import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.proposal.detail');
import { OnInit, OnDestroy, AfterViewChecked, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";
import mermaid from 'mermaid';
import showdown from 'showdown';

@Component({
    selector: 'wiz-page-proposal-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.proposal.detail/view.scss */
@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  overflow: hidden;
  background: #fafafa;
  --ink: #0a0a0a;
  --sub: #525252;
  --muted: #a3a3a3;
  --line: #e5e5e5;
  --line-soft: #f5f5f5;
  --surface: #fff;
  --surface-hover: #fafafa;
  --accent: #2563eb;
  --accent-hover: #1d4ed8;
  --accent-bg: rgba(37, 99, 235, 0.04);
  --accent-light: #3b82f6;
  --dark: #0a0a0a;
  --dark-hover: #171717;
  --danger: #dc2626;
  --success: #16a34a;
  --success-bg: rgba(22, 163, 74, 0.04);
  --radius: 12px;
  --radius-sm: 10px;
  --radius-xs: 8px;
  --shadow-xs: 0 1px 2px rgba(0,0,0,0.03);
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02);
  --shadow-md: 0 4px 6px -1px rgba(0,0,0,0.04), 0 2px 4px -2px rgba(0,0,0,0.03);
  --shadow-lg: 0 10px 15px -3px rgba(0,0,0,0.04), 0 4px 6px -4px rgba(0,0,0,0.02);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.review-dashboard,
.pending-panel,
.quality-panel,
.requirement-panel,
.toc-jump-panel {
  margin: 0 0 14px;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
}

.pending-panel {
  border-color: rgba(37, 99, 235, 0.18);
  background: linear-gradient(180deg, rgba(37, 99, 235, 0.035), #fff 72px);
}

.pending-panel.empty {
  border-color: var(--line);
  background: var(--surface);
}

.review-score-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.review-score-main {
  display: flex;
  align-items: baseline;
  gap: 5px;
  color: var(--sub);
}
.review-score-main span {
  font-size: 11px;
  font-weight: 600;
}
.review-score-main strong {
  font-size: 26px;
  line-height: 1;
  color: var(--ink);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}
.review-score-main small {
  font-size: 11px;
  color: var(--muted);
}

.review-score-state {
  flex: 1;
  min-width: 0;
  padding-left: 8px;
}
.review-score-state b {
  display: block;
  font-size: 12px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.review-score-state span {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-score-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.review-mini {
  min-width: 0;
  padding: 8px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
}
.review-mini span {
  display: block;
  font-size: 10px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.review-mini b {
  display: block;
  margin-top: 3px;
  font-size: 13px;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}

.review-score-reasons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 9px;
  padding-top: 9px;
  border-top: 1px solid var(--line);
}

.review-reason {
  display: flex;
  align-items: baseline;
  gap: 7px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--sub);
}
.review-reason i {
  color: var(--accent);
  flex-shrink: 0;
}

.pending-change {
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: #fafafa;
}
.pending-change + .pending-change {
  margin-top: 8px;
}

.pending-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}
.pending-head b {
  display: block;
  font-size: 12px;
  color: var(--ink);
}
.pending-head span {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: var(--muted);
}

.pending-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.pending-empty {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  color: var(--muted);
}
.pending-empty b {
  display: block;
  font-size: 12px;
  color: var(--sub);
}
.pending-empty span {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.45;
}

.pending-diff {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
}

.pending-diff-col {
  min-width: 0;
  max-height: 130px;
  overflow: auto;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: #fff;
}
.pending-diff-col span {
  display: block;
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 700;
  color: var(--muted);
}
.pending-diff-col.after {
  border-color: rgba(37, 99, 235, 0.24);
  background: rgba(37, 99, 235, 0.03);
}

.quality-issues {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.quality-issues.empty {
  flex-direction: row;
  align-items: center;
  color: var(--success);
  font-size: 12px;
  padding: 8px 0 0;
}

.quality-issue {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: #fff;
  color: var(--sub);
}
.quality-issue b {
  display: block;
  font-size: 12px;
  color: var(--ink);
}
.quality-issue span {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--sub);
}
.quality-issue.high {
  border-color: #fecaca;
  background: #fff7f7;
  color: #dc2626;
}
.quality-issue.medium {
  border-color: #e7e5e4;
  background: #fffdf9;
  color: #a16207;
}
.quality-issue.low {
  border-color: #e5e5e5;
  background: #fafafa;
  color: var(--sub);
}

.req-filter-row {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}

.req-filter {
  height: 26px;
  padding: 0 9px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #fff;
  color: var(--sub);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.req-filter.active {
  border-color: var(--ink);
  color: var(--ink);
  background: var(--line-soft);
}
.req-filter.danger.active {
  border-color: #dc2626;
  color: #dc2626;
  background: #fff7f7;
}
.req-filter.warn.active {
  border-color: #d6d3d1;
  color: #854d0e;
  background: #fffdf9;
}
.req-filter.ok.active {
  border-color: #d4d4d4;
  color: var(--sub);
  background: #fafafa;
}

.req-table {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow: auto;
}

.req-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) 42px 54px;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: #fff;
  cursor: pointer;
}
.req-row.covered {
  border-left: 3px solid #d4d4d4;
}
.req-row.weak {
  border-left: 3px solid #d6d3d1;
}
.req-row.missing {
  border-left: 3px solid #dc2626;
}

.req-id {
  font-size: 11px;
  font-weight: 800;
  color: var(--ink);
  word-break: break-all;
}

.req-main {
  min-width: 0;
}
.req-main b {
  display: block;
  font-size: 11px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.req-main span {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.req-status {
  justify-self: end;
  font-size: 10px;
  font-weight: 700;
  color: var(--sub);
}

.req-row.missing .req-status {
  color: #dc2626;
}

.req-row.weak .req-status {
  color: #854d0e;
}

.req-action {
  justify-self: end;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 24px;
  padding: 0 7px;
  border-radius: 999px;
  border: 1px solid rgba(37, 99, 235, 0.18);
  background: rgba(37, 99, 235, 0.04);
  color: var(--accent);
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.req-action:hover {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.toc-jump-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 220px;
  overflow: auto;
}

.toc-jump {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 12px;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 8px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: #fff;
  cursor: pointer;
  text-align: left;
}
.toc-jump span {
  font-size: 10px;
  font-weight: 800;
  color: var(--muted);
}
.toc-jump b {
  min-width: 0;
  font-size: 11px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.toc-jump.done span {
  color: var(--success);
}

.chat-approval-toggle {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  color: var(--ink);
  font-size: 12px;
  font-weight: 600;
}
.chat-approval-toggle input {
  margin-top: 2px;
  accent-color: var(--accent);
}
.chat-approval-toggle small {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.35;
}

/* ── Header ── */
.page-header {
  max-width: 1080px;
  margin: 0 auto;
  width: 100%;
  padding: 20px 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}

.page-header.result-mode {
  max-width: 100%;
  margin: 0;
  padding: 0 20px;
  height: 52px;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
}

.project-tabs {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.project-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--sub);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.project-tab:hover {
  background: var(--line-soft);
  color: var(--ink);
}

.project-tab.is-active {
  border-color: rgba(37, 99, 235, 0.16);
  background: var(--accent-bg);
  color: var(--accent);
}

.project-tab i {
  font-size: 11px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.header-stats {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 14px;
  background: var(--line-soft);
  border-radius: 999px;
}

.header-stat-item {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.header-stat-num {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}

.header-stat-slash {
  font-size: 11px;
  font-weight: 500;
  color: var(--muted);
}

.header-stat-label {
  font-size: 10px;
  font-weight: 500;
  color: var(--muted);
  margin-left: 1px;
}

.header-stat-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #d4d4d4;
}

.header-action-sep {
  width: 1px;
  height: 20px;
  background: var(--line);
  margin: 0 4px;
}

.header-btn-export {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 16px;
  border-radius: var(--radius-xs);
  font-size: 12px;
  font-weight: 600;
  border: 0;
  background: var(--accent);
  color: #fff;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.header-btn-export:hover {
  background: var(--accent-hover);
}

.back-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-xs);
  background: transparent;
  border: 1px solid var(--line);
  color: var(--muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.back-btn:hover {
  color: var(--ink);
  border-color: #d4d4d4;
  background: var(--surface);
}

.page-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.page-sub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

/* ── Flow Strip ── */
.flow-strip {
  max-width: 1080px;
  margin: 0 auto;
  width: 100%;
  padding: 16px 24px 0;
  flex-shrink: 0;
}

.flow-strip-inner {
  display: flex;
  align-items: stretch;
  gap: 0;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow-xs);
}

.flow-step {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--surface);
  transition: all 0.2s;
  position: relative;
  border-right: 1px solid var(--line);
}
.flow-step:last-child {
  border-right: none;
}

.flow-step.active {
  background: var(--line-soft);
}

.flow-step.done {
  background: var(--surface);
}

.flow-connector {
  display: none;
}

.flow-step-num {
  width: 28px;
  min-width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--line-soft);
  color: var(--muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  transition: all 0.2s;
  flex-shrink: 0;
}

.flow-step.active .flow-step-num {
  background: var(--accent);
  color: #fff;
}

.flow-step.done .flow-step-num {
  background: #dcfce7;
  color: var(--success);
}

.flow-step-copy {
  min-width: 0;
}

.flow-step-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}

.flow-step-title {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.flow-step-desc {
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--muted);
}

/* ── Document Strip ── */
.doc-strip {
  max-width: 1080px;
  margin: 0 auto;
  width: 100%;
  padding: 10px 24px 0;
  flex-shrink: 0;
}

.doc-strip-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  background: var(--surface);
  border: 1px solid var(--line);
}

.doc-strip-icon {
  width: 30px;
  height: 30px;
  border-radius: var(--radius-xs);
  background: #fef2f2;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.doc-strip-copy {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.doc-strip-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
}

.doc-strip-count {
  font-size: 11px;
  color: var(--muted);
}

.doc-strip-items {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
}

.doc-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--line-soft);
  border: none;
}

.doc-chip-name {
  font-size: 11px;
  font-weight: 500;
  color: var(--ink);
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-chip-size {
  font-size: 10px;
  color: var(--muted);
}

.doc-chip-badge {
  font-size: 9px;
  font-weight: 600;
  color: var(--muted);
  background: #e5e5e5;
  padding: 2px 6px;
  border-radius: 4px;
}

.doc-chip-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  border: 0;
  color: var(--muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.doc-chip-btn:hover {
  background: #e5e5e5;
  color: var(--ink);
}

/* ── Buttons ── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 32px;
  padding: 0 12px;
  border-radius: var(--radius-xs);
  font-size: 12px;
  font-weight: 500;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--sub);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.btn:hover {
  border-color: #d4d4d4;
  color: var(--ink);
  background: var(--surface-hover);
}

.btn.sm {
  height: 28px;
  padding: 0 10px;
  font-size: 11px;
}

.btn.ghost {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: var(--muted);
}

.btn.ghost:hover {
  background: var(--line-soft);
  color: var(--ink);
  border-color: transparent;
}

.btn.ghost.active {
  background: var(--dark);
  color: #fff;
  border-color: var(--dark);
}

.btn.primary {
  background: var(--dark);
  color: #fff;
  border-color: var(--dark);
}

.btn.primary:hover {
  background: var(--dark-hover);
}

.btn.accent {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.btn.accent:hover {
  background: var(--accent-hover);
}

.btn.danger {
  color: var(--danger);
  border-color: #fecaca;
  background: #fef2f2;
}

.btn.danger:hover {
  background: #fee2e2;
}

.btn[disabled] {
  opacity: 0.35;
  cursor: not-allowed;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: var(--line-soft);
  color: var(--sub);
}

.badge.sm {
  height: 18px;
  font-size: 10px;
  padding: 0 6px;
}

.badge.success {
  background: #f0fdf4;
  color: var(--success);
}

.badge.muted {
  background: var(--line-soft);
  color: var(--muted);
}

.badge.active {
  background: var(--accent);
  color: #fff;
}

.icon-btn-sm {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: transparent;
  color: var(--muted);
  border: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.icon-btn-sm:hover {
  background: var(--line-soft);
  color: var(--ink);
}

/* ── Loading ── */
.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  color: var(--muted);
  font-size: 13px;
  gap: 14px;
}

.loading-spinner {
  color: var(--muted);
}

/* ═══════ SETUP V2 (compact 2-col, no hero) ═══════ */
.setup-v2 {
  max-width: 1280px;
  margin: 0 auto;
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.info-bar-main {
  min-width: 0;
  flex: 1;
}

.info-bar-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  color: var(--accent);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.info-bar-dot {
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #d4d4d4;
}

.info-bar-eyebrow > span:not(.info-bar-dot):nth-child(3) {
  color: var(--muted);
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}

.info-bar-title {
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.info-bar-meta {
  margin-top: 4px;
  font-size: 12px;
  color: var(--muted);
  line-height: 1.5;
}

.info-bar-docs {
  flex-shrink: 0;
  max-width: 50%;
  min-width: 0;
}

.info-bar-docs-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: var(--sub);
}

.info-bar-docs-chips {
  margin-top: 6px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.rfp-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--line-soft);
  border: 0;
  font-size: 11px;
  color: var(--sub);
  cursor: pointer;
  transition: all 0.15s;
  max-width: 180px;
}

.rfp-chip:hover:not([disabled]) {
  background: var(--accent-bg);
  color: var(--accent);
}

.rfp-chip[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.rfp-chip-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.setup-v2-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 16px;
  align-items: start;
}

@media (max-width: 1023px) {
  .setup-v2-grid {
    grid-template-columns: 1fr;
  }
}
.setup-v2-main, .setup-v2-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.setup-v2-side {
  position: sticky;
  top: 16px;
}

.panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow-xs);
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
  border-bottom: 1px solid transparent;
}

.panel-head:hover {
  background: var(--surface-hover);
}

.panel-head-static {
  cursor: default;
}

.panel-head-static:hover {
  background: transparent;
}

.panel-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.panel-head-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.panel-head-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--muted);
  text-decoration: none;
  transition: color 0.15s;
}

.panel-head-link:hover {
  color: var(--blue);
}

.panel-toggle {
  width: 24px;
  height: 24px;
  border-radius: var(--radius-xs);
  border: 0;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.panel-toggle:hover {
  background: var(--line-soft);
  color: var(--ink);
}

.panel-body {
  padding: 14px 16px 16px;
  border-top: 1px solid var(--line-soft);
}

.panel-body-collapsed {
  padding: 0 16px 12px;
}

.summary-snippet {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
  color: var(--muted);
  line-height: 1.5;
}

/* Asset library tabs */
.lib-tabs {
  display: flex;
  gap: 0;
  padding: 0 10px;
  border-top: 1px solid var(--line-soft);
  border-bottom: 1px solid var(--line);
  background: var(--surface-hover);
  overflow-x: auto;
}

.lib-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 38px;
  padding: 0 14px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.lib-tab:hover {
  color: var(--ink);
}

.lib-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
  background: var(--surface);
  font-weight: 600;
}

.lib-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.lib-body {
  padding: 14px 16px;
  min-height: 200px;
  max-height: 480px;
  overflow-y: auto;
}

.lib-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--muted);
  padding: 20px 0;
}

.lib-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 36px 16px;
  font-size: 13px;
  color: var(--muted);
}
.lib-empty a {
  color: var(--blue);
  text-decoration: none;
  font-size: 12px;
}
.lib-empty a:hover {
  text-decoration: underline;
}

.lib-grid {
  gap: 8px;
}

.lib-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
}
.lib-card input[type=radio], .lib-card input[type=checkbox] {
  margin-top: 2px;
  width: 15px;
  height: 15px;
  accent-color: var(--accent);
  flex-shrink: 0;
  cursor: pointer;
}

.lib-card:hover {
  border-color: #d4d4d4;
  background: var(--surface-hover);
}

.lib-card-active {
  border-color: var(--accent) !important;
  background: var(--accent-bg) !important;
}

.lib-card-body {
  min-width: 0;
  flex: 1;
}

.lib-card-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.lib-card-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.lib-card-meta {
  font-size: 12px;
  color: var(--muted);
}

.lib-card-desc {
  margin-top: 3px;
  font-size: 12px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lib-tag {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
}

.tag-blue {
  background: #eff6ff;
  color: #1d4ed8;
}

.tag-emerald {
  background: #f0fdf4;
  color: #15803d;
}

.tag-indigo {
  background: #eef2ff;
  color: #4338ca;
}

.lib-image-grid {
  gap: 8px;
}

.lib-image-cell {
  position: relative;
  border: 2px solid var(--line);
  border-radius: var(--radius-xs);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.15s;
  background: var(--surface);
}

.lib-image-cell:hover {
  border-color: #d4d4d4;
}

.lib-image-active {
  border-color: var(--accent) !important;
}

.lib-image-thumb {
  aspect-ratio: 1;
  background: var(--line-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.lib-image-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lib-image-check {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lib-image-name {
  padding: 4px 6px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upload-label-compact {
  height: 40px;
  border-style: dashed;
}

/* Inline asset upload */
.lib-upload-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: var(--radius-xs);
  background: var(--accent-bg);
  color: var(--accent);
  border: 1px dashed #d4d4d4;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.lib-upload-trigger:hover {
  background: var(--accent);
  color: #fff;
  border-style: solid;
}

.lib-upload-form {
  margin-bottom: 12px;
  border: 1px solid #d4d4d4;
  border-radius: var(--radius);
  background: var(--line-soft);
  overflow: hidden;
}

.lib-upload-form-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.6);
  border-bottom: 1px solid #d4d4d4;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.lib-upload-close {
  width: 22px;
  height: 22px;
  border: 0;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
  border-radius: var(--radius-xs);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lib-upload-close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--ink);
}

.lib-upload-form-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.lib-upload-form-body textarea.form-input {
  resize: vertical;
  min-height: 36px;
  font-family: inherit;
}

/* ═══════ /SETUP V2 ═══════ */
.setup-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: var(--surface);
  margin-bottom: 16px;
  box-shadow: var(--shadow-xs);
}

.setup-hero-copy {
  flex: 1;
  min-width: 0;
}

.setup-hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--sub);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.setup-hero-title {
  margin-top: 12px;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.025em;
}

.text-gradient {
  background: linear-gradient(135deg, #2563eb, #6366f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.setup-hero-desc {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--muted);
  max-width: 560px;
}

.setup-hero-stats {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.hero-stat {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  background: var(--line-soft);
  border: 1px solid var(--line);
}

.hero-stat-icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-xs);
  background: var(--accent-bg);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hero-stat-body {
  min-width: 0;
}

.hero-stat-num {
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}

.hero-stat-label {
  margin-top: 1px;
  font-size: 11px;
  color: var(--muted);
}

.setup-grid {
  display: grid;
  grid-template-columns: 1fr minmax(300px, 380px);
  gap: 16px;
  align-items: start;
}

@media (max-width: 900px) {
  .setup-grid {
    grid-template-columns: 1fr;
  }
}
.setup-main, .setup-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}

/* FN-0020: 자산 라이브러리 선택 가시성 향상 */
.card-asset-library label {
  user-select: none;
}
.card-asset-library label:hover {
  background: rgba(37, 99, 235, 0.03) !important;
}
.card-asset-library input[type=radio], .card-asset-library input[type=checkbox] {
  cursor: pointer;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* Cards */
.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 20px;
  box-shadow: var(--shadow-xs);
  transition: box-shadow 0.15s;
}

.card:hover {
  box-shadow: var(--shadow-sm);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.card-icon {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  color: var(--sub);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.01em;
}

.card-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

.card-header .card-label {
  margin-bottom: 0;
}

.card-header .card-label-row {
  margin-bottom: 0;
}

.card-count {
  font-size: 11px;
  color: var(--muted);
  font-weight: 500;
}

.summary-preview {
  font-size: 13px;
  line-height: 1.7;
  color: var(--sub);
  white-space: pre-wrap;
  max-height: 200px;
  overflow: auto;
  padding: 12px 14px;
  background: var(--line-soft);
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
}

.summary-empty {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--muted);
  padding: 12px 14px;
  background: var(--line-soft);
  border-radius: var(--radius-xs);
  border: 1px dashed var(--line);
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  border: 1px solid var(--line);
}

.info-key {
  font-size: 11px;
  color: var(--muted);
  font-weight: 600;
  letter-spacing: 0.01em;
}

.info-val {
  font-size: 13px;
  color: var(--ink);
  font-weight: 500;
}

.form-group {
  margin-bottom: 12px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--sub);
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: var(--surface);
  font-size: 13px;
  color: var(--ink);
  outline: none;
  font-family: inherit;
  transition: all 0.15s;
}

.form-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
}

.form-input.addon {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  flex: 1 1 auto;
  min-width: 0;
}

.form-row {
  display: flex;
  gap: 12px;
}

.input-addon {
  display: flex;
  align-items: stretch;
  width: 100%;
}

.addon-text {
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 0 var(--radius-xs) var(--radius-xs) 0;
  border: 1px solid var(--line);
  background: var(--line-soft);
  font-size: 12px;
  color: var(--muted);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.model-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mode-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.mode-choice {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  column-gap: 8px;
  row-gap: 2px;
  min-height: 64px;
  padding: 10px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--sub);
  text-align: left;
  cursor: pointer;
  transition: all 0.15s;
}
.mode-choice i {
  grid-row: 1/span 2;
  margin-top: 2px;
  color: var(--muted);
}
.mode-choice span {
  color: var(--ink);
  font-size: 12px;
  font-weight: 800;
}
.mode-choice small {
  color: var(--muted);
  font-size: 10px;
  line-height: 1.35;
}

.mode-choice:hover {
  border-color: #cbd5e1;
}

.mode-choice.active {
  border-color: #0f172a;
  background: #f8fafc;
  box-shadow: inset 0 0 0 1px #0f172a;
}
.mode-choice.active i {
  color: #0f172a;
}

.autonomous-note-body p {
  margin: 0 0 8px;
  color: var(--sub);
  font-size: 12px;
  line-height: 1.45;
}
.autonomous-note-body ul {
  margin: 0;
  padding-left: 16px;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.55;
}

.chip {
  height: 32px;
  padding: 0 14px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: var(--surface);
  font-size: 12px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.15s;
}

.chip:hover {
  border-color: #d4d4d4;
  color: var(--ink);
}

.chip.active {
  background: var(--dark);
  color: #fff;
  border-color: var(--dark);
}

.chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.field-hint {
  margin-top: 6px;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.4;
}

.guide-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  padding: 3px;
  margin-bottom: 10px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
}

.guide-tabs button {
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.guide-tabs button.active {
  background: var(--surface);
  color: var(--ink);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.guide-list, .style-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.guide-item {
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  cursor: pointer;
  transition: all 0.15s;
  background: var(--surface);
}

.guide-item:hover, .guide-item.active {
  border-color: #d4d4d4;
  background: var(--line-soft);
}

.guide-item input {
  width: 15px;
  height: 15px;
  accent-color: var(--accent);
  margin-top: 1px;
}

.guide-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.guide-meta {
  font-size: 11px;
  color: var(--muted);
  margin-top: 2px;
}

.style-option {
  display: grid;
  grid-template-columns: 36px 1fr 16px;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 58px;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--line);
  background: var(--surface);
  text-align: left;
  cursor: pointer;
  transition: all 0.15s;
}

.style-option:hover, .style-option.active {
  border-color: #d4d4d4;
  background: var(--line-soft);
}

.style-swatch {
  display: flex;
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 7px;
  border: 1px solid var(--line);
}

.style-swatch span {
  flex: 1;
}

.style-copy {
  min-width: 0;
}

.style-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
}

.style-meta {
  margin-top: 2px;
  font-size: 11px;
  color: var(--muted);
}

.style-check {
  color: var(--accent);
  font-size: 11px;
}

.card-flow {
  background: var(--surface);
}

.flow-note-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.flow-note-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.flow-note-num {
  width: 24px;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-bg);
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
}

.flow-note-copy {
  min-width: 0;
}

.flow-note-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.flow-note-desc {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--muted);
}

.card-generation {
  padding: 14px;
}
.card-generation .card-header {
  margin-bottom: 12px;
}

.card-harness-preview {
  padding: 14px;
  background: var(--surface);
  border-color: var(--line-soft);
}
.card-harness-preview .card-header {
  margin-bottom: 10px;
}

.harness-compact {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.harness-compact span {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  color: var(--sub);
  font-size: 10px;
  font-weight: 600;
}

.harness-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.harness-debug {
  border-top: 1px solid var(--line-soft);
  margin-top: 2px;
  padding-top: 10px;
}
.harness-debug summary {
  cursor: pointer;
  color: var(--muted);
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 8px;
}

.harness-preview-loading,
.harness-preview-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  font-size: 11px;
  line-height: 1.5;
}

.harness-preview-loading {
  background: var(--surface-hover);
  border: 1px solid var(--line-soft);
  color: var(--muted);
}

.harness-preview-error {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #c2410c;
}

.harness-preview-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.harness-preview-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.harness-preview-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}

.harness-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.harness-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--sub);
  font-size: 10px;
  font-weight: 600;
}

.harness-chip.soft {
  background: #f5f3ff;
  color: #6d28d9;
}

.harness-chip.accent {
  background: var(--accent-bg);
  color: var(--accent);
}

.harness-chip.accent.subtle {
  background: #eff6ff;
  color: #1d4ed8;
}

.harness-preview-empty,
.harness-preview-sample {
  font-size: 11px;
  line-height: 1.5;
  color: var(--sub);
}

.harness-preview-empty {
  color: var(--muted);
}

.harness-preview-pre {
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  background: #0f172a;
  color: #dbeafe;
  border: 1px solid rgba(15, 23, 42, 0.12);
  font-size: 10px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 180px;
  overflow: auto;
  font-family: "JetBrains Mono", "Fira Code", monospace;
}

/* Reference slots */
.reference-slot-note {
  font-size: 12px;
  line-height: 1.6;
  color: var(--sub);
}

.reference-slot-extensions {
  margin-top: 6px;
  font-size: 11px;
  color: var(--muted);
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  background: var(--line-soft);
  border-radius: var(--radius-xs);
}

.reference-slot-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.reference-slot-card {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 12px 14px;
  background: var(--surface);
  transition: all 0.15s;
}
.reference-slot-card.has-files {
  border-color: #bbf7d0;
  background: #fafff9;
}
.reference-slot-card.empty-marked {
  border-color: var(--line);
  background: var(--line-soft);
  opacity: 0.6;
}

.reference-slot-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.reference-slot-copy {
  min-width: 0;
}

.reference-slot-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.reference-slot-desc {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.5;
  color: var(--muted);
}

.reference-slot-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.reference-upload-label {
  flex: 1;
}

.reference-legacy {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.reference-legacy-label {
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
}

/* Assets */
.asset-compact {
  margin-top: 10px;
}

.asset-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 0;
}

.asset-row + .asset-row {
  border-top: 1px solid var(--line-soft);
}

.asset-row-info {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.asset-thumb {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  border: 1px solid var(--line);
  object-fit: cover;
  background: #fff;
  flex-shrink: 0;
}

.asset-name {
  font-size: 12px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-size {
  font-size: 11px;
  color: var(--muted);
  flex-shrink: 0;
}

/* Softer proposal generation controls */
:host {
  --accent: #0f766e;
  --accent-hover: #0b5f59;
  --accent-bg: rgba(15, 118, 110, 0.05);
  --accent-light: #14b8a6;
}

.setup-side .card {
  padding: 16px;
  border-color: #e5e7eb;
  box-shadow: var(--shadow-xs);
}

.setup-side .card:hover {
  box-shadow: var(--shadow-xs);
}

.setup-side .card-header {
  gap: 8px;
  margin-bottom: 12px;
}

.setup-side .card-icon {
  width: 24px;
  height: 24px;
  border-radius: 7px;
}

.setup-side .card-label {
  font-size: 12px;
  font-weight: 600;
}

.setup-side .card-count {
  font-size: 10.5px;
  font-weight: 500;
}

.setup-side .form-label {
  font-size: 11.5px;
  font-weight: 500;
}

.setup-side .form-input {
  height: 34px;
  padding: 0 10px;
  font-size: 12px;
}

.setup-side .form-input:focus {
  border-color: #99f6e4;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

.setup-side .addon-text {
  font-size: 11px;
  font-weight: 500;
}

.setup-side .chip {
  height: 30px;
  padding: 0 11px;
  font-size: 11.5px;
  font-weight: 500;
}

.setup-side .chip.active {
  background: var(--accent-bg);
  color: var(--accent);
  border-color: #99f6e4;
}

.setup-side .guide-tabs button {
  height: 28px;
  font-size: 11.5px;
  font-weight: 500;
}

.setup-side .guide-tabs button.active {
  color: var(--accent);
}

.setup-side .guide-item {
  padding: 9px 10px;
}

.setup-side .guide-name,
.setup-side .style-name {
  font-size: 12px;
  font-weight: 550;
}

.setup-side .style-option {
  min-height: 52px;
  padding: 9px 10px;
}

.setup-side .style-option.active,
.setup-side .guide-item.active {
  border-color: #99f6e4;
  background: #ecfdf5;
}

.card-generation {
  border-color: #d9f5ee;
  background: linear-gradient(180deg, #ffffff 0%, #fbfffd 100%);
}

.card-generation .card-header {
  margin-bottom: 10px;
}

.gen-start-btn {
  gap: 11px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #0f766e;
  border: 1px solid #0f766e;
  box-shadow: none;
  transition: background 0.16s, border-color 0.16s;
}

.gen-start-btn:hover {
  background: #0b5f59;
  border-color: #0b5f59;
  transform: none;
  box-shadow: none;
}

.gen-btn-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.14);
}

.gen-btn-icon i {
  font-size: 14px !important;
}

.gen-btn-title {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
}

.gen-btn-sub {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
  opacity: 0.72;
}

/* Generate button */
.gen-start-btn {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px 20px;
  border-radius: var(--radius);
  background: var(--accent);
  color: #fff;
  border: 0;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.gen-start-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.gen-start-btn[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.gen-btn-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gen-btn-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.gen-btn-sub {
  font-size: 12px;
  opacity: 0.6;
  margin-top: 2px;
}

.empty-hint {
  padding: 32px 20px;
  text-align: center;
  font-size: 13px;
  color: var(--muted);
  border: 1px dashed var(--line);
  border-radius: var(--radius);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.empty-hint-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--line-soft);
  color: #d4d4d4;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.empty-hint-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--sub);
}

.empty-hint-desc {
  font-size: 12px;
  color: var(--muted);
}

/* ═══════ GENERATING ═══════ */
.gen-workbench {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 18px 24px 34px;
}

.gen-command,
.gen-progress-console,
.gen-stage-panel,
.gen-queue-panel,
.gen-log-console {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: var(--shadow-xs);
}

.gen-command {
  min-height: 112px;
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.gen-command-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.gen-run-indicator {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: var(--accent);
}

.gen-command-copy {
  min-width: 0;
}
.gen-command-copy h2 {
  margin: 3px 0 5px;
  color: var(--ink);
  font-size: 22px;
  line-height: 1.25;
  font-weight: 800;
  letter-spacing: 0;
}
.gen-command-copy p {
  margin: 0;
  color: var(--sub);
  font-size: 13px;
  line-height: 1.55;
}

.gen-kicker {
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.07em;
}

.gen-command-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.gen-mini-pill {
  height: 32px;
  padding: 0 11px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--sub);
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}

.gen-mini-pill i {
  color: var(--accent);
}

.gen-stop-btn {
  height: 36px;
  padding: 0 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fff7f7;
  color: var(--danger);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.12s;
  white-space: nowrap;
}

.gen-stop-btn:hover {
  background: #fef2f2;
  border-color: #fca5a5;
}

.gen-progress-console {
  margin-top: 12px;
  padding: 14px 16px 16px;
}

.gen-progress-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.gen-progress-top span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 750;
}
.gen-progress-top strong {
  color: var(--ink);
  font-size: 22px;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.gen-progress-track {
  height: 10px;
  border-radius: 999px;
  background: #eeeeee;
  overflow: hidden;
}

.gen-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--accent);
  transition: width 0.35s ease;
}

.gen-stat-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.gen-stat {
  min-width: 0;
  padding: 9px 10px;
  border-radius: 8px;
  background: var(--line-soft);
  border: 1px solid transparent;
}
.gen-stat span {
  display: block;
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
}
.gen-stat strong {
  display: block;
  margin-top: 3px;
  color: var(--ink);
  font-size: 14px;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gen-stat.warn {
  background: #fff7ed;
  border-color: #fed7aa;
}
.gen-stat.warn strong {
  color: #c2410c;
}

.gen-layout {
  margin-top: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  grid-template-areas: "stage log" "queue log";
  gap: 12px;
  align-items: stretch;
}

.gen-stage-panel {
  grid-area: stage;
  padding: 16px;
}

.gen-queue-panel {
  grid-area: queue;
  min-width: 0;
  overflow: hidden;
}

.gen-log-console {
  grid-area: log;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gen-panel-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--line);
}

.gen-stage-panel > .gen-panel-title-row {
  padding: 0 0 13px;
}

.gen-panel-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  color: var(--ink);
  font-size: 13px;
  font-weight: 850;
}

.gen-panel-title i {
  color: var(--accent);
  flex-shrink: 0;
}

.gen-panel-count {
  height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--sub);
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.gen-active-section {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  grid-template-areas: "no copy" "no meta";
  gap: 10px 14px;
  padding: 16px;
  border-radius: 8px;
  background: #f8fbff;
  border: 1px solid #dbeafe;
}

.gen-active-section.empty {
  background: var(--line-soft);
  border-color: var(--line);
}

.gen-active-no {
  grid-area: no;
  width: 58px;
  height: 58px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: #fff;
  font-size: 18px;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.gen-active-section.empty .gen-active-no {
  background: var(--surface);
  color: var(--muted);
  border: 1px solid var(--line);
}

.gen-active-copy {
  grid-area: copy;
  min-width: 0;
}
.gen-active-copy h3 {
  margin: 1px 0 5px;
  color: var(--ink);
  font-size: 18px;
  line-height: 1.35;
  font-weight: 850;
  letter-spacing: 0;
}
.gen-active-copy p {
  margin: 0;
  color: var(--sub);
  font-size: 13px;
  line-height: 1.55;
}

.gen-active-meta {
  grid-area: meta;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gen-active-meta span {
  height: 26px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--surface);
  border: 1px solid var(--line);
  color: var(--sub);
  font-size: 11px;
  font-weight: 750;
}

.gen-phase-strip {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.gen-phase-step {
  min-width: 0;
  height: 42px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  border-radius: 8px;
  background: var(--line-soft);
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.gen-phase-step i {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--surface);
  color: inherit;
  flex-shrink: 0;
}

.gen-phase-step.active {
  background: #eff6ff;
  color: var(--accent);
}

.gen-phase-step.done {
  background: #f0fdf4;
  color: var(--success);
}

.gen-queue-list {
  max-height: 450px;
  overflow: auto;
  padding: 8px;
}

.gen-queue-row {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  padding: 9px 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: background 0.12s, border-color 0.12s;
}

.gen-queue-row + .gen-queue-row {
  margin-top: 3px;
}

.gen-queue-row.active {
  background: #f8fbff;
  border-color: #bfdbfe;
}

.gen-queue-row.done {
  background: #f0fdf4;
}

.gen-queue-row.error {
  background: #fef2f2;
}

.gen-queue-marker {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--line-soft);
  color: var(--muted);
  font-size: 10px;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.gen-queue-row.active .gen-queue-marker {
  background: var(--accent);
  color: #fff;
}

.gen-queue-row.done .gen-queue-marker {
  background: #bbf7d0;
  color: var(--success);
}

.gen-queue-row.error .gen-queue-marker {
  background: #fecaca;
  color: var(--danger);
}

.gen-queue-copy {
  min-width: 0;
}
.gen-queue-copy strong {
  display: block;
  color: var(--ink);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gen-queue-copy span {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gen-queue-status {
  height: 24px;
  min-width: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--muted);
  font-size: 10px;
  font-weight: 850;
  white-space: nowrap;
}

.gen-queue-row.active .gen-queue-status {
  background: #dbeafe;
  color: var(--accent);
}

.gen-queue-row.done .gen-queue-status {
  background: #dcfce7;
  color: var(--success);
}

.gen-queue-row.error .gen-queue-status {
  background: #fee2e2;
  color: var(--danger);
}

.gen-queue-empty,
.gen-log-empty {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--muted);
  font-size: 12px;
}

.gen-log-list {
  min-height: 0;
  max-height: 628px;
  overflow: auto;
  padding: 8px;
}

.gen-log-item {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}

.gen-log-item + .gen-log-item {
  margin-top: 3px;
}

.gen-log-item.done {
  background: #f0fdf4;
}

.gen-log-item.error {
  background: #fef2f2;
}

.gen-log-item.active {
  background: #f8fbff;
  border-color: #bfdbfe;
}

.gen-log-time {
  padding-top: 2px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
}

.gen-log-body {
  min-width: 0;
}

.gen-log-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: var(--ink);
  font-size: 12px;
  font-weight: 850;
}

.gen-log-title i {
  color: var(--accent);
  flex-shrink: 0;
}

.gen-log-item.done .gen-log-title i {
  color: var(--success);
}

.gen-log-item.error .gen-log-title i {
  color: var(--danger);
}

.gen-log-title span {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gen-log-detail {
  margin-top: 4px;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.5;
  word-break: break-word;
}

/* ═══════ RESULT ═══════ */
.scroll-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.setup-scroll,
.generation-scroll {
  background: #f8fafc;
}

.generation-scroll {
  display: flex;
  flex-direction: column;
}

.generation-scroll .gen-workbench {
  box-sizing: border-box;
  flex: 1 0 auto;
}

.result-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.result-view {
  flex: 1;
  min-height: 0;
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow: hidden;
}

/* Result Grid */
.result-grid {
  display: grid;
  grid-template-columns: 1fr 400px;
  grid-template-rows: minmax(0, 1fr);
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.result-wrapper.codex-only .result-grid {
  grid-template-columns: minmax(0, 1fr);
}

.result-wrapper.codex-only .result-right {
  width: min(1120px, 100%);
  margin: 0 auto;
}

.result-left {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
  min-height: 0;
  box-shadow: var(--shadow-sm);
  position: relative;
}

.preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 10px;
  border-bottom: 1px solid var(--line);
  background: var(--surface);
  flex-shrink: 0;
  min-height: 40px;
}

.preview-toolbar-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.preview-tab-btns {
  display: flex;
  align-items: center;
  gap: 1px;
  background: var(--line-soft);
  border-radius: 6px;
  padding: 2px;
}

.preview-tab-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.12s ease;
}
.preview-tab-btn:hover {
  color: var(--sub);
}
.preview-tab-btn.active {
  background: var(--surface);
  color: var(--ink);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  font-weight: 600;
}

.preview-toolbar-right {
  display: flex;
  align-items: center;
  gap: 3px;
}

.preview-frame {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: 0;
}

.preview-page-nav {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: rgba(10, 10, 10, 0.85);
  color: #fff;
  border-radius: 999px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 10;
  font-size: 12px;
  user-select: none;
  backdrop-filter: blur(12px);
}
.preview-page-nav .nav-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: #fff;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.15s;
}
.preview-page-nav .nav-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.15);
}
.preview-page-nav .nav-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.preview-page-nav .nav-pos {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 60px;
  justify-content: center;
}
.preview-page-nav .nav-input {
  width: 36px;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 2px 2px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
.preview-page-nav .nav-input::-webkit-inner-spin-button,
.preview-page-nav .nav-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.preview-page-nav .nav-total {
  color: rgba(255, 255, 255, 0.7);
  font-variant-numeric: tabular-nums;
}

.preview-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--muted);
  font-size: 13px;
}

/* Edit Mode */
.edit-mode-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
}
.edit-mode-label i {
  color: var(--accent);
}

.edit-frame {
  flex: 1;
  width: 100%;
  border: none;
  min-height: 0;
}

.result-right {
  display: flex;
  flex-direction: column;
  background: #fbfbfa;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
  min-height: 0;
  box-shadow: var(--shadow-sm);
}

/* Tabs */
.result-panel-head {
  flex-shrink: 0;
  padding: 14px 14px 12px;
  border-bottom: 1px solid var(--line);
  background: var(--surface);
}

.result-panel-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.result-panel-title strong {
  color: var(--ink);
  font-size: 14px;
  font-weight: 750;
  letter-spacing: 0;
}

.result-panel-kicker {
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.result-tabs {
  display: flex;
  gap: 3px;
  padding: 3px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--line-soft);
  flex-shrink: 0;
}

.tab-btn {
  flex: 1;
  height: 30px;
  font-size: 12px;
  font-weight: 650;
  color: var(--muted);
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.tab-btn:hover {
  color: var(--sub);
  background: rgba(255, 255, 255, 0.55);
}

.tab-btn.active {
  color: var(--ink);
  background: var(--surface);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  font-weight: 750;
}

.tab-btn.has-pending:not(.active) {
  color: var(--accent);
}

.tab-badge {
  min-width: 16px;
  height: 16px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.result-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

/* ── Tab content wrappers ── */
.tab-content-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.tab-content-chat {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chat-scroll-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-bottom: 10px;
}

/* ── Overview Quick Grid ── */
.ov-quick-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 16px;
}

.ov-quick-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  transition: all 0.15s;
}

.ov-quick-card:hover {
  border-color: #d4d4d4;
  background: var(--line-soft);
  transform: translateY(-1px);
}

.ov-quick-icon {
  width: 34px;
  height: 34px;
  border-radius: var(--radius-xs);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ov-quick-icon.pdf {
  background: #fef2f2;
  color: #ef4444;
}
.ov-quick-icon.chat {
  background: var(--line-soft);
  color: var(--sub);
}
.ov-quick-icon.codex {
  background: #eef2ff;
  color: #334155;
}
.ov-quick-icon.edit {
  background: #fefce8;
  color: #ca8a04;
}
.ov-quick-icon.download {
  background: #f0fdf4;
  color: var(--success);
}

.ov-quick-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--sub);
}

/* Section header */
.ov-section-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--line);
}

.ov-section-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
}

.ov-section-sub {
  font-size: 11px;
  color: var(--muted);
}

/* Section overview rows */
.section-overview {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 16px;
}

.sec-item { /* wrapper for sec-row + inline AI edit */ }

.sec-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  border-radius: var(--radius-xs);
  transition: all 0.12s;
}
.sec-row:hover {
  background: var(--line-soft);
}
.sec-row:hover .row-actions {
  opacity: 1;
}
.sec-row.completed .sec-num.done {
  background: #dcfce7;
  color: var(--success);
}
.sec-row.active {
  background: var(--line-soft);
}
.sec-row.active .sec-name {
  color: var(--ink);
  font-weight: 600;
}
.sec-row.active .sec-num {
  background: var(--accent);
  color: #fff;
}
.sec-row.active .sec-num.done {
  background: var(--accent);
  color: #fff;
}

.sec-row-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  cursor: pointer;
}
.sec-row-main:hover .sec-name {
  color: var(--ink);
}

.sec-num-wrap {
  flex-shrink: 0;
}

.sec-num {
  width: 22px;
  min-width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--line-soft);
  color: var(--sub);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  transition: all 0.15s;
}
.sec-num.done {
  background: #dcfce7;
  color: var(--success);
}

.sec-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sec-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--sub);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.12s;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.12s;
}

.text-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 26px;
  height: 26px;
  padding: 0;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: var(--muted);
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.12s;
}

.text-action:hover {
  background: var(--line);
  color: var(--ink);
}

.text-action.accent {
  background: var(--accent-bg);
  color: var(--accent);
  font-weight: 700;
}

.text-action.accent:hover {
  background: var(--accent);
  color: #fff;
}

/* AI edit */
.ai-edit-inline {
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 12px;
  background: var(--line-soft);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  animation: aiSlideDown 0.2s ease-out;
  overflow: hidden;
}

@keyframes aiSlideDown {
  from {
    opacity: 0;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  to {
    opacity: 1;
    max-height: 200px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
.ai-edit-card {
  margin-top: 10px;
  padding: 12px;
  background: var(--line-soft);
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
}

.ai-edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ai-edit-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
}

.ai-edit-input {
  width: 100%;
  min-height: 60px;
  max-height: 100px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
  outline: none;
  font-family: inherit;
  transition: border-color 0.15s;
  background: var(--surface);
}
.ai-edit-input:focus {
  border-color: var(--accent);
}

.ai-edit-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.ai-edit-error {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: var(--radius-xs);
  background: #fef2f2;
  border: 1px solid #fecaca;
  font-size: 12px;
  line-height: 1.5;
  color: var(--danger);
}

/* AI edit progress */
.ai-edit-progress {
  padding: 12px 0 4px;
}

.ai-edit-progress-bar {
  width: 100%;
  height: 3px;
  background: var(--line);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 10px;
}

.ai-edit-progress-bar-fill {
  height: 100%;
  width: 40%;
  background: var(--accent);
  border-radius: 2px;
  animation: aiProgressSlide 1.8s ease-in-out infinite;
}

@keyframes aiProgressSlide {
  0% {
    transform: translateX(-100%);
    width: 40%;
  }
  50% {
    transform: translateX(80%);
    width: 60%;
  }
  100% {
    transform: translateX(250%);
    width: 40%;
  }
}
.ai-edit-progress-phase {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--sub);
  font-weight: 500;
  animation: aiFadeIn 0.3s ease;
}

@keyframes aiFadeIn {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Section generating phase in overview */
.sec-gen-phase {
  display: block;
  font-size: 10px;
  color: var(--sub);
  font-weight: 400;
  margin-top: 2px;
  animation: aiFadeIn 0.3s ease;
}

.sec-num.gen {
  background: var(--line-soft);
  color: var(--sub);
}

.sec-row.generating {
  background: var(--line-soft);
}

/* Chat thinking indicator */
.chat-thinking {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.thinking-bubble {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.thinking-dots {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 4px 0;
}
.thinking-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
  opacity: 0.3;
  animation: thinkingBounce 1.4s ease-in-out infinite;
}
.thinking-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.thinking-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes thinkingBounce {
  0%, 80%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  40% {
    transform: scale(1.3);
    opacity: 0.8;
  }
}
.thinking-phase {
  font-size: 12px;
  color: var(--accent);
  font-weight: 500;
  animation: aiFadeIn 0.3s ease;
}

.chat-hint-phase {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--accent);
  font-weight: 500;
}

/* Chat */
.quick-prompts {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 12px;
}

.quick-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--surface);
  border: 1px solid var(--line);
  font-size: 11px;
  color: var(--sub);
  cursor: pointer;
  transition: all 0.12s;
}

.quick-btn:hover {
  border-color: #d4d4d4;
  color: var(--ink);
  background: var(--line-soft);
}

.quick-btn[disabled] {
  opacity: 0.35;
  cursor: not-allowed;
}

.chat-thread {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 12px;
}

.chat-context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--line-soft);
  margin-bottom: 12px;
}

.chat-context-copy {
  min-width: 0;
}

.chat-context-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}

.chat-context-title {
  margin-top: 3px;
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
}

.chat-msg {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  max-width: 100%;
}

.chat-msg.mine {
  flex-direction: row-reverse;
}
.chat-msg.mine .chat-bubble-wrap {
  align-items: flex-end;
}
.chat-msg.mine .chat-role {
  text-align: right;
}

.chat-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--line-soft);
  color: var(--sub);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  border: 1px solid var(--line);
}

.chat-msg.mine .chat-avatar {
  background: var(--accent);
  color: #fff;
  border-color: transparent;
}

.chat-bubble-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.chat-role {
  font-size: 10px;
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 4px;
  letter-spacing: 0.01em;
}

.chat-msg.mine .chat-role {
  color: var(--sub);
}

.chat-bubble {
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: var(--surface);
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
  max-width: 92%;
}

.chat-msg.mine .chat-bubble {
  background: var(--line-soft);
  color: var(--ink);
  border-color: var(--line);
  border-bottom-right-radius: 4px;
}

.chat-msg:not(.mine) .chat-bubble {
  border-bottom-left-radius: 4px;
}

.chat-msg.error .chat-bubble {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.chat-form {
  flex-shrink: 0;
}

.chat-input-wrap {
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: var(--surface);
  overflow: hidden;
  transition: border-color 0.15s;
}
.chat-input-wrap:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
}

.chat-input {
  width: 100%;
  min-height: 64px;
  padding: 12px 14px 8px;
  border: 0;
  background: transparent;
  font-size: 13px;
  color: var(--ink);
  outline: none;
  resize: none;
  font-family: inherit;
}

.chat-input-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 10px 6px;
}

.chat-hint {
  font-size: 11px;
  color: var(--muted);
}

.codex-mini-pipeline {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin: 10px 0;
}

.codex-mini-stage {
  min-width: 0;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--surface);
}
.codex-mini-stage span {
  display: block;
  color: var(--accent);
  font-size: 10px;
  font-weight: 800;
  line-height: 1.1;
}
.codex-mini-stage b {
  display: block;
  margin-top: 4px;
  color: var(--ink);
  font-size: 12px;
  line-height: 1.25;
  word-break: keep-all;
}
.codex-mini-stage small {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: 10px;
}

/* Real Codex */
.tab-content-codex {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.codex-usage-card {
  flex-shrink: 0;
  padding: 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: #ffffff;
}

.codex-usage-card.warn {
  border-color: #fbbf24;
  background: #fffbeb;
}

.codex-usage-card.danger {
  border-color: #f87171;
  background: #fef2f2;
}

.codex-usage-top,
.codex-usage-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.codex-usage-top {
  align-items: flex-start;
}
.codex-usage-top b {
  display: block;
  color: var(--ink);
  font-size: 12px;
  font-weight: 850;
}
.codex-usage-top span {
  display: block;
  margin-top: 3px;
  color: var(--sub);
  font-size: 11px;
  line-height: 1.35;
}

.codex-usage-value {
  text-align: right;
  white-space: nowrap;
}
.codex-usage-value strong {
  display: block;
  color: var(--ink);
  font-size: 18px;
  font-weight: 850;
  line-height: 1;
}
.codex-usage-value small {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 10px;
}

.codex-usage-bar {
  height: 8px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: #e5e7eb;
}

.codex-usage-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #0ea5e9, #14b8a6);
  transition: width 0.2s ease;
}

.codex-usage-card.warn .codex-usage-fill {
  background: #f59e0b;
}

.codex-usage-card.danger .codex-usage-fill {
  background: #dc2626;
}

.codex-usage-foot {
  margin-top: 8px;
  color: var(--muted);
  font-size: 11px;
}

.codex-status-card {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--surface);
}

.codex-status-card.ready {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.codex-status-card.blocked {
  border-color: #fecaca;
  background: #fef2f2;
}

.codex-status-main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}
.codex-status-main i {
  margin-top: 3px;
  color: var(--sub);
}
.codex-status-main b {
  display: block;
  font-size: 12px;
  color: var(--ink);
  margin-bottom: 3px;
}
.codex-status-main span {
  display: block;
  font-size: 11px;
  color: var(--sub);
  line-height: 1.45;
  word-break: break-word;
}
.codex-status-main small {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: var(--muted);
}

.codex-status-card.ready .codex-status-main i {
  color: var(--success);
}

.codex-status-card.blocked .codex-status-main i {
  color: var(--danger);
}

.codex-status-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.codex-workflow-card {
  flex-shrink: 0;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
}

.codex-workflow-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.codex-workflow-head b {
  display: block;
  color: var(--ink);
  font-size: 12px;
  font-weight: 850;
}
.codex-workflow-head span {
  display: block;
  margin-top: 3px;
  color: var(--sub);
  font-size: 11px;
  line-height: 1.35;
}

.codex-workflow-meter {
  display: flex;
  align-items: baseline;
  gap: 3px;
  color: var(--muted);
  white-space: nowrap;
}
.codex-workflow-meter strong {
  color: var(--accent);
  font-size: 20px;
  line-height: 1;
}
.codex-workflow-meter span {
  font-size: 11px;
}

.codex-workflow-bar {
  height: 6px;
  margin: 10px 0;
  overflow: hidden;
  border-radius: 999px;
  background: var(--line-soft);
}

.codex-workflow-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--accent);
  transition: width 0.2s ease;
}

.codex-stage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(118px, 1fr));
  gap: 6px;
}

.codex-stage-btn {
  min-width: 0;
  min-height: 92px;
  padding: 9px;
  text-align: left;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, box-shadow 0.12s;
  position: relative;
  overflow: hidden;
}

.codex-stage-btn:hover,
.codex-stage-btn.active {
  border-color: var(--accent);
  background: #f8fafc;
}

.codex-stage-btn.active {
  box-shadow: inset 3px 0 0 var(--accent);
}

.codex-stage-btn.done {
  border-color: #bbf7d0;
}

.codex-stage-btn.running {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.codex-stage-btn.error {
  border-color: #fecaca;
  background: #fef2f2;
}

.codex-stage-btn:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.codex-stage-btn:disabled:hover {
  border-color: var(--line);
  background: #ffffff;
}

.codex-stage-num {
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}

.codex-stage-icon {
  margin-top: 8px;
  color: var(--accent);
  font-size: 13px;
}

.codex-stage-copy {
  margin-top: 6px;
}
.codex-stage-copy b {
  display: block;
  color: var(--ink);
  font-size: 12px;
  line-height: 1.25;
  word-break: keep-all;
}
.codex-stage-copy span {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 10px;
  line-height: 1.3;
  word-break: keep-all;
}

.codex-stage-state {
  position: absolute;
  top: 8px;
  right: 8px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 700;
}

.codex-stage-btn.done .codex-stage-state {
  color: var(--success);
}

.codex-stage-btn.running .codex-stage-state {
  color: #1d4ed8;
}

.codex-stage-btn.error .codex-stage-state {
  color: var(--danger);
}

.codex-stage-brief {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--line-soft);
  min-width: 0;
}
.codex-stage-brief > div:nth-child(2) {
  flex: 1;
  min-width: 0;
}
.codex-stage-brief b {
  display: block;
  color: var(--ink);
  font-size: 12px;
  line-height: 1.3;
}
.codex-stage-brief span {
  display: block;
  margin-top: 2px;
  color: var(--sub);
  font-size: 11px;
  line-height: 1.4;
  word-break: keep-all;
}

.codex-stage-brief-icon {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  color: var(--accent);
  flex-shrink: 0;
}

.codex-shell {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(150px, 0.34fr) minmax(0, 0.66fr);
  gap: 10px;
}

.codex-history,
.codex-detail {
  min-height: 0;
  overflow-y: auto;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
}

.codex-history {
  padding: 10px;
}

.codex-detail {
  padding: 12px;
}

.codex-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.codex-panel-head b {
  font-size: 12px;
  color: var(--ink);
}
.codex-panel-head span {
  font-size: 11px;
  color: var(--muted);
}

.codex-empty,
.codex-detail-empty,
.codex-log-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 58px;
  color: var(--muted);
  font-size: 12px;
}

.codex-job {
  width: 100%;
  text-align: left;
  display: block;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--surface);
  cursor: pointer;
  margin-bottom: 6px;
  transition: all 0.12s;
}

.codex-job:hover,
.codex-job.active {
  border-color: #cbd5e1;
  background: var(--line-soft);
}

.codex-job.running {
  border-color: #bfdbfe;
}

.codex-job.error {
  border-color: #fecaca;
}

.codex-job-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 5px;
}
.codex-job-top strong {
  font-size: 10px;
  color: var(--accent);
}
.codex-job-top span {
  font-size: 10px;
  color: var(--muted);
}

.codex-job-title {
  font-size: 12px;
  line-height: 1.45;
  color: var(--ink);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.codex-job-stage,
.codex-detail-stage {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  margin-bottom: 5px;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--line-soft);
  color: var(--sub);
  font-size: 10px;
  font-weight: 700;
}

.codex-job-meta {
  margin-top: 5px;
  font-size: 10px;
  color: var(--muted);
  word-break: break-all;
}

.codex-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 10px;
}
.codex-detail-head h4 {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink);
}

.codex-detail-kicker {
  font-size: 10px;
  color: var(--muted);
  word-break: break-all;
}

.codex-detail-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.codex-running {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 10px;
  border-radius: var(--radius-xs);
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}

.codex-section-title {
  font-size: 11px;
  font-weight: 750;
  color: var(--ink);
  margin: 12px 0 7px;
}

.codex-harness {
  margin-bottom: 10px;
}

.codex-harness-strip {
  padding: 10px 12px;
  border: 1px solid #bbf7d0;
  border-radius: var(--radius-xs);
  background: #f0fdf4;
}

.codex-harness-strip.warning {
  border-color: #fde68a;
  background: #fffbeb;
}

.codex-harness-strip.blocked {
  border-color: #fecaca;
  background: #fef2f2;
}

.codex-harness-main {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #047857;
}
.codex-harness-main i {
  margin-top: 4px;
  flex-shrink: 0;
}
.codex-harness-main b {
  display: block;
  color: var(--ink);
  font-size: 12px;
  line-height: 1.35;
}
.codex-harness-main span {
  display: block;
  margin-top: 2px;
  color: var(--sub);
  font-size: 11px;
  line-height: 1.45;
  word-break: keep-all;
}

.codex-harness-strip.warning .codex-harness-main {
  color: #b45309;
}

.codex-harness-strip.blocked .codex-harness-main {
  color: #b91c1c;
}

.codex-harness-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.codex-harness-chip {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: var(--sub);
  font-size: 10px;
  font-weight: 750;
}

.codex-harness-debug {
  margin-top: 7px;
  color: var(--muted);
  font-size: 11px;
}
.codex-harness-debug summary {
  cursor: pointer;
  font-weight: 750;
}

.codex-harness-check {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid var(--line-soft);
}
.codex-harness-check b {
  color: var(--ink);
  font-size: 10px;
}
.codex-harness-check span {
  color: var(--sub);
  line-height: 1.4;
  word-break: keep-all;
}

.codex-final {
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--line-soft);
  margin-bottom: 10px;
}

.codex-log {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.codex-log-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid var(--line-soft);
}
.codex-log-line i {
  margin-top: 4px;
  font-size: 8px;
  color: var(--muted);
  width: 12px;
}
.codex-log-line b {
  display: block;
  font-size: 11px;
  color: var(--ink);
  margin-bottom: 2px;
}
.codex-log-line span {
  display: block;
  font-size: 12px;
  line-height: 1.55;
  color: var(--sub);
  white-space: pre-wrap;
  word-break: break-word;
}

.codex-form {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.codex-form-stage {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 7px 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--line-soft);
}
.codex-form-stage span {
  color: var(--muted);
  font-size: 11px;
  font-weight: 700;
}
.codex-form-stage b {
  color: var(--ink);
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
}
.codex-form-stage small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--sub);
  font-size: 11px;
}

.codex-context-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.codex-context-row label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--sub);
  font-weight: 600;
}

.codex-model-row input,
.codex-extra-input,
.codex-input {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: var(--radius-xs);
  background: var(--surface);
  color: var(--ink);
  outline: none;
  font-family: inherit;
}
.codex-model-row input:focus,
.codex-extra-input:focus,
.codex-input:focus {
  border-color: var(--accent);
}

.codex-model-row input {
  height: 32px;
  padding: 0 10px;
  font-size: 12px;
}

.codex-extra-input {
  min-height: 46px;
  max-height: 90px;
  padding: 9px 10px;
  resize: vertical;
  font-size: 12px;
  line-height: 1.45;
}

.codex-upload-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.codex-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.codex-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: var(--line-soft);
  color: var(--sub);
  font-size: 11px;
  cursor: pointer;
  max-width: 170px;
}
.codex-file-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.codex-input-wrap {
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: var(--surface);
  overflow: hidden;
}
.codex-input-wrap:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
}

.codex-input {
  min-height: 72px;
  padding: 12px 14px 8px;
  border: 0;
  resize: vertical;
  font-size: 13px;
  line-height: 1.55;
}

.codex-input-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px 10px 7px;
}

/* Section edit */
.section-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.section-card {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 12px 14px;
  background: var(--surface);
  transition: all 0.12s;
}
.section-card:hover {
  border-color: #d4d4d4;
}
.section-card.generating {
  border-color: #e5e5e5;
  background: var(--line-soft);
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.section-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  font-size: 13px;
  color: var(--ink);
  outline: none;
  resize: vertical;
  font-family: inherit;
  transition: all 0.15s;
}

.section-textarea:focus {
  border-color: var(--accent);
}

.section-preview {
  max-height: 200px;
  overflow: auto;
}

.section-empty {
  display: flex;
  min-height: 160px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #d4d4d4;
  border-radius: var(--radius-sm);
  background: #fafafa;
  color: var(--muted);
  font-size: 12px;
  text-align: center;
}

/* ── Section pill navigation ── */
.section-edit-tab {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-edit-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 2px 0;
}

.section-edit-eyebrow {
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
}

.section-edit-heading {
  margin-top: 2px;
  color: var(--ink);
  font-size: 16px;
  font-weight: 750;
}

.section-edit-progress {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  height: 26px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
  color: var(--ink);
  font-size: 12px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
}
.section-edit-progress small {
  color: var(--muted);
  font-size: 10px;
  font-weight: 650;
}

.section-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
  flex-shrink: 0;
  scrollbar-width: none;
}
.section-nav::-webkit-scrollbar {
  display: none;
}

.section-edit-tab .section-nav {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(32px, 1fr));
  gap: 6px;
  padding: 10px;
  margin-bottom: 0;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: var(--surface);
  max-height: 146px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.section-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--sub);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.12s;
  flex-shrink: 0;
}
.section-pill:hover {
  border-color: #d4d4d4;
  background: var(--line-soft);
}
.section-pill.active {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}
.section-pill.done:not(.active) {
  background: #f0fdf4;
  color: var(--success);
  border-color: #bbf7d0;
}
.section-pill.error:not(.active) {
  background: #fef2f2;
  color: var(--danger);
  border-color: #fecaca;
}

.section-edit-tab .section-pill {
  width: 100%;
  min-width: 0;
  height: 32px;
  border-radius: 8px;
  background: #fbfbfb;
}

.section-edit-tab .section-pill.active {
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.16);
}

.section-detail-card {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 16px;
  background: var(--surface);
  box-shadow: var(--shadow-xs);
  transition: all 0.12s;
}
.section-detail-card.generating {
  border-color: #e5e5e5;
  background: var(--line-soft);
}

.section-detail-card .section-preview {
  max-height: none;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.section-detail-card .section-head {
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.section-title-block {
  min-width: 0;
}

.section-detail-card .section-title {
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: 1.35;
}

.section-detail-card .section-title > span:last-child {
  min-width: 0;
}

.section-detail-card .section-title .sec-num.error {
  background: #fef2f2;
  color: var(--danger);
}

.section-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 600;
}
.section-meta-row span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.section-meta-row span + span::before {
  content: "";
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #d4d4d4;
}

.section-detail-card .section-actions {
  gap: 6px;
}

.section-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  color: var(--sub);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.12s;
}

.section-action-btn:hover {
  border-color: #d4d4d4;
  background: var(--line-soft);
  color: var(--ink);
}

.section-action-btn.accent {
  border-color: rgba(37, 99, 235, 0.14);
  background: var(--accent-bg);
  color: var(--accent);
}

.section-action-btn.accent:hover {
  border-color: var(--accent);
  background: var(--accent);
  color: #fff;
}

.section-editor-box {
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.section-editor-label {
  margin-bottom: 8px;
  color: var(--sub);
  font-size: 12px;
  font-weight: 700;
}

.section-editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}

.section-detail-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.section-nav-pos {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

/* ── Rendered markdown ── */
:host ::ng-deep .proposal-rendered h1,
:host ::ng-deep .proposal-rendered h2,
:host ::ng-deep .proposal-rendered h3,
:host ::ng-deep .proposal-rendered h4 {
  color: var(--ink);
  font-weight: 700;
  line-height: 1.4;
  margin: 0.7em 0 0.25em;
}

:host ::ng-deep .proposal-rendered h1 {
  font-size: 16px;
}

:host ::ng-deep .proposal-rendered h2 {
  font-size: 14px;
}

:host ::ng-deep .proposal-rendered .mermaid {
  margin: 0.8em 0;
  padding: 12px;
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: var(--line-soft);
  overflow-x: auto;
}

:host ::ng-deep .proposal-rendered .mermaid svg {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

:host ::ng-deep .proposal-rendered .mermaid.is-error {
  font-size: 12px;
  line-height: 1.5;
  color: var(--danger);
  border-color: #fecaca;
  background: #fef2f2;
  white-space: pre-wrap;
}

:host ::ng-deep .proposal-rendered h3 {
  font-size: 12px;
}

:host ::ng-deep .proposal-rendered p,
:host ::ng-deep .proposal-rendered li,
:host ::ng-deep .proposal-rendered blockquote {
  font-size: 13px;
  line-height: 1.65;
  color: var(--sub);
}

:host ::ng-deep .proposal-rendered ul,
:host ::ng-deep .proposal-rendered ol {
  padding-left: 16px;
  margin: 0.3em 0;
}

:host ::ng-deep .proposal-rendered blockquote {
  border-left: 3px solid var(--line);
  padding-left: 12px;
  color: var(--muted);
  margin: 0.4em 0;
}

:host ::ng-deep .proposal-rendered pre {
  overflow: auto;
  background: var(--line-soft);
  border-radius: var(--radius-xs);
  padding: 10px 12px;
  border: 1px solid var(--line);
}

:host ::ng-deep .proposal-rendered code {
  font-size: 12px;
}

:host ::ng-deep .proposal-rendered table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.5em 0;
}

:host ::ng-deep .proposal-rendered th,
:host ::ng-deep .proposal-rendered td {
  border: 1px solid var(--line);
  padding: 6px 8px;
  font-size: 12px;
}

:host ::ng-deep .proposal-rendered th {
  background: var(--line-soft);
  font-weight: 700;
}

/* ── Responsive ── */
@media (max-width: 1280px) {
  .result-grid {
    grid-template-columns: 1fr;
  }
  .result-left {
    min-height: 500px;
  }
  .gen-layout {
    grid-template-columns: 1fr;
    grid-template-areas: "stage" "queue" "log";
  }
  .gen-log-list {
    max-height: 320px;
  }
  .page-header.result-mode {
    height: auto;
    padding: 8px 16px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .header-stats {
    display: none;
  }
  .header-action-sep {
    display: none;
  }
}
@media (max-width: 900px) {
  .setup-hero {
    flex-direction: column;
  }
  .setup-hero-stats {
    flex-direction: row;
  }
  .setup-grid {
    grid-template-columns: 1fr;
  }
  .ov-quick-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 640px) {
  .flow-strip, .doc-strip, .page-header, .setup-view, .result-view, .gen-workbench {
    padding-left: 14px;
    padding-right: 14px;
  }
  .flow-strip-inner {
    flex-direction: column;
  }
  .flow-step {
    border-right: none;
    border-bottom: 1px solid var(--line);
  }
  .flow-step:last-child {
    border-bottom: none;
  }
  .setup-hero, .setup-hero-stats, .setup-grid {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .gen-workbench {
    padding-top: 16px;
    padding-bottom: 28px;
  }
  .gen-command {
    align-items: flex-start;
    flex-direction: column;
  }
  .gen-command-right {
    justify-content: flex-start;
  }
  .gen-active-section {
    grid-template-columns: 1fr;
    grid-template-areas: "no" "copy" "meta";
  }
  .gen-phase-strip {
    grid-template-columns: 1fr 1fr;
  }
  .gen-queue-row {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .gen-queue-status {
    display: none;
  }
  .gen-log-item {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .header-right, .row-actions, .section-actions {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .sec-row {
    align-items: flex-start;
  }
  .info-grid, .form-row {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .doc-strip-inner {
    flex-wrap: wrap;
  }
  .header-btn-export {
    width: 100%;
  }
  .ov-quick-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* Setup View wrapper */
.setup-view {
  max-width: none;
  margin: 0 auto;
  padding: 16px 20px 32px;
  width: 100%;
  overflow-x: hidden;
}

/* ── Asset Library Tabs ── */
.asset-tabs {
  display: flex;
  gap: 4px;
  padding: 0 12px;
  margin: 0 -20px;
  border-top: 1px solid var(--line-soft);
  border-bottom: 1px solid var(--line);
  background: var(--surface-hover);
  overflow-x: auto;
  scrollbar-width: none;
}

.asset-tabs::-webkit-scrollbar {
  display: none;
}

.asset-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 38px;
  padding: 0 16px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}

.asset-tab:hover {
  color: var(--ink);
}

.asset-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
  background: var(--surface);
  font-weight: 600;
}

.asset-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.asset-tab-panel {
  padding: 14px 0 4px;
  min-height: 60px;
}

/* ── Setup Info Bar (compact project info) ── */
.setup-info-bar {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 14px 20px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  margin-bottom: 16px;
  box-shadow: var(--shadow-xs);
  flex-wrap: wrap;
}

.setup-info-bar-item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.setup-info-bar-key {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.setup-info-bar-val {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.setup-info-bar-sep {
  width: 1px;
  height: 16px;
  background: var(--line);
  flex-shrink: 0;
}

/* ── Info Banner (compact project info) ── */
.info-banner {
  padding: 12px 18px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  margin-bottom: 16px;
  box-shadow: var(--shadow-xs);
}

.info-banner-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.info-tag {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  white-space: nowrap;
}

.info-tag-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  flex-shrink: 0;
}

.info-tag-val {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── RFP Summary card ── */
.card-rfp-summary .summary-preview {
  max-height: 140px;
}

/* ── Personnel Org Chart ── */
.pc-wrap {
  padding: 8px 0;
}

.pc-ceo {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
}

.pc-node {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--line);
  background: var(--surface);
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
}
.pc-node:hover {
  border-color: var(--accent);
  background: var(--accent-bg);
}
.pc-node.selected {
  border-color: var(--accent);
  background: var(--accent-bg);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);
}

.pc-node--ceo {
  padding: 8px 16px;
}
.pc-node--ceo .pc-name {
  font-size: 13px;
  font-weight: 600;
}
.pc-node--ceo .pc-pos {
  font-size: 11px;
  color: var(--muted);
}

.pc-node--leader {
  border-left: 2px solid var(--accent);
}

.pc-check {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid var(--line);
  font-size: 9px;
  color: transparent;
  flex-shrink: 0;
  transition: all 0.15s;
}
.selected > .pc-check {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.pc-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--ink);
  white-space: nowrap;
}

.pc-pos {
  font-size: 11px;
  color: var(--sub);
  white-space: nowrap;
}

.pc-resume {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
}
.pc-resume.has {
  background: #dbeafe;
  color: #1d4ed8;
}
.pc-resume.no {
  background: #f5f5f5;
  color: #a3a3a3;
}

.pc-section {
  margin-bottom: 12px;
}

.pc-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--sub);
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--line-soft);
}

.pc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
}

.pc-card {
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  overflow: hidden;
}

.pc-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: var(--surface-hover);
  border-bottom: 1px solid var(--line-soft);
}

.pc-card-team {
  font-size: 11px;
  font-weight: 600;
  color: var(--ink);
}

.pc-card-all {
  font-size: 10px;
  color: var(--accent);
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 3px;
}
.pc-card-all:hover {
  background: var(--accent-bg);
}

.pc-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
}

/* ── Image Card (redesigned) ── */
.img-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}

.img-card {
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.15s;
}
.img-card:hover {
  border-color: #d4d4d4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.img-card.selected {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}
.img-card.selected .img-card-preview {
  opacity: 1;
}
.img-card.selected .img-card-name {
  color: var(--accent);
  font-weight: 600;
}

.img-card-preview {
  position: relative;
  aspect-ratio: 4/3;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.img-card-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-card-check {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.img-card-info {
  padding: 8px 10px;
  border-top: 1px solid var(--line-soft);
}

.img-card-name {
  font-size: 11px;
  font-weight: 500;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.img-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.img-tag {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 3px;
  background: #ecfdf5;
  color: #0f766e;
  white-space: nowrap;
}

/* Proposal setup redesign final overrides */
:host {
  --accent: #0f766e;
  --accent-hover: #0b5f59;
  --accent-bg: rgba(15, 118, 110, 0.05);
  --accent-light: #14b8a6;
  --setup-accent: #0f766e;
  --setup-accent-hover: #0b5f59;
  --setup-blue: #2563eb;
  --setup-amber: #b7791f;
}

.page-header:not(.result-mode) {
  max-width: none;
  width: 100%;
  height: 64px;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid var(--line);
  background: #fff;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03);
}

.page-header:not(.result-mode) .header-left {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
}

.page-header:not(.result-mode) .page-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
}

.page-header:not(.result-mode) .page-sub {
  margin-top: 2px;
  font-size: 11px;
}

.flow-strip,
.doc-strip,
.setup-view {
  max-width: 1120px;
}

.flow-strip {
  padding: 12px 20px 0;
}

.flow-strip-inner,
.info-banner,
.card,
.reference-slot-card,
.pc-card,
.img-card {
  border-radius: 8px;
}

.flow-step {
  gap: 9px;
  padding: 10px 12px;
}

.flow-step-num {
  width: 26px;
  min-width: 26px;
  height: 26px;
}

.flow-step-label {
  font-size: 11px;
}

.flow-step-desc {
  font-size: 10.5px;
}

.doc-strip {
  padding: 8px 20px 0;
}

.setup-view {
  width: 100%;
  padding: 14px 20px 28px;
  overflow-x: hidden;
}

.info-banner {
  padding: 10px 14px;
  margin-bottom: 12px;
}

.info-banner-row {
  gap: 10px;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #fff;
  white-space: nowrap;
}

.info-tag-icon {
  color: var(--setup-blue);
  font-size: 10px;
  flex-shrink: 0;
}

.info-tag:nth-child(2) .info-tag-icon {
  color: var(--setup-accent);
}

.info-tag:nth-child(3) .info-tag-icon {
  color: var(--setup-amber);
}

.info-tag:nth-child(4) .info-tag-icon {
  color: #7c3aed;
}

.info-tag-label {
  font-size: 10.5px;
}

.info-tag-val {
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 600;
}

.setup-grid {
  display: grid;
  grid-template-columns: minmax(0, 650px) minmax(390px, 420px);
  gap: 18px;
  justify-content: center;
  align-items: start;
}

.setup-main,
.card-asset-library {
  width: 100%;
  max-width: 650px;
}

.setup-side {
  width: 100%;
  max-width: 420px;
  position: sticky;
  top: 12px;
}

.card {
  padding: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.card-header {
  margin-bottom: 12px;
}

.card-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #eff6ff;
  color: var(--setup-blue);
}

.card-asset-library .card-icon,
.card-reference-assets .card-icon {
  background: #ecfdf5;
  color: var(--setup-accent);
}

.card-generation .card-icon {
  background: #fef3c7;
  color: var(--setup-amber);
}

.asset-tabs {
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  margin: 0;
  overflow: visible;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f8fafc;
}

.asset-tab {
  flex: 1 1 calc(33.333% - 4px);
  justify-content: center;
  min-width: 82px;
  height: 30px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  font-size: 11px;
}

.asset-tab.active {
  border-bottom-color: transparent;
  background: #fff;
  color: var(--setup-blue);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.asset-tab-count {
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: var(--setup-accent);
  font-size: 9px;
}

.asset-tab-panel {
  min-height: 48px;
  padding: 10px 0 2px;
}

.card-asset-library .grid {
  grid-template-columns: minmax(0, 1fr) !important;
}

.card-asset-library label {
  border-radius: 7px !important;
}

.summary-preview {
  max-height: 118px;
  font-size: 12px;
  line-height: 1.62;
}

.reference-slot-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.reference-slot-card {
  padding: 10px;
}

.setup-side .model-chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
}

.setup-side .chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  height: 32px;
  gap: 5px;
  padding: 0 7px;
  border-radius: 7px;
  font-size: 10.5px;
  white-space: nowrap;
}

.setup-side .chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setup-side .chip i {
  flex-shrink: 0;
}

.setup-side .card-label {
  font-weight: 600;
}

.setup-side .form-label,
.setup-side .guide-tabs button {
  font-weight: 500;
}

.setup-side .form-input {
  height: 34px;
  font-size: 12px;
}

.setup-side .chip.active,
.setup-side .guide-item.active,
.setup-side .style-option.active {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: var(--setup-accent);
}

.proposal-company-line {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #f8fafc;
  color: var(--sub);
  font-size: 12px;
  font-weight: 600;
}

.proposal-company-line i {
  color: var(--setup-blue);
  flex-shrink: 0;
}

.proposal-company-line span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.guide-tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.card-generation {
  order: -1;
  border-color: #bfe8df;
  background: linear-gradient(180deg, #f8fffd 0%, #ffffff 100%);
}

.card-generation .card-header {
  margin-bottom: 10px;
}

.gen-start-btn {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 72px;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--setup-accent);
  border-radius: 8px;
  background: var(--setup-accent);
  color: #fff;
  text-align: left;
  box-shadow: none;
  transition: background 0.16s, border-color 0.16s, box-shadow 0.16s;
}

.gen-start-btn:hover {
  border-color: var(--setup-accent-hover);
  background: var(--setup-accent-hover);
  box-shadow: 0 6px 14px rgba(15, 118, 110, 0.16);
  transform: none;
}

.gen-start-btn:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.gen-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  color: var(--setup-accent);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.14);
}

.gen-btn-icon i {
  display: block;
  font-size: 16px !important;
  line-height: 1;
}

.gen-btn-title {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
}

.gen-btn-sub {
  max-height: 30px;
  margin-top: 3px;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.78);
  font-size: 10.5px;
  font-weight: 400;
  line-height: 1.35;
  opacity: 1;
}

@media (max-width: 1080px) {
  .setup-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .setup-main,
  .setup-side,
  .card-asset-library {
    max-width: none;
  }
  .setup-side {
    position: static;
  }
  .setup-side .model-chips {
    flex-wrap: wrap;
  }
}
@media (max-width: 640px) {
  .page-header:not(.result-mode) {
    height: auto;
    min-height: 60px;
    padding: 8px 14px;
  }
  .flow-strip,
  .doc-strip,
  .setup-view {
    padding-left: 14px;
    padding-right: 14px;
  }
  .info-tag {
    width: 100%;
    justify-content: flex-start;
  }
  .info-tag-val {
    max-width: none;
  }
  .asset-tab {
    flex-basis: calc(50% - 4px);
  }
  .setup-side .chip {
    flex-basis: calc(50% - 3px);
  }
}
/* Generating dashboard redesign final overrides */
.gen-workbench {
  max-width: 1180px;
  padding: 16px 20px 32px;
}

.gen-command,
.gen-progress-console,
.gen-stage-panel,
.gen-queue-panel,
.gen-log-console {
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.gen-command {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 286px;
  align-items: stretch;
  gap: 18px;
  min-height: 136px;
  padding: 18px;
}

.gen-command-left {
  align-items: flex-start;
  gap: 14px;
}

.gen-run-indicator {
  position: relative;
  width: 54px;
  height: 54px;
  border: 1px solid #bfe8df;
  border-radius: 8px;
  background: #ecfdf5;
  color: var(--setup-accent);
}

.gen-run-indicator::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(15, 118, 110, 0.18);
  border-radius: 10px;
  content: "";
  animation: genPulseFrame 1.8s ease-in-out infinite;
}

@keyframes genPulseFrame {
  0%, 100% {
    opacity: 0.28;
    transform: scale(0.98);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.03);
  }
}
.gen-command-copy h2 {
  max-width: 680px;
  margin: 2px 0 6px;
  font-size: 21px;
  line-height: 1.28;
  letter-spacing: 0;
}

.gen-command-copy p {
  max-width: 720px;
  font-size: 12.5px;
}

.gen-kicker {
  color: var(--setup-blue);
  letter-spacing: 0;
}

.gen-command-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.gen-mini-pill {
  height: 28px;
  padding: 0 9px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #f8fafc;
  font-size: 10.5px;
  font-weight: 700;
}

.gen-mini-pill i {
  color: var(--setup-blue);
}

.gen-mini-pill:nth-child(2) i {
  color: #7c3aed;
}

.gen-mini-pill:nth-child(3) i,
.gen-mini-pill:nth-child(4) i {
  color: var(--setup-accent);
}

.gen-command-right {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  align-content: start;
}

.gen-command-metric {
  min-width: 0;
  height: 58px;
  padding: 8px 9px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f8fafc;
}

.gen-command-metric span {
  display: block;
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
}

.gen-command-metric strong {
  display: block;
  margin-top: 4px;
  overflow: hidden;
  color: var(--ink);
  font-size: 14px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gen-command-metric.primary {
  border-color: var(--setup-accent);
  background: var(--setup-accent);
}

.gen-command-metric.primary span,
.gen-command-metric.primary strong {
  color: #fff;
}

.gen-stop-btn {
  grid-column: 1/-1;
  width: 100%;
  height: 36px;
  border-radius: 8px;
}

.gen-progress-console {
  display: grid;
  grid-template-columns: minmax(230px, 300px) minmax(0, 1fr);
  gap: 14px;
  align-items: center;
  margin-top: 12px;
  padding: 14px;
}

.gen-progress-main {
  min-width: 0;
}

.gen-progress-top {
  margin-bottom: 9px;
}

.gen-progress-top strong {
  color: var(--setup-accent);
  font-size: 24px;
}

.gen-progress-track {
  height: 9px;
  background: #e5e7eb;
}

.gen-progress-fill {
  background: linear-gradient(90deg, var(--setup-blue) 0%, var(--setup-accent) 100%);
}

.gen-stat-row {
  grid-template-columns: repeat(6, minmax(74px, 1fr));
  gap: 7px;
  margin-top: 0;
}

.gen-stat {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  grid-template-areas: "icon label" "icon value";
  align-items: center;
  min-height: 54px;
  padding: 8px;
  border: 1px solid transparent;
  background: #f8fafc;
}

.gen-stat i {
  grid-area: icon;
  color: var(--setup-blue);
}

.gen-stat span {
  grid-area: label;
  line-height: 1.1;
}

.gen-stat strong {
  grid-area: value;
  margin-top: 2px;
  font-size: 13px;
}

.gen-stat.warn i,
.gen-stat.warn strong {
  color: #c2410c;
}

.gen-layout {
  grid-template-columns: minmax(0, 1.08fr) minmax(340px, 0.92fr);
  grid-template-areas: "stage queue" "stage log";
  gap: 14px;
  margin-top: 14px;
  align-items: stretch;
}

.gen-stage-panel {
  display: flex;
  min-height: 520px;
  flex-direction: column;
  padding: 18px;
}

.gen-queue-panel,
.gen-log-console {
  min-height: 250px;
}

.gen-panel-title-row {
  padding: 13px 14px 11px;
}

.gen-stage-panel > .gen-panel-title-row {
  padding: 0 0 13px;
}

.gen-panel-title {
  font-size: 12.5px;
}

.gen-panel-title i {
  color: var(--setup-blue);
}

.gen-panel-count {
  height: 24px;
  background: #f8fafc;
}

.gen-active-section {
  grid-template-columns: 66px minmax(0, 1fr);
  gap: 12px 16px;
  margin-top: 14px;
  padding: 18px;
  border-color: #bfdbfe;
  background: #f8fbff;
}

.gen-active-section.empty {
  background: #f8fafc;
}

.gen-active-no {
  width: 66px;
  height: 66px;
  border-radius: 8px;
  background: var(--setup-blue);
  font-size: 20px;
}

.gen-active-kicker {
  margin-bottom: 4px;
  color: var(--setup-blue);
  font-size: 10px;
  font-weight: 850;
}

.gen-active-copy h3 {
  margin-bottom: 6px;
  font-size: 19px;
  letter-spacing: 0;
}

.gen-active-copy p {
  font-size: 12.5px;
}

.gen-active-meta span {
  height: 27px;
  background: #fff;
}

.gen-phase-strip {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: auto;
  padding-top: 14px;
}

.gen-phase-step {
  height: 48px;
  border: 1px solid var(--line);
  background: #f8fafc;
  font-size: 11px;
}

.gen-phase-step.active {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: var(--setup-blue);
}

.gen-phase-step.done {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.gen-queue-list {
  max-height: 284px;
  padding: 8px;
}

.gen-queue-row {
  grid-template-columns: 34px minmax(0, 1fr) 48px;
  padding: 8px;
}

.gen-queue-row.active {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.gen-queue-marker {
  border-radius: 7px;
}

.gen-queue-row.active .gen-queue-marker {
  background: var(--setup-blue);
}

.gen-log-list {
  max-height: 282px;
  padding: 8px;
}

.gen-log-item {
  grid-template-columns: 50px minmax(0, 1fr);
  padding: 8px;
}

.gen-log-item.active {
  border-color: #bfe8df;
  background: #ecfdf5;
}

.gen-log-title i {
  color: var(--setup-accent);
}

.gen-queue-empty,
.gen-log-empty {
  min-height: 180px;
}

@media (max-width: 1120px) {
  .gen-command {
    grid-template-columns: minmax(0, 1fr);
  }
  .gen-command-right {
    grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  }
  .gen-stop-btn {
    grid-column: auto;
  }
  .gen-progress-console {
    grid-template-columns: minmax(0, 1fr);
  }
  .gen-stat-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .gen-layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "stage" "queue" "log";
  }
  .gen-stage-panel {
    min-height: 0;
  }
}
@media (max-width: 640px) {
  .gen-command-left {
    flex-direction: column;
  }
  .gen-command-right,
  .gen-stat-row,
  .gen-phase-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .gen-stop-btn {
    grid-column: 1/-1;
  }
  .gen-active-section {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "no" "copy" "meta";
  }
}
/* Proposal-only image upload controls */
.card-reference-assets {
  overflow: hidden;
}

.card-reference-assets .reference-slot-list {
  gap: 8px;
}

.card-reference-assets .reference-slot-card {
  padding: 11px;
  border-radius: 8px;
}

.card-reference-assets .reference-slot-head {
  align-items: center;
  gap: 8px;
}

.card-reference-assets .reference-slot-copy {
  min-width: 0;
}

.card-reference-assets .reference-slot-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-reference-assets .reference-slot-desc {
  display: -webkit-box;
  margin-top: 3px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.reference-slot-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #f8fafc;
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.card-reference-assets .reference-slot-actions {
  display: grid;
  grid-template-columns: minmax(172px, 1fr) 84px;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
}

.card-reference-assets .reference-upload-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  min-width: 0;
  width: 100%;
  height: 34px;
  gap: 6px;
  padding: 0 12px;
  border: 1px dashed #99f6e4;
  border-radius: 8px;
  background: #ecfdf5;
  color: var(--setup-accent);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}

.card-reference-assets .reference-upload-label:hover {
  border-color: var(--setup-accent);
  background: var(--setup-accent);
  color: #fff;
}

.card-reference-assets .reference-upload-label i,
.card-reference-assets .reference-upload-text {
  flex-shrink: 0;
  white-space: nowrap;
}

.card-reference-assets .reference-empty-btn {
  width: 84px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
  white-space: nowrap;
}

.card-reference-assets .asset-row-info {
  min-width: 0;
}

.card-reference-assets .asset-name {
  min-width: 0;
}

@media (max-width: 520px) {
  .card-reference-assets .reference-slot-actions {
    grid-template-columns: minmax(0, 1fr);
  }
  .card-reference-assets .reference-empty-btn {
    width: 100%;
  }
}
/* Proposal setup asset library height guard */
.setup-scroll {
  min-height: 0;
  overflow-y: auto;
}

.setup-main {
  overflow: visible;
}

.card-asset-library {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(760px, 100dvh - 190px);
  overflow: hidden;
}

.card-asset-library > .card-header,
.card-asset-library > .asset-tabs {
  flex: 0 0 auto;
}

.card-asset-library > .asset-tab-panel {
  flex: 1 1 auto;
  min-height: 96px;
  max-height: clamp(220px, 100dvh - 338px, 520px);
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.card-asset-library > .asset-tab-panel::-webkit-scrollbar {
  width: 8px;
}

.card-asset-library > .asset-tab-panel::-webkit-scrollbar-thumb {
  border: 2px solid #fff;
  border-radius: 999px;
  background: #cbd5e1;
}

.card-asset-library .pc-wrap,
.card-asset-library .img-grid {
  min-height: 0;
}

@media (max-height: 720px) and (min-width: 1081px) {
  .card-asset-library {
    max-height: calc(100dvh - 150px);
  }
  .card-asset-library > .asset-tab-panel {
    max-height: clamp(180px, 100dvh - 308px, 360px);
  }
}
@media (max-width: 1080px) {
  .card-asset-library {
    max-height: none;
  }
  .card-asset-library > .asset-tab-panel {
    max-height: min(56dvh, 520px);
  }
}
/* Proposal workspace flat redesign */
:host {
  --proposal-primary: #185FA5;
  --proposal-blue-bg: #E6F1FB;
  --proposal-blue-border: #85B7EB;
  --proposal-blue-text: #0C447C;
  --proposal-green-bg: #EAF3DE;
  --proposal-green-text: #3B6D11;
  --proposal-green-border: #C0DD97;
  --proposal-amber-bg: #FAEEDA;
  --proposal-amber-text: #854F0B;
  --proposal-border: rgba(0, 0, 0, 0.15);
  --proposal-border-hover: rgba(0, 0, 0, 0.3);
  --proposal-muted: #8A8F98;
  --proposal-ink: #15171A;
  --proposal-surface: #FFFFFF;
  --accent: var(--proposal-primary);
  --accent-hover: #0C447C;
  --accent-bg: var(--proposal-blue-bg);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.proposal-workspace-topbar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 18px;
  min-height: 64px;
  padding: 0 28px;
  border-bottom: 0.5px solid var(--proposal-border);
  background: var(--proposal-surface);
  flex: 0 0 auto;
}

.workspace-topbar-left {
  display: flex;
  align-items: stretch;
  gap: 24px;
  min-width: 0;
}

.workspace-title-block {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 260px;
}

.workspace-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #fff;
  color: var(--proposal-muted);
  cursor: pointer;
}

.workspace-back-btn:hover {
  border-color: var(--proposal-border-hover);
  color: var(--proposal-ink);
}

.workspace-title-copy {
  min-width: 0;
}

.workspace-title {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workspace-subtitle {
  margin-top: 2px;
  overflow: hidden;
  color: var(--proposal-muted);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workspace-tabs {
  display: flex;
  align-items: stretch;
  gap: 18px;
}

.workspace-tab {
  display: inline-flex;
  align-items: center;
  height: 64px;
  padding: 0 2px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #4B5563;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.workspace-tab:hover {
  color: var(--proposal-blue-text);
}

.workspace-tab.is-active {
  border-bottom-color: var(--proposal-primary);
  color: var(--proposal-blue-text);
}

.workspace-steps {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.workspace-step {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  color: #737983;
  background: #F2F3F5;
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
}

.workspace-step i {
  font-size: 10px;
}

.workspace-step.complete {
  color: var(--proposal-green-text);
  background: var(--proposal-green-bg);
}

.workspace-step.current {
  color: var(--proposal-blue-text);
  background: var(--proposal-blue-bg);
  font-weight: 500;
}

.workspace-step.pending {
  color: #7A808A;
  background: #F1F2F4;
}

.proposal-setup-redesign {
  width: 100%;
  max-width: 1188px;
  padding: 12px 20px 28px;
  margin: 0 auto;
}

.proposal-setup-redesign .setup-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 16px;
  align-items: start;
  justify-content: stretch;
}

.proposal-setup-redesign .setup-main {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: none;
  overflow: visible;
}

.proposal-setup-redesign .setup-side {
  position: sticky;
  top: 12px;
  width: 280px;
  max-width: 280px;
  min-width: 280px;
}

.proposal-setup-redesign .workspace-section-card {
  display: block;
  width: 100%;
  padding: 0;
  overflow: visible;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: var(--proposal-surface);
  box-shadow: none;
}

.proposal-setup-redesign .workspace-section-card.card-asset-library {
  max-width: none;
  max-height: none;
}

.proposal-setup-redesign .workspace-section-card.is-action {
  border-color: var(--proposal-blue-border);
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 54px;
  padding: 13px 15px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 12px;
}

.section-icon.asset {
  color: #0B6B4F;
  background: #E9F8EF;
}

.section-icon.upload {
  color: var(--proposal-amber-text);
  background: var(--proposal-amber-bg);
}

.section-icon.diagram {
  color: var(--proposal-blue-text);
  background: var(--proposal-blue-bg);
}

.section-title-stack {
  min-width: 0;
}

.section-title {
  color: var(--proposal-ink);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
}

.section-subtitle {
  margin-top: 2px;
  overflow: hidden;
  color: var(--proposal-muted);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 42px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.section-badge.done {
  border: 0.5px solid var(--proposal-green-border);
  color: var(--proposal-green-text);
  background: var(--proposal-green-bg);
}

.section-badge.needed {
  color: var(--proposal-amber-text);
  background: var(--proposal-amber-bg);
}

.section-badge.recommended {
  border: 0.5px solid #E6C788;
  color: var(--proposal-amber-text);
  background: var(--proposal-amber-bg);
}

.section-badge.optional {
  border: 0.5px solid var(--proposal-border);
  color: #6B7280;
  background: #fff;
}

.section-card-body {
  padding: 13px 15px;
}

.asset-library-loading,
.asset-library-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 74px;
  color: var(--proposal-muted);
  font-size: 12px;
}

.asset-library-sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.asset-category-section {
  overflow: hidden;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #fff;
}

.asset-category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 9px 10px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  background: #F8FAFC;
}

.asset-category-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.asset-category-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #E9F8EF;
  color: #0B6B4F;
  font-size: 11px;
}

.asset-category-copy {
  min-width: 0;
}

.asset-category-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.asset-category-title {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-category-selected {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--proposal-blue-bg);
  color: var(--proposal-blue-text);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.asset-category-required {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--proposal-amber-bg);
  color: var(--proposal-amber-text);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.asset-category-desc {
  margin-top: 2px;
  overflow: hidden;
  color: var(--proposal-muted);
  font-size: 10.5px;
  font-weight: 400;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-category-meta {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 54px;
}

.asset-category-mode,
.asset-category-total {
  flex: 0 0 auto;
  color: var(--proposal-muted);
  font-size: 10.5px;
  font-weight: 500;
  white-space: nowrap;
}

.asset-category-mode {
  color: #5B6470;
}

.asset-category-grid {
  padding: 10px;
}

.asset-thumb-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.asset-thumb-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 8px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #F6F7F8;
  color: var(--proposal-ink);
  text-align: left;
  cursor: pointer;
}

.asset-thumb-card:hover {
  border-color: var(--proposal-border-hover);
}

.asset-thumb-card.selected {
  border-color: var(--proposal-primary);
  background: var(--proposal-blue-bg);
}

.asset-thumb-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
  border-radius: 6px;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  background: #ECEFF2;
  color: #98A1AE;
  font-size: 18px;
}

.asset-thumb-card.selected .asset-thumb-media {
  border-color: var(--proposal-blue-border);
  color: var(--proposal-primary);
  background: #F8FBFF;
}

.asset-category-section.is-compact .asset-category-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.asset-category-section.is-compact .asset-thumb-card {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  min-height: 60px;
  padding: 8px;
  background: #fff;
}

.asset-category-section.is-compact .asset-thumb-media {
  width: 42px;
  height: 42px;
  aspect-ratio: auto;
  border-radius: 8px;
  background: #F1F4F7;
  color: var(--proposal-primary);
  font-size: 15px;
}

.asset-category-section.is-compact .asset-thumb-card.selected .asset-thumb-media {
  background: #fff;
}

.asset-category-section.is-compact .asset-thumb-check {
  top: -5px;
  right: -5px;
  width: 17px;
  height: 17px;
  font-size: 8px;
}

.asset-category-section.is-compact .asset-thumb-info {
  padding-top: 0;
}

.asset-category-section.is-compact .asset-thumb-title {
  font-size: 12px;
  font-weight: 600;
}

.asset-category-section.is-compact .asset-thumb-meta {
  white-space: normal;
}

.asset-thumb-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-thumb-check {
  position: absolute;
  top: 6px;
  right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: var(--proposal-primary);
  color: #fff;
  font-size: 9px;
}

.asset-thumb-info {
  min-width: 0;
  padding-top: 7px;
}

.asset-thumb-title {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-thumb-meta {
  margin-top: 2px;
  overflow: hidden;
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-add-cell {
  border-style: dashed;
  background: #fff;
}

.asset-add-cell .asset-thumb-media {
  border-style: dashed;
  background: #fff;
  color: var(--proposal-primary);
}

.section-card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  color: var(--proposal-muted);
  font-size: 11px;
}

.section-link-btn {
  height: 26px;
  padding: 0 10px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 6px;
  background: #fff;
  color: var(--proposal-blue-text);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}

.section-link-btn:hover {
  border-color: var(--proposal-border-hover);
}

.upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 18px;
  border: 1.5px dashed var(--proposal-blue-border);
  border-radius: 8px;
  background: var(--proposal-blue-bg);
  text-align: center;
}

.upload-dropzone.uploading {
  opacity: 0.7;
}

.upload-drop-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: #fff;
  color: var(--proposal-primary);
  font-size: 24px;
}

.upload-drop-copy {
  margin-top: 10px;
}

.upload-drop-title {
  color: var(--proposal-blue-text);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
}

.upload-drop-text {
  margin-top: 4px;
  color: #5A7084;
  font-size: 11px;
  line-height: 1.45;
}

.upload-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 13px;
}

.upload-action-primary,
.upload-action-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.upload-action-primary {
  border: 0.5px solid var(--proposal-primary);
  background: var(--proposal-primary);
  color: #fff;
}

.upload-action-secondary {
  border: 0.5px solid var(--proposal-border);
  background: #fff;
  color: var(--proposal-blue-text);
}

.upload-action-secondary:hover {
  border-color: var(--proposal-border-hover);
}

.uploaded-inline-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.uploaded-inline-item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto 24px;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 4px 6px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 6px;
  background: #fff;
}

.uploaded-inline-item img,
.uploaded-inline-item > i {
  width: 28px;
  height: 28px;
  border-radius: 5px;
  object-fit: cover;
  color: var(--proposal-muted);
}

.uploaded-inline-item span {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 11px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uploaded-inline-item small {
  color: var(--proposal-muted);
  font-size: 10px;
  white-space: nowrap;
}

.uploaded-inline-item button,
.diagram-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--proposal-muted);
  cursor: pointer;
}

.uploaded-inline-item button:hover,
.diagram-delete:hover {
  background: #F1F2F4;
  color: var(--proposal-ink);
}

.diagram-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.diagram-file-card,
.diagram-add-card {
  position: relative;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) 24px;
  align-items: center;
  gap: 10px;
  min-height: 74px;
  padding: 10px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #fff;
}

.diagram-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 50px;
  overflow: hidden;
  border-radius: 6px;
  background: #F1F2F4;
  color: var(--proposal-primary);
  font-size: 16px;
}

.diagram-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.diagram-file-copy {
  min-width: 0;
}

.diagram-file-name {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.diagram-file-meta {
  margin-top: 3px;
  color: var(--proposal-muted);
  font-size: 10px;
  line-height: 1.3;
}

.diagram-add-card {
  display: flex;
  justify-content: center;
  grid-template-columns: none;
  border-style: dashed;
  color: var(--proposal-primary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.diagram-add-card:hover {
  border-color: var(--proposal-blue-border);
  background: #F8FBFF;
}

.settings-panel {
  display: flex;
  flex-direction: column;
  width: 280px;
  height: calc(100dvh - 92px);
  min-height: 620px;
  overflow: hidden;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #fff;
}

.settings-readiness {
  flex: 0 0 auto;
  padding: 14px 14px 12px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
}

.settings-readiness-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 600;
}

.settings-readiness-title b {
  color: var(--proposal-blue-text);
  font-size: 11px;
  font-weight: 600;
}

.settings-ready-list {
  display: grid;
  gap: 6px;
  margin-top: 10px;
}

.settings-ready-item {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  min-height: 28px;
  padding: 5px 7px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 7px;
  background: #F8FAFC;
  color: #5B6470;
}

.settings-ready-item i {
  color: var(--proposal-muted);
  font-size: 10px;
  text-align: center;
}

.settings-ready-item span {
  overflow: hidden;
  color: var(--proposal-ink);
  font-size: 11px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settings-ready-item small {
  color: var(--proposal-muted);
  font-size: 10px;
  white-space: nowrap;
}

.settings-ready-item.done {
  border-color: var(--proposal-green-border);
  background: var(--proposal-green-bg);
}

.settings-ready-item.done i,
.settings-ready-item.done small {
  color: var(--proposal-green-text);
}

.settings-ready-item.required:not(.done) {
  border-color: #E6C788;
  background: var(--proposal-amber-bg);
}

.settings-ready-item.required:not(.done) i,
.settings-ready-item.required:not(.done) small {
  color: var(--proposal-amber-text);
}

.settings-groups {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  padding: 14px 14px 0;
  overflow-y: auto;
}

.settings-group {
  min-width: 0;
}

.settings-group-label {
  padding-bottom: 8px;
  margin-bottom: 10px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.settings-field + .settings-field {
  margin-top: 12px;
}

.settings-field-label {
  color: #4B5563;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
}

.format-segments {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
  margin-top: 7px;
}

.format-segments button {
  height: 30px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 6px;
  background: #fff;
  color: #5B6470;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}

.format-segments button.active {
  border-color: var(--proposal-blue-border);
  background: var(--proposal-blue-bg);
  color: var(--proposal-blue-text);
}

.range-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.range-value {
  color: var(--proposal-blue-text);
  font-size: 11px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.settings-range {
  width: 100%;
  margin-top: 9px;
  accent-color: var(--proposal-primary);
}

.settings-field-hint {
  margin-top: 6px;
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.4;
}

.proposal-toggle-list,
.model-radio-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.proposal-toggle-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.proposal-toggle-copy {
  min-width: 0;
}

.proposal-toggle-title {
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}

.proposal-toggle-desc {
  margin-top: 2px;
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.3;
}

.proposal-toggle-switch {
  position: relative;
  width: 34px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #D8DCE2;
  cursor: pointer;
}

.proposal-toggle-switch span {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 0.5px solid #B9C0CA;
  background: #F6F7F8;
  transition: transform 0.15s;
}

.proposal-toggle-switch.on {
  background: var(--proposal-primary);
}

.proposal-toggle-switch.on span {
  border-color: #fff;
  background: #fff;
  transform: translateX(16px);
}

.model-radio-card {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  min-height: 50px;
  padding: 9px;
  border: 0.5px solid var(--proposal-border);
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.model-radio-card:hover {
  border-color: var(--proposal-border-hover);
}

.model-radio-card.selected {
  border-color: #378ADD;
  background: var(--proposal-blue-bg);
}

.model-radio-dot {
  position: relative;
  width: 14px;
  height: 14px;
  border: 1px solid #A3ABB6;
  border-radius: 999px;
  background: #fff;
}

.model-radio-card.selected .model-radio-dot {
  border-color: var(--proposal-primary);
}

.model-radio-card.selected .model-radio-dot::after {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--proposal-primary);
  content: "";
}

.model-radio-copy {
  min-width: 0;
}

.model-radio-title {
  color: var(--proposal-ink);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}

.model-radio-desc {
  margin-top: 2px;
  color: var(--proposal-muted);
  font-size: 10px;
  line-height: 1.3;
}

.settings-panel-footer {
  flex: 0 0 auto;
  padding: 12px 14px 14px;
  border-top: 0.5px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}

.settings-progress-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #4B5563;
  font-size: 11px;
  font-weight: 500;
}

.settings-progress-row b {
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 500;
}

.settings-progress-track {
  height: 3px;
  margin-top: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #E5E7EB;
}

.settings-progress-fill {
  width: 66%;
  height: 100%;
  border-radius: inherit;
  background: var(--proposal-primary);
}

.settings-generate-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 38px;
  margin-top: 12px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: var(--proposal-primary);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.settings-generate-btn span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.settings-generate-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.settings-help-text {
  margin-top: 8px;
  color: var(--proposal-muted);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.35;
  text-align: center;
}

@media (max-width: 1120px) {
  .proposal-workspace-topbar {
    flex-direction: column;
    gap: 8px;
    padding: 10px 20px 0;
  }
  .workspace-topbar-left {
    justify-content: space-between;
  }
  .workspace-steps {
    padding-bottom: 10px;
  }
  .workspace-tab {
    height: 38px;
  }
  .proposal-setup-redesign .setup-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .proposal-setup-redesign .setup-side,
  .settings-panel {
    position: static;
    width: 100%;
    min-width: 0;
    max-width: none;
  }
  .settings-panel {
    height: auto;
    min-height: 0;
  }
}
@media (max-width: 720px) {
  .proposal-workspace-topbar {
    padding-right: 14px;
    padding-left: 14px;
  }
  .workspace-topbar-left {
    flex-direction: column;
    gap: 6px;
  }
  .workspace-title-block {
    min-width: 0;
  }
  .workspace-tabs,
  .workspace-steps {
    overflow-x: auto;
  }
  .proposal-setup-redesign {
    padding-right: 14px;
    padding-left: 14px;
  }
  .asset-thumb-grid,
  .diagram-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .asset-category-header {
    align-items: flex-start;
  }
  .asset-category-desc {
    white-space: normal;
  }
  .section-subtitle {
    white-space: normal;
  }
}`],
})
export class PageProposalDetailComponent implements OnInit, OnDestroy, AfterViewChecked {
    // ── Core state ──
    public notice_no: string = '';
    public proposal: any = null;
    public item: any = null;
    public sections: any[] = [];
    public rfpSummary: string = '';
    public hasAnalysisToc: boolean = false;
    public analysisTocCount: number = 0;
    public loading: boolean = true;

    // ── Step state ──
    public step: 'setup' | 'generating' | 'result' = 'setup';
    public resultTab: 'overview' | 'codex' = 'overview';

    // ── Setup settings ──
    public companyName: string = '';
    public targetPages: number = 100;
    public currentModel: string = 'qwen3.6:35b-a3b';
    public generationMode: 'structured' | 'codex_autonomous' = 'structured';
    public modelOptions: any[] = [
        { id: 'qwen3.6:35b-a3b', label: 'Qwen 2.6 35B · 내부' },
        { id: 'codex', label: 'Codex · 기술 문서 특화' },
        { id: 'remote', label: 'Remote · 속도 우선' },
    ];
    public registeredModelOptions: any[] = [];
    public readonly proposalModelCards: any[] = [
        { id: 'qwen3.6:35b-a3b', title: 'Qwen 2.6 35B', description: '고품질 · 균형형 · 권장' },
        { id: 'codex', title: 'Codex', description: '기술 문서 특화' },
        { id: 'remote', title: 'Remote', description: '속도 우선 · 간단 제안서' },
    ];
    public proposalContentOptions: any[] = [
        { id: 'bid_eval', title: '입찰 평가 대응', description: '평가 항목 자동 매핑', enabled: true },
        { id: 'rfp_grounded', title: 'RFP 근거 기반 작성', description: 'RFP 내용 인용 포함', enabled: false },
        { id: 'asset_auto', title: '선택 자산 자동 반영', description: '이미지·로고 자동 삽입', enabled: true },
        { id: 'assistant_guide', title: 'AI 어시스턴트 가이드', description: '작성 중 제안 표시', enabled: false },
    ];
    public guides: any[] = [];
    public selectedGuideIds: any = {};
    public guidePanelTab: 'guides' | 'styles' = 'guides';
    public currentStyleProfile: string = 'bid_reference';
    public styleOptions: any[] = [
        { id: 'bid_reference', title: '정석 입찰형', subtitle: '네이비·골드 기준', tone: 'formal', colors: ['#0f3057', '#c9a437', '#ffffff'] },
        { id: 'technical_blueprint', title: '기술 설계형', subtitle: '시스템·AI·데이터 강조', tone: 'tech', colors: ['#123a5d', '#0ea5a4', '#eef6f7'] },
        { id: 'executive_summary', title: '경영 요약형', subtitle: '간결한 의사결정 문서', tone: 'exec', colors: ['#263238', '#2f7d68', '#f2f5f3'] },
    ];
public harnessPreviewOpen: boolean = false;
public harnessPreviewLoading: boolean = false;
public harnessPreviewError: string = '';
public harnessPreview: any = null;
    public guideOpen: boolean = true;
    public rfpSummaryOpen: boolean = true;

    // ── Assets ──
    public workspaceAssets: any[] = [];
    public assetUploading: boolean = false;
    public assetSlotEmpty: any = { proposal_logo: false, proposal_image: false, company: false, consortium: false, case: false };

    // ── Asset Library Selection (제안서 생성 전) ──
    public assetLibCompanies: any[] = [];           // 자사·일반회사 (라디오)
    public assetLibConsortium: any[] = [];          // 컨소시엄 파트너 (체크박스)
    public assetLibPersonnel: any[] = [];           // 인력
    public assetLibProjects: any[] = [];            // 유사실적
    public assetLibImages: any[] = [];              // 참고 이미지
    public assetLibGeneralStatus: any[] = [];        // 일반현황
    public selectedLibCompanyId: string = '';
    public selectedLibConsortiumIds: any = {};
    public selectedLibPersonnelIds: any = {};
    public selectedLibProjectIds: any = {};
    public selectedLibImageIds: any = {};
    public selectedLibGeneralStatusIds: any = {};
    public assetLibLoading: boolean = false;
    public assetLibTab: string = 'company';
    public readonly assetLibTabs: any[] = [
        { id: 'company', label: '회사', icon: 'fas fa-building' },
        { id: 'consortium', label: '컨소시엄', icon: 'fas fa-handshake' },
        { id: 'personnel', label: '인력', icon: 'fas fa-user-tie' },
        { id: 'projects', label: '실적', icon: 'fas fa-trophy' },
        { id: 'images', label: '이미지', icon: 'fas fa-image' },
        { id: 'general_status', label: '일반현황', icon: 'fas fa-chart-bar' },
    ];

    // ── Generation ──
    public generating: boolean = false;
    public generationMessage: string = '';
    public generationPhase: string = '';
    public generationProgress: number = 0;
    public generationEta: string = '-';
    public generationLogs: any[] = [];
    public generationStartedAt: number = 0;
    public actualPageCount: number = 0;
    public currentPageIdx: number = 0;
    private _previewIframeEl: HTMLIFrameElement | null = null;
    private sseAbortController: AbortController | null = null;

    // ── Section editing ──
    public editingSection: any = null;
    public editingDraft: string = '';
    public editSectionIdx: number = 0;

    // ── Section AI edit ──
    public aiEditSection: any = null;
    public activeSectionNo: string = '';
    public aiEditInstruction: string = '';
    public aiEditLoading: boolean = false;
    public aiEditPhase: string = '';
    public aiEditError: string = '';
    private aiEditPhaseTimer: any = null;

    // ── PDF ──
    public pdfPreviewUrl: SafeResourceUrl | string = '';
    public htmlPreviewUrl: SafeResourceUrl | string = '';
    public previewTab: 'html' | 'pdf' = 'html';
    public pdfDownloading: boolean = false;

    // ── HTML Edit Mode ──
    public htmlEditMode: boolean = false;
    public htmlEditSaving: boolean = false;
    public editablePreviewUrl: SafeResourceUrl | string = '';

    // ── Chat ──
    public chatMessages: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;
    public chatPhase: string = '';
    private chatPhaseTimer: any = null;
    public chatComposing: boolean = false;
    private chatSendAfterComposition: boolean = false;
    public chatSection: any = null;
    public chatContext: any = {};
    public chatApprovalMode: boolean = true;
    public pendingChanges: any[] = [];
    public reviewDashboard: any = null;
    public reviewLoading: boolean = false;
    public reviewRequirementFilter: 'all' | 'missing' | 'weak' | 'covered' = 'all';

    // ── Real Codex ──
    public codexStatus: any = null;
    public codexJobs: any[] = [];
    public selectedCodexJobId: string = '';
    public codexInput: string = '';
    public codexExtraContext: string = '';
    public codexModel: string = '';
    public codexFiles: File[] = [];
    public codexPageCapturePath: string = '';
    public codexPageCapturePage: number = 0;
    public codexPageCaptureLoading: boolean = false;
    public codexUsageSummary: any = null;
    public codexUsageLoading: boolean = false;
    public codexLoading: boolean = false;
    public codexPollingJobId: string = '';
    private codexPollTimer: any = null;
    public codexContextOptions: any = {
        include_proposal_context: true,
        include_html_rules: true,
    };
    public codexWorkflowStage: string = 'proposal_design';
    public readonly codexWorkflowSteps: any[] = [
        {
            id: 'proposal_design',
            order: '01',
            label: '디자인 분석',
            shortLabel: '디자인',
            icon: 'fas fa-palette',
            description: 'RFP의 사업 성격, 발주기관 톤, 평가 포인트를 읽고 제안서 전체 디자인 방향을 뽑습니다.',
            output: '디자인 컨셉 · 색/타이포 · 지면 규칙 · 샘플 구조',
            placeholder: 'RFP를 보고 제안서 전체 디자인 방향을 뽑아줘. 아직 목차와 본문은 만들지 마.',
            defaultPrompt: '현재 공고의 RFP만 기준으로 제안서 전체 디자인 방향을 뽑아줘. 아직 목차와 본문은 만들지 마. 결과는 검토/승인하기 쉽게 2~3개 디자인 후보로 정리하고, 각 후보마다 문서 톤, 색상 팔레트, 타이포 계층, 표지/목차/본문/표/도식 스타일, 페이지 밀도, 피해야 할 디자인, 샘플 HTML 구조 방향을 포함해줘.',
        },
        {
            id: 'toc_design',
            order: '02',
            label: '목차 설계',
            shortLabel: '목차',
            icon: 'fas fa-list-ol',
            description: '승인한 디자인 방향을 전제로 RFP 요구사항과 평가기준에 맞는 목차를 설계합니다.',
            output: '장/절 목차 · 페이지 배분 · 평가 대응 매핑',
            placeholder: '승인한 디자인 방향을 기준으로 RFP 제안서 목차를 설계해줘.',
            defaultPrompt: '직전 디자인 분석 결과 중 사용자가 승인한 디자인 방향을 기준으로, RFP를 보고 제안서 목차만 설계해줘. 아직 본문은 작성하지 마. 장/절 구조, 각 절의 목적, 예상 페이지 수, 평가항목 대응, 필요한 도식/표/증빙자료, 작성 우선순위를 함께 정리해줘.',
            requiresDesign: true,
        },
    ];

    public readonly referenceAssetSlots: any[] = [
        {
            id: 'proposal_logo',
            label: '기관 로고',
            title: '표지 기관 로고',
            description: '이 제안서의 발주기관/수요기관 로고를 올리세요. 표지 상단의 기관 영역에만 사용됩니다.',
            cta: '기관 로고 업로드',
            accept: '.png,.jpg,.jpeg,.webp,.gif,.svg',
        },
        {
            id: 'proposal_image',
            label: '본문 이미지',
            title: '시스템 구성도·파이프라인·화면',
            description: '해당 제안서에만 넣을 시스템 구성도, 데이터 파이프라인, 화면 캡처, 실적 이미지를 올리세요. AI가 관련 섹션에 캡션과 함께 배치할 수 있습니다.',
            cta: '본문 이미지 업로드',
            accept: '.pdf,.png,.jpg,.jpeg,.webp,.gif,.svg',
        },
        {
            id: 'company',
            label: '회사 정보',
            title: '회사 소개 자료',
            description: '회사소개서, 핵심 인력, 보유 역량, 조직 구성처럼 제안사 강점을 보여주는 자료를 올리세요.',
            cta: '회사 정보 업로드',
        },
        {
            id: 'consortium',
            label: '컨소시엄',
            title: '컨소시엄 구성 자료',
            description: '참여사 역할 분담, 협업 구조, 책임 범위, 수행 인력 체계가 드러나는 자료를 올리세요.',
            cta: '컨소시엄 자료 업로드',
        },
        {
            id: 'case',
            label: '유사사업 정보',
            title: '유사사업 수행 자료',
            description: '유사사업 실적서, 레퍼런스, 성과 요약, 수행 결과처럼 신뢰도를 높일 자료를 올리세요.',
            cta: '유사사업 자료 업로드',
        },
    ];

    public readonly assetAcceptedExtensions: string = '.md,.pdf,.png,.jpg,.jpeg,.webp,.gif,.txt,.doc,.docx,.hwp,.hwpx';
    public readonly assetAcceptedExtensionsLabel: string = '지원 형식: md, pdf, png, jpg, jpeg, webp, gif, txt, doc, docx, hwp, hwpx';

    public readonly quickChatPrompts: string[] = [
        '현재 초안에서 평가 항목 대응이 약한 부분을 짚어줘',
        '업로드한 회사 정보와 유사사례를 어디에 녹이면 좋을지 제안해줘',
        '평가위원 시점에서 문장이 약한 구간을 수정 문안으로 바꿔줘',
    ];

    private markdownConverter = new showdown.Converter({
        tables: true,
        ghCodeBlocks: true,
        tasklists: true,
        strikethrough: true,
        simpleLineBreaks: false,
    });
    private mermaidInitialized: boolean = false;
    private mermaidRenderScheduled: boolean = false;
    private mermaidRenderInProgress: boolean = false;
    private mermaidSequence: number = 0;
    private referenceAssetUrlVersion: number = Date.now();

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer,@Inject( ElementRef<HTMLElement>)  private elementRef: ElementRef<HTMLElement>) { }

    public get isCodexRfp(): boolean {
        return this.item?.source === 'codex_upload';
    }

    public async ngOnInit() {
        if (!this.mermaidInitialized) {
            mermaid.initialize({ startOnLoad: false, securityLevel: 'loose', theme: 'neutral' });
            this.mermaidInitialized = true;
        }
        await this.service.init();
        this.notice_no = WizRoute.segment.id;
        await this.load();
        const queryCodexStage = this.codexWorkflowStageFromQuery();
        if (this.isCodexRfp || this.hasCodexEntryQuery()) {
            await this.openCodexWorkspace();
            await this.setCodexWorkflowStage(queryCodexStage || this.codexWorkflowStage);
        } else if (queryCodexStage) {
            await this.setCodexWorkflowStage(queryCodexStage);
        }
        await this.service.render();
    }

    public ngAfterViewChecked() {
        this.scheduleMermaidRender();
    }

    public ngOnDestroy() {
        this.abortSSE();
        this.stopAiEditPhases();
        this.stopChatPhases();
        this.stopCodexPolling();
    }

    public goBack() {
        if (this.isCodexRfp || this.hasCodexEntryQuery()) {
            this.service.href('/codex');
            return;
        }
        this.service.href('/proposal');
    }

    private hasCodexEntryQuery(): boolean {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get('codex') === '1' || params.get('tab') === 'codex';
        } catch {
            return false;
        }
    }

    private codexWorkflowStageFromQuery(): string {
        try {
            const params = new URLSearchParams(window.location.search || '');
            const stageId = (params.get('codex_stage') || params.get('stage') || '').trim();
            return this.codexWorkflowSteps.some((step: any) => step.id === stageId) ? stageId : '';
        } catch {
            return '';
        }
    }

    public goProjectAnalysis() {
        this.service.href(`/analysis/${encodeURIComponent(this.notice_no)}?from=project`);
    }

    public async goProjectProposal() {
        if (this.isCodexRfp) {
            await this.openCodexWorkspace();
            return;
        }
        if (this.hasCodexEntryQuery()) {
            this.service.href(`/proposal/${encodeURIComponent(this.notice_no)}`);
            return;
        }
        this.step = this.determineStep();
        if (this.step === 'result') {
            this.resultTab = 'overview';
            this.refreshHtmlPreview(false);
            this.refreshPdfPreview(false);
        }
        await this.service.render();
    }

    public async openCodexWorkspace() {
        this.step = 'result';
        this.resultTab = 'codex';
        this.editingSection = null;
        this.aiEditSection = null;
        this.htmlEditMode = false;
        if (this.isCodexRfp) {
            this.clearProposalPreview();
        } else {
            this.refreshHtmlPreview(false);
            this.refreshPdfPreview(false);
        }
        await this.loadCodexStatus(false);
        await this.loadCodexJobs(false);
        await this.loadCodexUsageSummary(false);
        await this.service.render();
    }

    public goProjectPresentation() {
        this.service.href(`/presentation?notice_no=${encodeURIComponent(this.notice_no)}`);
    }

    // ── Step navigation ──

    private determineStep() {
        if (this.isCodexRfp) return 'result';
        if (this.generating) return 'generating';
        let hasContent = this.sections.some((s: any) => s.status === 'done' && s.content);
        if (hasContent) return 'result';
        return 'setup';
    }

    public async goToSetup() {
        this.editingSection = null;
        this.aiEditSection = null;
        this.step = 'setup';
        await this.service.render();
        this.resetWorkspaceScroll();
    }

    private resetWorkspaceScroll() {
        try {
            requestAnimationFrame(() => {
                const wrapper = document.querySelector('.scroll-wrapper') as HTMLElement | null;
                if (wrapper) wrapper.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            });
        } catch { }
    }

    public async setResultTab(tab: 'overview' | 'codex') {
        if (this.isCodexRfp) tab = 'codex';
        this.resultTab = tab;
        if (tab === 'codex') {
            await this.loadCodexStatus(false);
            await this.loadCodexJobs(false);
            await this.loadCodexUsageSummary(false);
        }
        await this.service.render();
    }

    public scrollToSection(section: any) {
        if (!section) return;
        const sectionNo = section.section_no;
        if (!sectionNo) return;
        this.activeSectionNo = sectionNo;
        // Ensure HTML preview tab is active
        if (this.previewTab !== 'html') {
            this.previewTab = 'html';
        }
        this.service.render();
        setTimeout(() => {
            const iframe = this.elementRef.nativeElement.querySelector('.preview-frame:not(.edit-frame)') as HTMLIFrameElement;
            if (!iframe?.contentWindow?.document) return;
            const doc = iframe.contentWindow.document;
            const target = doc.querySelector(`.page.body-page[data-section-no="${sectionNo}"]`) as HTMLElement | null;
            if (!target) return;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, this.previewTab === 'html' ? 50 : 500);
    }

    // ── Edit section navigation ──

    public get activeEditSection(): any {
        if (this.sections.length === 0) return null;
        if (this.editSectionIdx >= this.sections.length) this.editSectionIdx = 0;
        return this.sections[this.editSectionIdx];
    }

    public async selectEditSection(idx: number) {
        this.editSectionIdx = idx;
        this.editingSection = null;
        this.aiEditSection = null;
        await this.service.render();
    }

    public async prevEditSection() {
        if (this.editSectionIdx > 0) {
            this.editSectionIdx--;
            this.editingSection = null;
            this.aiEditSection = null;
            await this.service.render();
        }
    }

    public async nextEditSection() {
        if (this.editSectionIdx < this.sections.length - 1) {
            this.editSectionIdx++;
            this.editingSection = null;
            this.aiEditSection = null;
            await this.service.render();
        }
    }

    // ── Computed ──

    public get selectedGuideIdList(): string[] {
        return Object.keys(this.selectedGuideIds).filter((id) => this.selectedGuideIds[id]);
    }

    public get selectedGuideCount(): number {
        return this.selectedGuideIdList.length;
    }

    public get completedCount(): number {
        return this.sections.filter((s: any) => s.status === 'done' && s.content).length;
    }

    public get pendingCount(): number {
        return Math.max(this.sections.length - this.completedCount, 0);
    }

    public get failedCount(): number {
        return this.sections.filter((s: any) => s.status === 'error').length;
    }

    public get activeGeneratingSection(): any {
        return this.sections.find((s: any) => s._generating) || null;
    }

    public get queuedCount(): number {
        let active = this.activeGeneratingSection ? 1 : 0;
        return Math.max(this.sections.length - this.completedCount - this.failedCount - active, 0);
    }

    public get latestGenerationLog(): any {
        if (this.generationLogs.length === 0) return null;
        return this.generationLogs[this.generationLogs.length - 1];
    }

    public get progressPercent(): number {
        if (this.generating) return this.generationProgress;
        if (this.sections.length === 0) return 0;
        return Math.round((this.completedCount / this.sections.length) * 100);
    }

    public get generationElapsedLabel(): string {
        if (!this.generationStartedAt) return '-';
        return this.formatDuration(Date.now() - this.generationStartedAt);
    }

    public trackById(index: number, item: any): string {
        return item.id;
    }

    private rebuildModelOptions() {
        const base = [
            { id: 'qwen3.6:35b-a3b', label: 'Qwen 2.6 35B · 내부' },
            { id: 'codex', label: 'Codex · 기술 문서 특화' },
            { id: 'remote', label: 'Remote · 속도 우선' },
        ];
        const merged: any[] = [];
        const seen: any = {};
        const addOption = (option: any) => {
            const id = this.normalizeModelId(option?.id || '');
            if (!id || seen[id]) return;
            seen[id] = true;
            merged.push({ ...option, id, label: option?.label || id });
        };
        base.forEach(addOption);
        (this.registeredModelOptions || []).forEach(addOption);
        if (this.currentModel && !seen[this.currentModel]) {
            addOption({ id: this.currentModel, label: this.currentModel });
        }
        this.modelOptions = merged;
    }

    public get currentModelLabel(): string {
        let matched = this.modelOptions.find((option: any) => option.id === this.currentModel);
        return matched?.label || this.currentModel || 'Qwen 2.6 35B · 내부';
    }

    public get currentStyleLabel(): string {
        return this.styleOptions.find((option: any) => option.id === this.currentStyleProfile)?.title || '정석 입찰형';
    }

    public get uploadedRfpDocuments(): any[] {
        return this.item?.documents || [];
    }

    public get legacyReferenceAssets(): any[] {
        return this.workspaceAssets.filter((asset: any) => !this.referenceAssetSlots.find((slot: any) => slot.id === asset.category));
    }

    public get proposalImageAssetSlots(): any[] {
        return this.referenceAssetSlots.filter((slot: any) => slot.id === 'proposal_logo' || slot.id === 'proposal_image');
    }

    // ── Load ──

    public async load() {
        this.loading = true;
        await this.service.render();

        try {
            let res = await wiz.call('load', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.proposal = res.data.proposal;
                this.item = res.data.item;
                this.sections = res.data.sections || [];
                this.rfpSummary = res.data.rfp_summary || '';
                this.hasAnalysisToc = !!res.data.has_analysis_toc;
                this.analysisTocCount = res.data.analysis_toc_count || 0;
                this.guides = res.data.guides || [];
                this.setSelectedGuideIds(res.data.selected_guide_ids || []);
                this.workspaceAssets = res.data.workspace_assets || [];
                this.assetSlotEmpty = { proposal_logo: false, proposal_image: false, company: false, consortium: false, case: false, ...(res.data.asset_slot_empty || {}) };
                this.registeredModelOptions = Array.isArray(res.data.model_options) ? res.data.model_options : [];
                this.generationMode = res.data.generation_mode === 'codex_autonomous' ? 'codex_autonomous' : 'structured';
                this.currentModel = this.normalizeModelId(res.data.workspace_model || res.data.default_model || this.proposal?.ai_model || 'qwen3.6:35b-a3b');
                if (this.generationMode === 'codex_autonomous') this.currentModel = 'codex';
                this.rebuildModelOptions();
                this.companyName = res.data.company_name || '';
                this.targetPages = this.normalizeTargetPages(res.data.target_pages || 100);
                if (Array.isArray(res.data.style_profiles) && res.data.style_profiles.length > 0) {
                    this.styleOptions = res.data.style_profiles.map((item: any) => ({
                        ...item,
                        colors: this.getStyleColors(item.id),
                    }));
                }
                this.currentStyleProfile = this.normalizeStyleProfile(res.data.style_profile || 'bid_reference');

                this.step = this.determineStep();
                if (this.isCodexRfp) {
                    this.resultTab = 'codex';
                    this.clearProposalPreview();
                } else if (this.step === 'result') {
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    this.loadReviewDashboard(false);
                }
                this.initializeChatMessages();
            }
        } catch (e) {
            console.error('load error', e);
        }

        if (!this.isCodexRfp) {
            await this.ensureGuideOptionsLoaded();
            await this.loadAssetLibrary();
            await this.loadSavedAssetSelection();
        }
        this.loading = false;
        await this.service.render();
    }

    // ── Asset Library Selection (제안서 생성 전 자산 선택) ──
    public async loadAssetLibrary() {
        this.assetLibLoading = true;
        await this.service.render();
        try {
            let res = await wiz.call('load_asset_library', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.assetLibCompanies = this.normalizeAssetList(res.data.companies);
                this.assetLibConsortium = this.normalizeAssetList(res.data.consortium);
                this.assetLibPersonnel = this.normalizeAssetList(res.data.personnel);
                this.markPersonnelDirty();
                this.assetLibProjects = this.normalizeAssetList(res.data.projects);
                this.assetLibImages = this.normalizeAssetList(res.data.images);
                this.assetLibGeneralStatus = this.normalizeAssetList(res.data.general_status);

                let sel = this.normalizeAssetSelection(res.data.selection);
                if (sel && (sel.company_id || (sel.personnel_ids && sel.personnel_ids.length) || (sel.project_ids && sel.project_ids.length) || (sel.consortium_ids && sel.consortium_ids.length) || (sel.image_ids && sel.image_ids.length) || (sel.general_status_ids && sel.general_status_ids.length))) {
                    this.selectedLibCompanyId = sel.company_id ? String(sel.company_id) : '';
                    this.selectedLibConsortiumIds = {};
                    for (let id of sel.consortium_ids) this.selectedLibConsortiumIds[String(id)] = true;
                    this.selectedLibPersonnelIds = {};
                    for (let id of sel.personnel_ids) this.selectedLibPersonnelIds[String(id)] = true;
                    this.selectedLibProjectIds = {};
                    for (let id of sel.project_ids) this.selectedLibProjectIds[String(id)] = true;
                    this.selectedLibImageIds = {};
                    for (let id of sel.image_ids) this.selectedLibImageIds[String(id)] = true;
                    this.selectedLibGeneralStatusIds = {};
                    for (let id of sel.general_status_ids) this.selectedLibGeneralStatusIds[String(id)] = true;
                } else {
                    // 자사 자동 선택
                    this.selectedLibCompanyId = res.data.self_company_id || '';
                    this.selectedLibConsortiumIds = {};
                    this.selectedLibPersonnelIds = {};
                    this.selectedLibProjectIds = {};
                    this.selectedLibImageIds = {};
                    this.selectedLibGeneralStatusIds = {};
                }
            }
        } catch (e) {
            console.error('loadAssetLibrary error', e);
        }
        this.assetLibLoading = false;
        await this.service.render();
    }

    private asArray(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (value === null || value === undefined || value === '') return [];
        if (typeof value === 'object') return Object.values(value);
        return [];
    }

    private normalizeMetadata(metadata: any): any {
        if (!metadata) return {};
        if (Array.isArray(metadata)) return {};
        if (typeof metadata === 'object') return { ...metadata };
        if (typeof metadata === 'string') {
            try {
                const parsed = JSON.parse(metadata);
                return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch (e) {
                return {};
            }
        }
        return {};
    }

    private normalizeTags(tags: any): string[] {
        if (Array.isArray(tags)) {
            return tags.map((tag: any) => String(tag || '').trim()).filter((tag: string) => tag !== '');
        }
        if (typeof tags === 'string') {
            return tags
                .split(/[,#;\n]/)
                .map((tag: string) => tag.trim())
                .filter((tag: string) => tag !== '');
        }
        if (tags && typeof tags === 'object') {
            return Object.values(tags)
                .map((tag: any) => String(tag || '').trim())
                .filter((tag: string) => tag !== '');
        }
        return [];
    }

    private normalizeAssetList(value: any): any[] {
        return this.asArray(value)
            .filter((asset: any) => asset && typeof asset === 'object')
            .map((asset: any) => {
                const metadata = this.normalizeMetadata(asset.metadata);
                return {
                    ...asset,
                    metadata,
                    files: this.asArray(asset.files),
                    display_tags: this.normalizeTags(metadata.tags),
                };
            });
    }

    private normalizeIdList(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (value === null || value === undefined || value === '') return [];
        if (typeof value === 'object') {
            return Object.keys(value).filter((key: string) => !!value[key]);
        }
        return [value];
    }

    private normalizeAssetSelection(selection: any): any {
        const sel = selection && typeof selection === 'object' && !Array.isArray(selection) ? selection : {};
        return {
            company_id: sel.company_id ? String(sel.company_id) : '',
            consortium_ids: this.normalizeIdList(sel.consortium_ids),
            personnel_ids: this.normalizeIdList(sel.personnel_ids),
            project_ids: this.normalizeIdList(sel.project_ids),
            image_ids: this.normalizeIdList(sel.image_ids),
            general_status_ids: this.normalizeIdList(sel.general_status_ids),
        };
    }

    public async selectLibCompany(id: string) {
        this.selectedLibCompanyId = String(id);
        const company = this.assetLibCompanies.find((c: any) => String(c.id) === String(id));
        if (company) {
            this.companyName = company.name || '';
        }
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleLibConsortium(id: string) {
        let key = String(id);
        this.selectedLibConsortiumIds[key] = !this.selectedLibConsortiumIds[key];
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleLibPersonnel(id: string) {
        let key = String(id);
        this.selectedLibPersonnelIds[key] = !this.selectedLibPersonnelIds[key];
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleLibProject(id: string) {
        let key = String(id);
        this.selectedLibProjectIds[key] = !this.selectedLibProjectIds[key];
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleLibImage(id: string) {
        let key = String(id);
        this.selectedLibImageIds[key] = !this.selectedLibImageIds[key];
        await this.service.render();
        await this.saveAssetSelection();
    }

    public async toggleLibGeneralStatus(id: string) {
        let key = String(id);
        this.selectedLibGeneralStatusIds[key] = !this.selectedLibGeneralStatusIds[key];
        await this.service.render();
        await this.saveAssetSelection();
    }

    private async saveAssetSelection() {
        try {
            await wiz.call('save_asset_selection', {
                notice_no: this.notice_no,
                asset_selection: JSON.stringify(this.buildLibAssetSelection()),
            });
        } catch (e) {
            console.error('save asset selection', e);
        }
    }

    private async loadSavedAssetSelection() {
        try {
            let res = await wiz.call('get_asset_selection', { notice_no: this.notice_no });
            if (res?.code !== 200) return;
            let sel = this.normalizeAssetSelection(res.data?.selection);
            if (sel.company_id) this.selectedLibCompanyId = String(sel.company_id);
            for (let id of sel.consortium_ids) this.selectedLibConsortiumIds[String(id)] = true;
            for (let id of sel.personnel_ids) this.selectedLibPersonnelIds[String(id)] = true;
            for (let id of sel.project_ids) this.selectedLibProjectIds[String(id)] = true;
            for (let id of sel.image_ids) this.selectedLibImageIds[String(id)] = true;
            for (let id of sel.general_status_ids) this.selectedLibGeneralStatusIds[String(id)] = true;
        } catch (e) {
            console.error('load asset selection', e);
        }
    }

    public buildLibAssetSelection(): any {
        return {
            company_id: this.selectedLibCompanyId || '',
            consortium_ids: Object.keys(this.selectedLibConsortiumIds).filter(k => this.selectedLibConsortiumIds[k]),
            personnel_ids: Object.keys(this.selectedLibPersonnelIds).filter(k => this.selectedLibPersonnelIds[k]),
            project_ids: Object.keys(this.selectedLibProjectIds).filter(k => this.selectedLibProjectIds[k]),
            image_ids: Object.keys(this.selectedLibImageIds).filter(k => this.selectedLibImageIds[k]),
            general_status_ids: Object.keys(this.selectedLibGeneralStatusIds).filter(k => this.selectedLibGeneralStatusIds[k]),
        };
    }

    public getAssetThumbUrl(asset: any): string {
        if (!asset || !asset.id) return '';
        let files = this.asArray(asset.files);
        if (files.length === 0) return '';
        const imageFile = files.find((file: any) => {
            const type = String(file?.file_type || '').toLowerCase();
            const mime = String(file?.mime_type || '').toLowerCase();
            const name = String(file?.original_filename || '');
            return type === 'image' || mime.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(name);
        }) || files[0];
        if (!imageFile?.id) return '';
        return `/api/assets/images/${asset.id}/files/${imageFile.id}`;
    }

    public async setAssetLibTab(tabId: string) {
        this.assetLibTab = tabId;
        await this.service.render();
    }

    public getAssetLibTabSelectedCount(tabId: string): number {
        switch (tabId) {
            case 'company': return this.selectedLibCompanyId ? 1 : 0;
            case 'consortium': return Object.keys(this.selectedLibConsortiumIds).filter(k => this.selectedLibConsortiumIds[k]).length;
            case 'personnel': return Object.keys(this.selectedLibPersonnelIds).filter(k => this.selectedLibPersonnelIds[k]).length;
            case 'projects': return Object.keys(this.selectedLibProjectIds).filter(k => this.selectedLibProjectIds[k]).length;
            case 'images': return Object.keys(this.selectedLibImageIds).filter(k => this.selectedLibImageIds[k]).length;
            case 'general_status': return Object.keys(this.selectedLibGeneralStatusIds).filter(k => this.selectedLibGeneralStatusIds[k]).length;
            default: return 0;
        }
    }

    public get selectedAssetTotalCount(): number {
        return (this.selectedLibCompanyId ? 1 : 0)
            + Object.keys(this.selectedLibConsortiumIds).filter(k => this.selectedLibConsortiumIds[k]).length
            + Object.keys(this.selectedLibPersonnelIds).filter(k => this.selectedLibPersonnelIds[k]).length
            + Object.keys(this.selectedLibProjectIds).filter(k => this.selectedLibProjectIds[k]).length
            + Object.keys(this.selectedLibImageIds).filter(k => this.selectedLibImageIds[k]).length
            + Object.keys(this.selectedLibGeneralStatusIds).filter(k => this.selectedLibGeneralStatusIds[k]).length;
    }

    public get hasSelectedCompanyAsset(): boolean {
        return !!this.selectedLibCompanyId;
    }

    public get hasUploadedProposalLogo(): boolean {
        return this.getReferenceAssets('proposal_logo').length > 0;
    }

    public get selectedVisualAssetCount(): number {
        return Object.keys(this.selectedLibImageIds).filter(k => this.selectedLibImageIds[k]).length
            + this.getReferenceAssets('proposal_image').length;
    }

    public get hasProposalVisualAssets(): boolean {
        return this.selectedVisualAssetCount > 0;
    }

    public get setupReadinessItems(): any[] {
        return [
            {
                id: 'company',
                label: '회사 자산',
                detail: this.hasSelectedCompanyAsset ? '선택됨' : '미선택',
                done: this.hasSelectedCompanyAsset,
                required: true,
                icon: 'fas fa-building',
            },
            {
                id: 'logo',
                label: '표지 로고',
                detail: this.hasUploadedProposalLogo ? '업로드됨' : '권장',
                done: this.hasUploadedProposalLogo,
                required: false,
                icon: 'fas fa-image',
            },
            {
                id: 'visual',
                label: '구성도·이미지',
                detail: this.hasProposalVisualAssets ? `${this.selectedVisualAssetCount}개` : '선택',
                done: this.hasProposalVisualAssets,
                required: false,
                icon: 'fas fa-diagram-project',
            },
        ];
    }

    public get setupReadyStepCount(): number {
        return this.setupReadinessItems.filter((item: any) => item.done).length;
    }

    public get setupReadyTotalCount(): number {
        return this.setupReadinessItems.length;
    }

    public get setupReadyProgressPercent(): number {
        if (this.setupReadyTotalCount === 0) return 0;
        return Math.round((this.setupReadyStepCount / this.setupReadyTotalCount) * 100);
    }

    public get setupReadyStepLabel(): string {
        return `${this.setupReadyStepCount}/${this.setupReadyTotalCount} 단계`;
    }

    public get setupGenerateHelpText(): string {
        if (!this.hasSelectedCompanyAsset) return '회사 자산을 선택하면 제안사 소개와 수행역량이 정확해집니다.';
        if (!this.hasUploadedProposalLogo) return '표지 로고를 추가하면 첫 페이지 완성도가 높아집니다.';
        if (!this.hasProposalVisualAssets) return '구성도나 화면 이미지를 추가하면 기술 설명이 선명해집니다.';
        return '선택한 자산과 설정을 기준으로 초안을 생성합니다.';
    }

    private buildAssetLibraryTile(type: string, asset: any, label: string, icon: string, subtitle: string = ''): any {
        if (!asset?.id) return null;
        const metadata = asset.metadata || {};
        return {
            id: `${type}:${asset.id}`,
            assetId: String(asset.id),
            type,
            title: asset.name || asset.title || label,
            subtitle: subtitle || asset.description || metadata.position || metadata.category || metadata.domain || label,
            icon,
            thumbUrl: this.getAssetThumbUrl(asset),
        };
    }

    public get assetLibrarySections(): any[] {
        const sections = [
            {
                id: 'company',
                title: '회사',
                description: '제안사 기본 정보와 회사 소개 자산',
                icon: 'fas fa-building',
                required: true,
                selectionModeLabel: '단일 선택',
                cardMode: 'compact',
                tiles: this.assetLibCompanies
                    .map((asset: any) => this.buildAssetLibraryTile('company', asset, asset.metadata?.company_type === 'self' ? '자사' : '회사', 'fas fa-building')),
            },
            {
                id: 'consortium',
                title: '컨소시엄',
                description: '공동수급 및 협력 파트너 정보',
                icon: 'fas fa-handshake',
                required: false,
                selectionModeLabel: '복수 선택',
                cardMode: 'compact',
                tiles: this.assetLibConsortium
                    .map((asset: any) => this.buildAssetLibraryTile('consortium', asset, '컨소시엄', 'fas fa-handshake')),
            },
            {
                id: 'personnel',
                title: '인력',
                description: 'PM, 연구원, 투입 인력 프로필',
                icon: 'fas fa-user-tie',
                required: false,
                selectionModeLabel: '복수 선택',
                cardMode: 'compact',
                tiles: this.assetLibPersonnel
                    .map((asset: any) => this.buildAssetLibraryTile('personnel', asset, asset.metadata?.position || '인력', 'fas fa-user-tie')),
            },
            {
                id: 'projects',
                title: '유사실적',
                description: '관련 사업 수행 이력과 레퍼런스',
                icon: 'fas fa-trophy',
                required: false,
                selectionModeLabel: '복수 선택',
                cardMode: 'compact',
                tiles: this.assetLibProjects
                    .map((asset: any) => this.buildAssetLibraryTile('projects', asset, asset.metadata?.domain || '실적', 'fas fa-trophy')),
            },
            {
                id: 'images',
                title: '이미지',
                description: '로고, 화면, 구성도 등 시각 자료',
                icon: 'fas fa-image',
                required: false,
                selectionModeLabel: '복수 선택',
                cardMode: 'visual',
                tiles: this.assetLibImages
                    .map((asset: any) => this.buildAssetLibraryTile('images', asset, asset.metadata?.category || '이미지', 'fas fa-image')),
            },
            {
                id: 'general_status',
                title: '일반현황',
                description: '인증, 재무, 조직 현황 자료',
                icon: 'fas fa-chart-bar',
                required: false,
                selectionModeLabel: '복수 선택',
                cardMode: 'compact',
                tiles: this.assetLibGeneralStatus
                    .map((asset: any) => this.buildAssetLibraryTile('general_status', asset, asset.metadata?.category || '일반현황', 'fas fa-chart-bar')),
            },
        ];

        return sections
            .map((section: any) => {
                const tiles = section.tiles.filter((tile: any) => !!tile);
                return {
                    ...section,
                    tiles,
                    selectedCount: this.getAssetLibTabSelectedCount(section.id),
                    totalCount: tiles.length,
                };
            })
            .filter((section: any) => section.totalCount > 0);
    }

    public get assetLibraryTiles(): any[] {
        return this.assetLibrarySections.reduce((tiles: any[], section: any) => tiles.concat(section.tiles), []);
    }

    public trackByAssetSection(index: number, item: any): string {
        return item?.id || String(index);
    }

    public trackByAssetTile(index: number, item: any): string {
        return item?.id || String(index);
    }

    public isAssetLibraryTileSelected(tile: any): boolean {
        if (!tile) return false;
        const id = String(tile.assetId);
        switch (tile.type) {
            case 'company': return this.selectedLibCompanyId === id;
            case 'consortium': return !!this.selectedLibConsortiumIds[id];
            case 'personnel': return !!this.selectedLibPersonnelIds[id];
            case 'projects': return !!this.selectedLibProjectIds[id];
            case 'images': return !!this.selectedLibImageIds[id];
            case 'general_status': return !!this.selectedLibGeneralStatusIds[id];
            default: return false;
        }
    }

    public async toggleAssetLibraryTile(tile: any) {
        if (!tile) return;
        const id = String(tile.assetId);
        if (tile.type === 'company') {
            if (this.selectedLibCompanyId === id) {
                this.selectedLibCompanyId = '';
                this.companyName = '';
                await this.service.render();
                await this.saveAssetSelection();
            } else {
                await this.selectLibCompany(id);
            }
            return;
        }
        switch (tile.type) {
            case 'consortium':
                await this.toggleLibConsortium(id);
                break;
            case 'personnel':
                await this.toggleLibPersonnel(id);
                break;
            case 'projects':
                await this.toggleLibProject(id);
                break;
            case 'images':
                await this.toggleLibImage(id);
                break;
            case 'general_status':
                await this.toggleLibGeneralStatus(id);
                break;
        }
    }

    // ── Personnel grouping by team (org chart) ──
    public personnelCollapsed: any = {};
    private _personnelByTeam: any[] = [];
    private _personnelByTeamDirty: boolean = true;
    private _orgChart: any = null;

    private static readonly LEADER_POSITIONS = ['대표이사', '센터장', '실장', '팀장', '본부장', '부장'];
    private readonly leaderPositions = ['대표이사', '센터장', '실장', '팀장', '본부장', '부장'];

    public get personnelByTeam(): any[] {
        if (this._personnelByTeamDirty) {
            this._personnelByTeam = this._buildPersonnelByTeam();
            this._orgChart = this._buildOrgChart();
            this._personnelByTeamDirty = false;
        }
        return this._personnelByTeam;
    }

    public get orgChart(): any {
        if (this._personnelByTeamDirty) {
            this._personnelByTeam = this._buildPersonnelByTeam();
            this._orgChart = this._buildOrgChart();
            this._personnelByTeamDirty = false;
        }
        return this._orgChart;
    }

    private _buildOrgChart(): any {
        const groups = this._personnelByTeam;
        let ceo: any = null;
        const centers: any[] = [];
        const teams: any[] = [];
        const centerPositions = ['센터장', '본부장'];

        for (const g of groups) {
            const leader = g.members.find((m: any) => {
                const pos = m.metadata?.position || '';
                return this.leaderPositions.some((lp: string) => pos.includes(lp));
            });
            const members = g.members.filter((m: any) => m !== leader);

            if (leader && (leader.metadata?.position || '').includes('대표이사')) {
                ceo = leader;
                if (members.length > 0) {
                    teams.push({ team: g.team, leader: null, members: members });
                }
            } else {
                const isCenter = leader && centerPositions.some(cp => (leader.metadata?.position || '').includes(cp));
                const target = isCenter ? centers : teams;
                target.push({ team: g.team, leader: leader || null, members: members });
            }
        }
        return { ceo, centers, teams };
    }

    private _buildPersonnelByTeam(): any[] {
        const groups: any = {};
        for (const p of this.assetLibPersonnel) {
            const team = p.metadata?.team || '미지정';
            if (!groups[team]) groups[team] = { team, members: [] };
            groups[team].members.push({
                ...p,
                hasResume: p.has_resume || (p.files && p.files.length > 0)
            });
        }
        // Sort members: leaders first
        const lp = this.leaderPositions;
        for (const g of Object.values(groups) as any[]) {
            g.members.sort((a: any, b: any) => {
                const posA = a.metadata?.position || '';
                const posB = b.metadata?.position || '';
                const idxA = lp.findIndex((p: string) => posA.includes(p));
                const idxB = lp.findIndex((p: string) => posB.includes(p));
                const rankA = idxA >= 0 ? idxA : 999;
                const rankB = idxB >= 0 ? idxB : 999;
                return rankA - rankB || (a.name || '').localeCompare(b.name || '');
            });
        }
        return (Object.values(groups) as any[]).sort((a: any, b: any) => {
            if (a.team === '미지정') return 1;
            if (b.team === '미지정') return -1;
            return a.team.localeCompare(b.team);
        });
    }

    public markPersonnelDirty() {
        this._personnelByTeamDirty = true;
    }

    public async togglePersonnelTeam(team: string) {
        this.personnelCollapsed[team] = !this.personnelCollapsed[team];
        await this.service.render();
    }

    public getTeamSelectedCount(team: string): number {
        const group = this.personnelByTeam.find((g: any) => g.team === team);
        if (!group) return 0;
        return group.members.filter((m: any) => this.selectedLibPersonnelIds[String(m.id)]).length;
    }

    public async toggleTeamAll(team: string) {
        const group = this.personnelByTeam.find((g: any) => g.team === team);
        if (!group) return;
        const allSelected = group.members.every((m: any) => this.selectedLibPersonnelIds[String(m.id)]);
        for (const m of group.members) {
            this.selectedLibPersonnelIds[String(m.id)] = !allSelected;
        }
        await this.service.render();
        await this.saveAssetSelection();
    }

    // ── Guide ──

    private async ensureGuideOptionsLoaded() {
        if (this.guides.length > 0) return;
        try {
            let res = await wiz.call('load_guides', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.guides = res.data.guides || [];
            }
        } catch (e) {
            console.error('loadGuides error', e);
        }
    }

    public setSelectedGuideIds(ids: string[]) {
        this.selectedGuideIds = {};
        for (let id of ids) {
            this.selectedGuideIds[id] = true;
        }
    }

    public isGuideSelected(id: string): boolean {
        return !!this.selectedGuideIds[id];
    }

    public async toggleGuide(id: string, event: any) {
        this.selectedGuideIds[id] = event?.target?.checked ?? !this.selectedGuideIds[id];
        await this.service.render();
    }

    public async setGuidePanelTab(tab: 'guides' | 'styles') {
        this.guidePanelTab = tab;
        await this.service.render();
    }

    public async setProposalStyle(styleId: string) {
        styleId = this.normalizeStyleProfile(styleId);
        if (this.currentStyleProfile === styleId) return;
        this.currentStyleProfile = styleId;
        await this.service.render();
        try {
            await wiz.call('save_workspace_settings', {
                notice_no: this.notice_no,
                style_profile: styleId,
            });
        } catch (e) {
            console.error(e);
        }
        await this.service.render();
    }

    private normalizeStyleProfile(styleId: string): string {
        const ids = ['bid_reference', 'technical_blueprint', 'executive_summary'];
        return ids.includes(styleId) ? styleId : 'bid_reference';
    }

    public getStyleColors(styleId: string): string[] {
        switch (styleId) {
            case 'technical_blueprint': return ['#123a5d', '#0ea5a4', '#eef6f7'];
            case 'executive_summary': return ['#263238', '#2f7d68', '#f2f5f3'];
            default: return ['#0f3057', '#c9a437', '#ffffff'];
        }
    }

    public async adjustTargetPages(delta: number) {
        this.targetPages = this.normalizeTargetPages((this.targetPages || 100) + delta);
        await this.service.render();
    }

    public onTargetPagesInput(event: Event) {
        const input = event?.target as HTMLInputElement | null;
        this.targetPages = this.normalizeTargetPages(input?.value);
        void this.service.render();
    }

    private normalizeTargetPages(value: any): number {
        const numeric = Number(value) || 100;
        return Math.max(50, Math.min(300, Math.round(numeric / 10) * 10));
    }

    public async setModel(model: string) {
        if (!model) return;
        model = this.normalizeModelId(model);
        if (this.generationMode === 'codex_autonomous') {
            model = 'codex';
        }
        if (this.currentModel === model) return;

        this.currentModel = model;
        this.rebuildModelOptions();
        await this.service.render();

        try {
            await wiz.call('save_workspace_settings', {
                notice_no: this.notice_no,
                model: model,
                generation_mode: this.generationMode,
            });
        } catch (e) {
            console.error(e);
        }
        await this.service.render();
    }

    public async setGenerationMode(mode: 'structured' | 'codex_autonomous') {
        this.generationMode = mode;
        if (mode === 'codex_autonomous') {
            this.currentModel = 'codex';
            this.rebuildModelOptions();
        }
        await this.service.render();

        try {
            await wiz.call('save_workspace_settings', {
                notice_no: this.notice_no,
                model: this.currentModel,
                generation_mode: mode,
            });
        } catch (e) {
            console.error(e);
        }
        await this.service.render();
    }

    public async selectProposalModel(model: string) {
        if (!model) return;
        if (this.generationMode !== 'structured') {
            this.generationMode = 'structured';
        }
        await this.setModel(model);
    }

    public async toggleContentOption(optionId: string) {
        const option = this.proposalContentOptions.find((item: any) => item.id === optionId);
        if (!option) return;
        option.enabled = !option.enabled;
        this.proposalContentOptions = [...this.proposalContentOptions];
        await this.service.render();
    }

    public openAssetLibrary() {
        window.open('/library', '_blank', 'noopener');
    }

    public async openReferenceUrlImport() {
        const url = (window.prompt('가져올 이미지 URL을 입력하세요.') || '').trim();
        if (!url) return;
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const blob = await response.blob();
            const rawName = decodeURIComponent((url.split('/').pop() || '').split('?')[0] || 'remote-image');
            const ext = (blob.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
            const fileName = /\.[a-z0-9]+$/i.test(rawName) ? rawName : `${rawName}.${ext}`;
            const file = new File([blob], fileName, { type: blob.type || 'application/octet-stream' });
            await this.uploadAssets([file], 'proposal_logo', '표지 기관 로고');
        } catch (e) {
            console.error(e);
            window.alert('URL 파일을 가져오지 못했습니다. 접근 가능한 이미지 URL인지 확인하세요.');
        }
    }

    public onUploadZoneDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    public async onReferenceAssetDrop(category: string, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const files = Array.from(event.dataTransfer?.files || []) as File[];
        if (files.length === 0) return;
        let slot = this.referenceAssetSlots.find((item: any) => item.id === category);
        await this.uploadAssets(files, category, slot?.title || slot?.label || '참고 자료');
    }

    public async startProposalGeneration() {
        if (this.generationMode !== 'structured') {
            this.generationMode = 'structured';
            try {
                await wiz.call('save_workspace_settings', {
                    notice_no: this.notice_no,
                    model: this.currentModel,
                    generation_mode: this.generationMode,
                });
            } catch (e) {
                console.error(e);
            }
        }
        await this.startFullGeneration();
    }

    private normalizeModelId(model: string): string {
        if (model === 'gpt' || model === 'gemini') return 'qwen3.6:35b-a3b';
        if (model === 'ollama') return 'qwen3.6:35b-a3b';
        if (model === 'qwen') return 'qwen3.6:35b-a3b';
        if (model && (model.startsWith('gpt') || model.startsWith('gemini'))) return 'qwen3.6:35b-a3b';
        return model || 'qwen3.6:35b-a3b';
    }


public async toggleHarnessPreview(forceReload: boolean = false) {
    if (this.harnessPreviewOpen && !forceReload) {
        this.harnessPreviewOpen = false;
        await this.service.render();
        return;
    }

    this.harnessPreviewOpen = true;
    await this.loadHarnessPreview(forceReload || !this.harnessPreview);
}

public async refreshHarnessPreview() {
    await this.loadHarnessPreview(true);
}

private async loadHarnessPreview(forceReload: boolean = false) {
    if (this.harnessPreviewLoading) return;
    if (!forceReload && this.harnessPreview) {
        await this.service.render();
        return;
    }

    this.harnessPreviewLoading = true;
    this.harnessPreviewError = '';
    await this.service.render();

    try {
        let res = await wiz.call('preview_generation_harness', {
            notice_no: this.notice_no,
            model: this.currentModel,
            guide_ids: this.selectedGuideIdList.join(','),
            company_name: this.companyName,
            target_pages: this.targetPages,
            style_profile: this.currentStyleProfile,
        });
        if (res.code !== 200) {
            throw new Error(res?.data?.message || '하네스 미리보기를 불러오지 못했습니다.');
        }
        this.harnessPreview = res.data;
    } catch (e: any) {
        this.harnessPreviewError = e?.message || '하네스 미리보기를 불러오지 못했습니다.';
    }

    this.harnessPreviewLoading = false;
    await this.service.render();
}

    // ── Full generation (one-click) ──

    public async startFullGeneration(forceRegenerate: boolean = false) {
        if (this.generating) return;
        if (this.isCodexRfp || this.generationMode === 'codex_autonomous') {
            await this.openCodexWorkspace();
            await this.setCodexWorkflowStage('proposal_design');
            return;
        }
        this.step = 'generating';
        this.generating = true;
        this.generationProgress = 0;
        this.generationEta = '-';
        this.generationPhase = forceRegenerate ? '전체 재생성 준비 중...' : '서버 연결 중...';
        this.generationMessage = forceRegenerate ? '기존 섹션을 모두 다시 작성합니다.' : '';
        this.generationLogs = [];
        this.generationStartedAt = Date.now();
        this.appendGenerationLog(
            forceRegenerate ? '전체 재생성 시작' : '생성 시작',
            forceRegenerate
                ? `${this.currentModelLabel}로 기존 섹션을 포함해 제안서를 다시 생성합니다.`
                : (this.generationMode === 'codex_autonomous'
                    ? 'Codex 제안서 설계 흐름으로 RFP 기반 디자인 분석과 목차 설계를 진행합니다.'
                    : `${this.currentModelLabel}로 제안서 자동 생성을 시작합니다.`),
            'info'
        );
        await this.service.render();
        this.resetWorkspaceScroll();

        this.sseAbortController = new AbortController();

        const MAX_RETRIES = 5;
        let retryCount = 0;
        let isFirstAttempt = true;
        let receivedAllDone = false;
        let finalEvent: any = null;

        while (retryCount <= MAX_RETRIES && !receivedAllDone) {
            try {
                let formData = new FormData();
                formData.append('notice_no', this.notice_no);
                formData.append('model', this.currentModel);
                formData.append('generation_mode', this.generationMode);
                formData.append('guide_ids', this.selectedGuideIdList.join(','));
                formData.append('company_name', this.companyName);
                formData.append('target_pages', String(this.targetPages));
                formData.append('style_profile', this.currentStyleProfile);
                formData.append('force', (forceRegenerate && isFirstAttempt) ? '1' : '0');
                let _assetPayload = this.buildLibAssetSelection();
                if (isFirstAttempt) {
                    console.log('[ASSET] 전송값:', { company_id: _assetPayload.company_id, personnel_ids: _assetPayload.personnel_ids, project_ids: _assetPayload.project_ids, consortium_ids: _assetPayload.consortium_ids, image_ids: _assetPayload.image_ids });
                }
                formData.append('asset_selection', JSON.stringify(_assetPayload));

                let response = await fetch(wiz.url('stream_generate_full'), {
                    method: 'POST',
                    body: formData,
                    signal: this.sseAbortController.signal,
                });

                if (!response.ok || !response.body) {
                    let payload: any = null;
                    try { payload = await response.json(); } catch { }
                    throw new Error(payload?.data?.message || payload?.message || '스트리밍 연결에 실패했습니다.');
                }

                let reader = response.body.getReader();
                let decoder = new TextDecoder();
                let buffer = '';

                while (true) {
                    let { done, value } = await reader.read();
                    if (done) break;
                    buffer += decoder.decode(value, { stream: true });
                    let lines = buffer.split('\n\n');
                    buffer = lines.pop() || '';
                    for (let line of lines) {
                        if (!line.startsWith('data: ')) continue;
                        try {
                            let eventData = JSON.parse(line.slice(6));
                            if (eventData.type === 'all_done') {
                                receivedAllDone = true;
                                finalEvent = eventData;
                            }
                            await this.handleSSEEvent(eventData);
                        } catch { }
                    }
                }
                if (buffer.startsWith('data: ')) {
                    try {
                        let eventData = JSON.parse(buffer.slice(6));
                        if (eventData.type === 'all_done') {
                            receivedAllDone = true;
                            finalEvent = eventData;
                        }
                        await this.handleSSEEvent(eventData);
                    } catch { }
                }

                if (receivedAllDone) break;

                // Stream ended without all_done - connection was dropped
                retryCount++;
                if (retryCount <= MAX_RETRIES) {
                    this.appendGenerationLog('재연결', `네트워크 연결이 끊겼습니다. 자동 재연결 중... (${retryCount}/${MAX_RETRIES})`, 'info');
                    this.generationPhase = `재연결 중... (${retryCount}/${MAX_RETRIES})`;
                    await this.service.render();
                    await new Promise(r => setTimeout(r, 2000));
                    isFirstAttempt = false;
                }
            } catch (e: any) {
                if (e.name === 'AbortError') return;
                retryCount++;
                if (retryCount <= MAX_RETRIES) {
                    this.appendGenerationLog('재연결', `연결 오류 발생. 자동 재연결 중... (${retryCount}/${MAX_RETRIES})`, 'info');
                    this.generationPhase = `재연결 중... (${retryCount}/${MAX_RETRIES})`;
                    await this.service.render();
                    await new Promise(r => setTimeout(r, 2000));
                    isFirstAttempt = false;
                } else {
                    this.appendGenerationLog('오류', e.message || '알 수 없는 오류가 발생했습니다. 페이지를 새로고침 후 다시 시도해주세요.', 'error');
                }
            }
        }

        this.sseAbortController = null;
        if (this.generating) {
            this.generating = false;
            this.generationPhase = receivedAllDone && finalEvent?.ok !== false ? '완료' : '생성 미완료';
            if (!receivedAllDone) {
                this.appendGenerationLog('생성 미완료', '완료 이벤트를 받지 못했습니다. 실패한 섹션만 다시 생성해 주세요.', 'error');
            }
            try {
                let res = await wiz.call('load', { notice_no: this.notice_no });
                if (res.code === 200) {
                    this.sections = res.data.sections || [];
                }
            } catch (_e) {}
            this.step = this.sections.some((s: any) => s.status === 'done' && s.content) ? 'result' : 'setup';
            this.refreshHtmlPreview(false);
            this.refreshPdfPreview(false);
        }
        await this.service.render();
    }

    private async handleSSEEvent(event: any) {
        let type = event.type;

        if (type === 'phase') {
            this.generationPhase = event.message || event.phase || '';
            this.generationProgress = event.progress || this.generationProgress;
            if (event.message) {
                this.appendGenerationLog(event.phase || '단계', event.message, 'info');
            }
        }

        if (type === 'toc_created') {
            this.sections = event.sections || [];
            this.generationPhase = '목차 생성 완료';
            this.generationProgress = event.progress || 10;
            this.appendGenerationLog('목차 생성 완료', `${this.sections.length}개 섹션이 준비되었습니다.`, 'done');
        }

        if (type === 'sections_ready') {
            this.sections = event.sections || [];
            this.generationPhase = '섹션 타임라인 준비';
            this.generationProgress = event.progress || this.generationProgress || 10;
            this.generationMessage = `${this.sections.length}개 작성 섹션을 순서대로 준비했습니다.`;
            this.appendGenerationLog('섹션 타임라인 준비', `${this.sections.length}개 작성 섹션을 불러왔습니다.`, 'info');
        }

        if (type === 'start') {
            this.generationPhase = event.force ? '전체 재생성 진행 중' : '섹션 초안 생성';
            this.generationMessage = event.force
                ? `${event.pending}개 섹션을 다시 생성합니다.`
                : `${event.pending}개 섹션을 생성합니다.`;
            this.appendGenerationLog(
                event.force ? '전체 재생성 진행' : '섹션 생성 시작',
                event.force ? `총 ${event.total}개 섹션을 순서대로 다시 작성합니다.` : `총 ${event.total}개 섹션`,
                'info'
            );
        }

        if (type === 'section_start') {
            this.generationPhase = event.label;
            this.generationProgress = event.progress || this.generationProgress;
            this.updateEta(event.eta);
            this.appendGenerationLog(`${event.label} 생성 시작`, '초안을 작성하는 중입니다.', 'info');
            let target = this.sections.find((s: any) => s.id === event.section_id);
            if (target) target._generating = true;
        }

        if (type === 'heartbeat') {
            this.generationPhase = event.message || event.label || this.generationPhase;
            this.generationProgress = event.progress || this.generationProgress;
            this.updateEta(event.eta);
        }

        if (type === 'section_done') {
            let target = this.sections.find((s: any) => s.id === event.section_id);
            if (event.content) {
                this.applySectionUpdate(event.section_id, event.content, 'done');
            } else if (target) {
                target.status = 'done';
            }
            if (target) target._generating = false;
            this.generationProgress = event.progress || this.generationProgress;
            this.updateEta(event.eta);
            this.appendGenerationLog(`${event.label} 완료`, event.preview || '생성 완료', 'done');
        }

        if (type === 'section_error') {
            let target = this.sections.find((s: any) => s.id === event.section_id);
            if (target) {
                target._generating = false;
                target.status = 'error';
                target.ai_content = event.message || '';
            }
            this.appendGenerationLog(`${event.label} 실패`, event.message || '오류', 'error');
        }

        if (type === 'all_done') {
            let failedCount = Number(event.failed || 0);
            let total = Number(event.total || 0);
            let completed = Number(event.completed || 0);
            let ok = event.ok !== false && failedCount === 0 && (total === 0 || completed >= total);
            this.generating = false;
            this.generationProgress = ok ? 100 : (total > 0 ? Math.round((completed / total) * 100) : this.generationProgress);
            this.generationEta = '0초';
            this.generationPhase = ok ? '제안서 생성 완료' : '일부 섹션 생성 실패';
            if (ok) {
                this.appendGenerationLog('전체 완료', `${completed}/${total} 섹션, ${this.formatDuration((event.elapsed || 0) * 1000)} 소요`, 'done');
            } else {
                this.appendGenerationLog('생성 미완료', `${completed}/${total} 섹션 완료, ${failedCount}개 실패`, 'error');
                for (let failure of (event.failures || []).slice(0, 5)) {
                    this.appendGenerationLog(`${failure.label || '섹션'} 실패`, failure.message || '오류', 'error');
                }
            }
            try {
                let res = await wiz.call('load', { notice_no: this.notice_no });
                if (res.code === 200) {
                    this.sections = res.data.sections || [];
                }
            } catch (_e) {}
            this.step = 'result';
            this.refreshHtmlPreview(false);
            this.refreshPdfPreview(false);
        }

        await this.service.render();
    }

    private updateEta(seconds: number) {
        if (!seconds || seconds <= 0) { this.generationEta = '0초'; return; }
        this.generationEta = this.formatDuration(seconds * 1000);
    }

    private abortSSE() {
        if (this.sseAbortController) {
            this.sseAbortController.abort();
            this.sseAbortController = null;
        }
    }

    public async abortGeneration() {
        this.abortSSE();
        this.generating = false;
        this.generationPhase = '사용자 중단';
        this.appendGenerationLog('생성 중단', '사용자가 생성을 중단했습니다.', 'error');
        this.step = this.sections.some((s: any) => s.status === 'done' && s.content) ? 'result' : 'setup';
        if (this.step === 'result') this.refreshPdfPreview(false);
        await this.service.render();
    }

    private appendGenerationLog(title: string, detail: string, status: string) {
        let now = new Date();
        let time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        this.generationLogs.push({ title, detail, status, time });
    }

    private applySectionUpdate(sectionId: string, content: string, status: string = 'done') {
        let target = this.sections.find((s: any) => s.id === sectionId);
        if (!target) return;

        target.content = content;
        target.ai_content = content;
        target.status = status;

        if (this.editingSection?.id === sectionId) {
            this.editingSection = target;
            this.editingDraft = content || '';
        }

        if (this.aiEditSection?.id === sectionId) {
            this.aiEditSection = target;
        }

        if (this.chatSection?.id === sectionId) {
            this.chatSection = target;
        }
    }

    // ── Section operations ──

    public async generateSection(section: any) {
        if (section._generating) return;
        section._generating = true;
        section._generatingPhase = 'RFP 맥락을 분석하고 있습니다...';
        await this.service.render();

        const phases = [
            { msg: '섹션 구조를 설계하고 있습니다...', delay: 4000 },
            { msg: 'AI가 초안을 작성하고 있습니다...', delay: 9000 },
            { msg: '내용을 보강하고 있습니다...', delay: 18000 },
            { msg: '거의 완료되었습니다...', delay: 30000 },
        ];
        let phaseTimers: any[] = [];
        for (let p of phases) {
            phaseTimers.push(setTimeout(async () => {
                if (section._generating) {
                    section._generatingPhase = p.msg;
                    await this.service.render();
                }
            }, p.delay));
        }

        try {
            let res = await wiz.call('generate_section', {
                notice_no: this.notice_no,
                section_id: section.id,
                model: this.currentModel,
                guide_ids: this.selectedGuideIdList.join(','),
                target_pages: this.targetPages,
            });
            if (res.code === 200) {
                this.applySectionUpdate(section.id, res.data.content, 'done');
            } else {
                section.status = 'error';
                section.ai_content = res.data?.message || '섹션 생성에 실패했습니다.';
            }
        } catch (e) {
            console.error(e);
            section.status = 'error';
        }

        for (let t of phaseTimers) clearTimeout(t);
        section._generating = false;
        section._generatingPhase = '';
        this.refreshHtmlPreview(false);
        this.refreshPdfPreview(false);
        await this.service.render();
    }

    public async startEdit(section: any) {
        this.aiEditSection = null;
        this.editingSection = section;
        this.editingDraft = section.content || '';
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingSection = null;
        this.editingDraft = '';
        await this.service.render();
    }

    public async saveSection(section: any) {
        try {
            await wiz.call('save_section', { section_id: section.id, content: this.editingDraft });
            this.applySectionUpdate(section.id, this.editingDraft, 'done');
        } catch (e) {
            console.error(e);
        }
        this.editingSection = null;
        this.editingDraft = '';
        this.refreshHtmlPreview(false);
        this.refreshPdfPreview(false);
        await this.service.render();
    }

    // ── Section AI Edit ──

    public async startAiEdit(section: any) {
        if (this.aiEditSection === section) {
            this.aiEditSection = null;
            this.aiEditInstruction = '';
            this.aiEditError = '';
            await this.service.render();
            return;
        }
        this.editingSection = null;
        this.aiEditSection = section;
        this.aiEditInstruction = '';
        this.aiEditError = '';
        this.activeSectionNo = section.section_no;
        await this.service.render();
    }

    public async cancelAiEdit() {
        this.aiEditSection = null;
        this.aiEditInstruction = '';
        this.aiEditError = '';
        await this.service.render();
    }

    private startAiEditPhases() {
        const phases = [
            { msg: '지시사항을 분석하고 있습니다...', delay: 0 },
            { msg: '원문 섹션을 검토하고 있습니다...', delay: 3000 },
            { msg: 'AI가 내용을 수정하고 있습니다...', delay: 7000 },
            { msg: '수정 결과를 정리하고 있습니다...', delay: 15000 },
            { msg: '거의 완료되었습니다...', delay: 25000 },
        ];
        this.aiEditPhase = phases[0].msg;
        this.service.render();
        for (let i = 1; i < phases.length; i++) {
            let timer = setTimeout(async () => {
                if (this.aiEditLoading) {
                    this.aiEditPhase = phases[i].msg;
                    await this.service.render();
                }
            }, phases[i].delay);
            this.aiEditPhaseTimer = timer;
        }
    }

    private stopAiEditPhases() {
        if (this.aiEditPhaseTimer) {
            clearTimeout(this.aiEditPhaseTimer);
            this.aiEditPhaseTimer = null;
        }
        this.aiEditPhase = '';
    }

    public async submitAiEdit(section: any) {
        let instruction = (this.aiEditInstruction || '').trim();
        if (!instruction || this.aiEditLoading) return;
        let applied = false;
        this.aiEditLoading = true;
        this.aiEditError = '';
        this.startAiEditPhases();
        await this.service.render();

        try {
            let res = await wiz.call('chat_edit_section', {
                notice_no: this.notice_no,
                section_id: section.id,
                instruction: instruction,
                model: this.currentModel,
                guide_ids: this.selectedGuideIdList.join(','),
            });
            if (res.code === 200) {
                if (res.data.modification_failed || !res.data.content) {
                    this.aiEditError = res.data.reply || res.data.message || '실제 수정이 적용되지 않았습니다. 지시를 더 구체적으로 입력해 주세요.';
                } else {
                    this.applySectionUpdate(section.id, res.data.content, 'done');
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    applied = true;
                }
            }
        } catch (e: any) {
            console.error(e);
            this.aiEditError = e.message || '실제 수정 적용 중 오류가 발생했습니다.';
        }

        this.stopAiEditPhases();
        this.aiEditLoading = false;
        if (applied) {
            this.aiEditSection = null;
            this.aiEditInstruction = '';
            this.aiEditError = '';
        }
        await this.service.render();
    }

    public async chatAboutSection(section: any) {
        await this.requestCodexForSection(section);
    }

    public async clearChatSection() {
        this.chatSection = null;
        await this.service.render();
    }

    // ── Preview ──

    private clearProposalPreview() {
        this.actualPageCount = 0;
        this.currentPageIdx = 0;
        this._previewIframeEl = null;
        this.pdfPreviewUrl = '';
        this.htmlPreviewUrl = '';
        this.editablePreviewUrl = '';
        this.htmlEditMode = false;
    }

    public refreshPdfPreview(render: boolean = true) {
        if (this.isCodexRfp) {
            this.clearProposalPreview();
            if (render) this.service.render();
            return;
        }
        this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.buildApiUrl('preview_proposal_pdf', {
            notice_no: this.notice_no,
            _: Date.now(),
        }));
        if (render) this.service.render();
    }

    public refreshHtmlPreview(render: boolean = true) {
        if (this.isCodexRfp) {
            this.clearProposalPreview();
            if (render) this.service.render();
            return;
        }
        this.actualPageCount = 0;
        this.currentPageIdx = 0;
        this._previewIframeEl = null;
        this.htmlPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.buildApiUrl('preview_proposal_html', {
            notice_no: this.notice_no,
            _: Date.now(),
        }));
        if (render) this.service.render();
    }

    private _injectFitWidthMode(doc: Document) {
        if (!doc) return;
        if (doc.getElementById('__fit_width_mode_style')) return;
        const style = doc.createElement('style');
        style.id = '__fit_width_mode_style';
        // HTML preview chrome only. Do not override each page's display mode:
        // Codex autonomous documents use grid-based cover/body layouts, and
        // forcing `.page { display:flex }` breaks HTML preview while PDF stays fine.
        style.textContent = `
            html, body {
                margin: 0 !important;
                padding: 0 !important;
                background: #525659 !important;
                overflow-x: hidden !important;
                overflow-y: auto !important;
            }
            body {
                display: block !important;
                padding: 16px 0 !important;
            }
            .page, .page.paginated {
                margin: 0 auto 16px auto !important;
                box-shadow: 0 2px 8px rgba(0,0,0,0.4) !important;
                overflow: hidden !important;
            }
        `;
        doc.head.appendChild(style);
    }

    private _applyFitWidth() {
        const iframe = this._previewIframeEl;
        if (!iframe) return;
        const win = iframe.contentWindow;
        const doc = win?.document;
        if (!doc || !win) return;
        const pages = doc.querySelectorAll<HTMLElement>('.page');
        if (pages.length === 0) return;

        // iframe 가용 너비 (스크롤바 폭 약 16px 고려)
        const vw = win.innerWidth || 1;
        const padX = 32;   // 좌우 여백
        const naturalWidth = pages[0].offsetWidth || 794;
        const scale = Math.min((vw - padX) / naturalWidth, 1.0);  // 최대 100% (확대는 안 함)

        // body에 zoom을 적용하면 layout까지 영향 → 세로 스크롤이 자연스럽게 동작
        // (zoom은 Chromium/Webkit에서 1순위, Firefox 126+도 지원)
        (doc.body.style as any).zoom = String(scale);
    }

    private _bindResizeListener(win: Window) {
        if ((win as any).__proposalPreviewResizeBound) return;
        (win as any).__proposalPreviewResizeBound = true;
        win.addEventListener('resize', () => this._applyFitWidth());
    }

    private _bindPreviewScrollListener(win: Window) {
        if ((win as any).__proposalPreviewScrollBound) return;
        (win as any).__proposalPreviewScrollBound = true;
        const syncVisiblePage = async () => {
            try {
                const doc = win.document;
                const pages = Array.from(doc.querySelectorAll<HTMLElement>('.page'));
                if (!pages.length) return;
                let bestIdx = 0;
                let bestDistance = Number.MAX_SAFE_INTEGER;
                const anchorY = 24;
                pages.forEach((page: HTMLElement, idx: number) => {
                    const rect = page.getBoundingClientRect();
                    const distance = Math.abs(rect.top - anchorY);
                    if (distance < bestDistance) {
                        bestDistance = distance;
                        bestIdx = idx;
                    }
                });
                if (this.currentPageIdx !== bestIdx) {
                    this.currentPageIdx = bestIdx;
                    await this.service.render();
                }
            } catch (e) {
                console.error('preview page sync failed', e);
            }
        };
        win.addEventListener('scroll', () => { void syncVisiblePage(); }, { passive: true });
        setTimeout(() => { void syncVisiblePage(); }, 80);
    }

    public onHtmlPreviewLoad(event: Event) {
        const iframe = event.target as HTMLIFrameElement;
        if (!iframe) return;
        this._previewIframeEl = iframe;

        const syncPageCount = async () => {
            try {
                const win = iframe.contentWindow;
                const doc = win?.document;
                if (!doc || !win) return;
                this._injectFitWidthMode(doc);
                this._bindResizeListener(win);
                this._bindPreviewScrollListener(win);
                const pageCount = doc.querySelectorAll('.page').length || 0;
                if (pageCount > 0 && this.actualPageCount !== pageCount) {
                    this.actualPageCount = pageCount;
                    await this.service.render();
                }
                this._applyFitWidth();
            } catch (e) {
                console.error('preview page count sync failed', e);
            }
        };

        try {
            iframe.contentWindow?.document?.addEventListener('paginateDone', () => {
                void syncPageCount();
            }, { once: true });
        } catch (e) {
            console.error('paginateDone bind failed', e);
        }

        void syncPageCount();
        setTimeout(() => { void syncPageCount(); }, 1200);
        setTimeout(() => { void syncPageCount(); }, 2500);
    }

    public async setPreviewTab(tab: 'html' | 'pdf') {
        this.previewTab = tab;
        if (tab === 'html') {
            this.refreshHtmlPreview(false);
        }
        if (tab === 'pdf') {
            this.refreshPdfPreview(false);
        }
        await this.service.render();
    }

    public refreshPreview() {
        if (this.previewTab === 'html') {
            this.refreshHtmlPreview();
        } else {
            this.refreshPdfPreview();
        }
    }

    public openPreviewNewWindow() {
        if (this.previewTab === 'html') {
            window.open(this.buildApiUrl('preview_proposal_html', { notice_no: this.notice_no, _: Date.now() }), '_blank');
        } else {
            window.open(this.buildApiUrl('preview_proposal_pdf', { notice_no: this.notice_no, _: Date.now() }), '_blank');
        }
    }

    public openPdfPreview() {
        if (this.isCodexRfp) return;
        window.open(this.buildApiUrl('preview_proposal_pdf', { notice_no: this.notice_no, _: Date.now() }), '_blank');
    }

    private extractDownloadError(rawText: string): string {
        if (!rawText) return '';
        try {
            const payload = JSON.parse(rawText);
            const data = payload?.data || {};
            const message = data?.message || data?.error || payload?.message || payload?.error;
            if (message) return String(message).trim().slice(0, 260);
        } catch { }
        return rawText
            .replace(/<style[\s\S]*?<\/style>/gi, ' ')
            .replace(/<script[\s\S]*?<\/script>/gi, ' ')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 260);
    }

    private sanitizeDownloadFilename(value: string): string {
        const name = String(value || '').replace(/[\\/:*?"<>|]+/g, '_').replace(/\s+/g, ' ').trim();
        return (name || 'proposal').slice(0, 90);
    }

    private downloadFilenameFromHeader(contentDisposition: string | null): string {
        const value = contentDisposition || '';
        const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(value);
        if (encoded?.[1]) {
            try {
                return decodeURIComponent(encoded[1].replace(/^["']|["']$/g, ''));
            } catch { }
        }
        const quoted = /filename\s*=\s*"([^"]+)"/i.exec(value);
        if (quoted?.[1]) return quoted[1];
        const plain = /filename\s*=\s*([^;]+)/i.exec(value);
        return plain?.[1]?.trim() || '';
    }

    private async pdfBlobFromResponse(response: Response): Promise<Blob> {
        const buffer = await response.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const isPdf = bytes.length >= 5
            && bytes[0] === 0x25
            && bytes[1] === 0x50
            && bytes[2] === 0x44
            && bytes[3] === 0x46
            && bytes[4] === 0x2d;

        if (!response.ok || !isPdf) {
            let rawText = '';
            try {
                rawText = new TextDecoder('utf-8').decode(bytes);
            } catch { }
            const message = this.extractDownloadError(rawText)
                || `PDF 파일이 아닌 응답을 받았습니다. (${response.status})`;
            throw new Error(message);
        }

        return new Blob([bytes], { type: 'application/pdf' });
    }

    public async exportProposal() {
        if (this.isCodexRfp) return;
        if (this.pdfDownloading) return;

        this.pdfDownloading = true;
        await this.service.render();
        try {
            const response = await fetch(this.buildApiUrl('export_proposal', { notice_no: this.notice_no, _: Date.now() }), {
                method: 'GET',
                credentials: 'same-origin',
            });
            const blob = await this.pdfBlobFromResponse(response);
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            const filename = this.downloadFilenameFromHeader(response.headers.get('Content-Disposition'))
                || `${this.sanitizeDownloadFilename(this.item?.title || this.notice_no || 'proposal')}.pdf`;
            anchor.href = objectUrl;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        } catch (e: any) {
            await this.service.modal.show({ title: 'PDF 다운로드 실패', message: e?.message || 'PDF 파일을 생성하지 못했습니다.', cancel: false, action: '확인' });
        } finally {
            this.pdfDownloading = false;
            await this.service.render();
        }
    }

    // ── HTML Edit Mode ──
    public editablePreviewUrl: SafeResourceUrl | string = '';
    private messageHandler: any = null;

    public async enterHtmlEditMode() {
        if (this.isCodexRfp) return;
        this.htmlEditSaving = false;
        this.previewTab = 'html';
        this.editablePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.buildApiUrl('preview_proposal_html_editable', { notice_no: this.notice_no, _: Date.now() })
        );
        this.htmlEditMode = true;
        await this.service.render();
    }

    public async exitHtmlEditMode(save: boolean = false) {
        if (save) {
            this.htmlEditSaving = true;
            await this.service.render();

            // iframe에 섹션 데이터 요청
            const editData: any = await new Promise((resolve) => {
                const handler = (e: MessageEvent) => {
                    if (e.data?.type === 'sectionsData') {
                        window.removeEventListener('message', handler);
                        resolve(e.data);
                    }
                };
                window.addEventListener('message', handler);
                const iframe = this.elementRef.nativeElement.querySelector('.edit-frame') as HTMLIFrameElement;
                if (iframe?.contentWindow) {
                    iframe.contentWindow.postMessage({ type: 'getSections' }, '*');
                } else {
                    console.error('[EditMode] iframe not found or no contentWindow');
                    resolve({ sections: [] });
                }
                // 5초 타임아웃
                setTimeout(() => { window.removeEventListener('message', handler); resolve({ sections: [] }); }, 5000);
            });

            const sections = editData.sections || [];
            console.log('[EditMode] sections received:', sections.length);

            // 모든 섹션 저장 (designMode에서 dirty 감지가 제한적이므로)
            let savedCount = 0;
            for (const sec of sections) {
                if (sec.id && sec.html) {
                    console.log(`[EditMode] saving section ${sec.id}, html_len=${sec.html.length}, preview=${sec.html.substring(0, 100)}`);
                    try {
                        const res = await wiz.call('save_section_html', {
                            notice_no: this.notice_no,
                            section_id: sec.id,
                            html: sec.html,
                        });
                        console.log(`[EditMode] save response for ${sec.id}:`, res?.code, res?.data);
                        savedCount++;
                    } catch (e) {
                        console.error('[EditMode] save failed for section', sec.id, e);
                    }
                }
            }

            // 표지/목차 HTML 저장
            if (editData.coverHtml || editData.tocHtml) {
                try {
                    const res = await wiz.call('save_cover_toc_html', {
                        notice_no: this.notice_no,
                        cover_html: editData.coverHtml || '',
                        toc_html: editData.tocHtml || '',
                    });
                    console.log('[EditMode] cover/toc save response:', res?.code, res?.data);
                } catch (e) {
                    console.error('[EditMode] cover/toc save failed', e);
                }
            }

            // 저장 후 검증: 첫 번째 섹션의 DB 내용 확인
            if (sections.length > 0) {
                const verifyRes = await wiz.call('debug_section_content', { section_id: sections[0].id });
                console.log('[EditMode] DB verify:', verifyRes?.data);
            }
            console.log('[EditMode] saved:', savedCount, '/', sections.length);
            this.htmlEditSaving = false;
        }
        this.htmlEditMode = false;
        this.editablePreviewUrl = '';
        if (save) this.refreshHtmlPreview();
        await this.service.render();
    }

    public openUploadedDocument(doc: any) {
        if (!doc?.id) return;
        window.open(this.buildApiUrl('download_rfp_document', { doc_id: doc.id, _: Date.now() }), '_blank');
    }

    public downloadUploadedDocument(doc: any) {
        if (!doc?.id) return;
        window.open(this.buildApiUrl('download_rfp_document', { doc_id: doc.id, download: 1, _: Date.now() }), '_blank');
    }

    private buildApiUrl(fn: string, params: any = {}): string {
        let base = wiz.url(fn);
        let qs = Object.entries(params).map(([k, v]: any) => `${k}=${encodeURIComponent(v)}`).join('&');
        return qs ? `${base}?${qs}` : base;
    }

    // ── Assets ──

    public getReferenceAssets(category: string): any[] {
        return this.workspaceAssets.filter((asset: any) => asset.category === category);
    }

    public getReferenceSlotAccept(slot: any): string {
        return slot?.accept || this.assetAcceptedExtensions;
    }

    public getReferenceAssetUrl(asset: any): string {
        if (!asset?.id) return '';
        return this.buildApiUrl('download_reference_asset', { notice_no: this.notice_no, asset_id: asset.id, _: this.referenceAssetUrlVersion });
    }

    public isReferenceImageAsset(asset: any): boolean {
        let type = String(asset?.file_type || '').toLowerCase();
        let name = String(asset?.file_name || '').toLowerCase();
        return ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg'].includes(type) || /\.(png|jpe?g|webp|gif|svg)$/i.test(name);
    }

    public isReferenceEmptySelected(category: string): boolean {
        return this.getReferenceAssets(category).length === 0 && !!this.assetSlotEmpty[category];
    }

    public async toggleReferenceEmpty(category: string) {
        if (this.getReferenceAssets(category).length > 0) return;
        this.assetSlotEmpty = { ...this.assetSlotEmpty, [category]: !this.assetSlotEmpty[category] };
        await this.saveAssetSlotSettings();
        await this.service.render();
    }

    private async saveAssetSlotSettings() {
        try {
            let res = await wiz.call('save_workspace_settings', {
                notice_no: this.notice_no,
                asset_slot_empty: JSON.stringify(this.assetSlotEmpty),
            });
            if (res.code === 200 && res.data?.settings?.asset_slot_empty) {
                this.assetSlotEmpty = res.data.settings.asset_slot_empty;
            }
        } catch (e) {
            console.error(e);
        }
    }

    public async onReferenceAssetFileChange(category: string, event: any) {
        let files: File[] = Array.from(event.target.files || []);
        event.target.value = '';
        if (files.length === 0) return;
        let slot = this.referenceAssetSlots.find((item: any) => item.id === category);
        await this.uploadAssets(files, category, slot?.title || slot?.label || '참고 자료');
    }

    public async uploadAssets(files: File[], category: string, title: string = '') {
        if (this.assetUploading || files.length === 0) return;
        this.assetUploading = true;
        await this.service.render();

        try {
            let formData = new FormData();
            formData.append('notice_no', this.notice_no);
            formData.append('category', category);
            formData.append('title', title || '참고 자료');
            formData.append('description', '');
            for (let f of files) formData.append('file', f);

            let response = await fetch(wiz.url('upload_reference_asset'), { method: 'POST', body: formData });
            let result = await response.json();
            if (result.code === 200 && result.data?.assets) {
                this.referenceAssetUrlVersion = Date.now();
                this.workspaceAssets = [...result.data.assets, ...this.workspaceAssets.filter((a: any) => !result.data.assets.find((n: any) => n.id === a.id))];
                if (category in this.assetSlotEmpty) {
                    this.assetSlotEmpty = { ...this.assetSlotEmpty, [category]: false };
                    await this.saveAssetSlotSettings();
                }
            }
        } catch (e) {
            console.error(e);
        }

        this.assetUploading = false;
        await this.service.render();
    }

    public async deleteAsset(asset: any) {
        try {
            await wiz.call('delete_reference_asset', { notice_no: this.notice_no, asset_id: asset.id });
            this.workspaceAssets = this.workspaceAssets.filter((a: any) => a.id !== asset.id);
        } catch (e) {
            console.error(e);
        }
        await this.service.render();
    }

    public formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    // ── Real Codex ──

    public get selectedCodexWorkflowStep(): any {
        return this.codexWorkflowSteps.find((step: any) => step.id === this.codexWorkflowStage) || this.codexWorkflowSteps[0];
    }

    public get completedCodexWorkflowCount(): number {
        return this.codexWorkflowSteps.filter((step: any) => this.codexWorkflowStageStatus(step.id) === 'done').length;
    }

    public get codexWorkflowProgressPercent(): number {
        if (!this.codexWorkflowSteps.length) return 0;
        return Math.round((this.completedCodexWorkflowCount / this.codexWorkflowSteps.length) * 100);
    }

    public get hasCompletedProposalDesign(): boolean {
        return this.codexWorkflowStageStatus('proposal_design') === 'done';
    }

    public get canStartCodexRequest(): boolean {
        let message = (this.codexInput || '').trim() || this.codexWorkflowDefaultMessage();
        return !!message && !this.codexLoading && !(this.codexStatus && !this.codexStatus.authenticated);
    }

    private codexWorkflowDefaultMessage(): string {
        return (this.selectedCodexWorkflowStep?.defaultPrompt || '').trim();
    }

    private codexWorkflowStageJobs(stageId: string): any[] {
        return (this.codexJobs || []).filter((job: any) => (job.workflow_stage || 'ad_hoc') === stageId);
    }

    public codexWorkflowStageStatus(stageId: string): string {
        const jobs = this.codexWorkflowStageJobs(stageId);
        if (jobs.some((job: any) => job.status === 'running' || job.status === 'queued')) return 'running';
        if (jobs.some((job: any) => job.status === 'done')) return 'done';
        if (jobs.some((job: any) => job.status === 'error')) return 'error';
        if (jobs.some((job: any) => job.status === 'cancelled')) return 'cancelled';
        return 'pending';
    }

    public codexWorkflowStageStatusLabel(stageId: string): string {
        switch (this.codexWorkflowStageStatus(stageId)) {
            case 'done': return '완료';
            case 'running': return '진행 중';
            case 'error': return '오류';
            case 'cancelled': return '중단';
            default: return '대기';
        }
    }

    public codexJobStageLabel(job: any): string {
        const stageId = job?.workflow_stage || 'ad_hoc';
        const stage = this.codexWorkflowSteps.find((step: any) => step.id === stageId);
        return job?.workflow_stage_label || stage?.shortLabel || stage?.label || '일반';
    }

    public async setCodexWorkflowStage(stageId: string) {
        if (!this.codexWorkflowSteps.some((step: any) => step.id === stageId)) return;
        const targetStep = this.codexWorkflowSteps.find((step: any) => step.id === stageId);
        if (targetStep?.requiresDesign && !this.hasCompletedProposalDesign) {
            await this.service.modal.show({
                title: '디자인 분석 필요',
                message: '먼저 RFP 기반 디자인 분석을 완료한 뒤 목차 설계를 진행해 주세요.',
                cancel: false,
                action: '확인',
            });
            return;
        }
        this.codexWorkflowStage = stageId;
        if (stageId === 'proposal_design') {
            this.codexContextOptions.include_proposal_context = false;
            this.codexContextOptions.include_html_rules = true;
        } else if (stageId === 'toc_design') {
            this.codexContextOptions.include_proposal_context = false;
            this.codexContextOptions.include_html_rules = false;
        } else {
            this.codexContextOptions.include_proposal_context = true;
            this.codexContextOptions.include_html_rules = true;
        }
        if (!(this.codexInput || '').trim()) {
            this.applyCodexWorkflowTemplate(false);
        }
        await this.service.render();
    }

    public async moveToTocDesign() {
        await this.setCodexWorkflowStage('toc_design');
    }

    public applyCodexWorkflowTemplate(force: boolean = true) {
        if (!force && (this.codexInput || '').trim()) return;
        this.codexInput = this.codexWorkflowDefaultMessage();
        void this.service.render();
    }

    public get selectedCodexJob(): any {
        if (!this.codexJobs.length) return null;
        return this.codexJobs.find((job: any) => job.id === this.selectedCodexJobId) || this.codexJobs[0];
    }

    public get hasRunningCodexJob(): boolean {
        return this.codexJobs.some((job: any) => job.status === 'running' || job.status === 'queued');
    }

    public get codexUsagePercent(): number {
        return Math.min(Math.max(Number(this.codexUsageSummary?.percent || 0), 0), 100);
    }

    public get codexUsageLevelLabel(): string {
        const percent = Number(this.codexUsageSummary?.percent || 0);
        if (percent >= 100) return '한도 초과';
        if (percent >= 90) return '90% 이상';
        if (percent >= 70) return '70% 이상';
        return '정상';
    }

    public formatCredit(value: any): string {
        const n = Number(value || 0);
        if (n >= 100) return n.toFixed(1);
        if (n >= 10) return n.toFixed(2);
        return n.toFixed(3);
    }

    public async loadCodexStatus(render: boolean = true) {
        try {
            let res = await wiz.call('codex_status');
            if (res.code === 200) this.codexStatus = res.data;
        } catch (e) {
            console.error('codex status error', e);
        }
        if (render) await this.service.render();
    }

    public async loadCodexJobs(render: boolean = true) {
        if (!this.notice_no) return;
        try {
            let res = await wiz.call('codex_list_jobs', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.codexJobs = res.data.jobs || [];
                if (!this.selectedCodexJobId && this.codexJobs.length > 0) {
                    this.selectedCodexJobId = this.codexJobs[0].id;
                }
                let running = this.codexJobs.find((job: any) => job.status === 'running' || job.status === 'queued');
                if (running) this.startCodexPolling(running.id);
            }
        } catch (e) {
            console.error('codex jobs error', e);
        }
        if (render) await this.service.render();
    }

    public async loadCodexUsageSummary(render: boolean = true) {
        this.codexUsageLoading = true;
        try {
            let res = await wiz.call('codex_usage_summary');
            if (res.code === 200) {
                this.codexUsageSummary = res.data.usage || null;
            }
        } catch (e) {
            console.error('codex usage summary error', e);
        }
        this.codexUsageLoading = false;
        if (render) await this.service.render();
    }

    public selectCodexJob(job: any) {
        if (!job?.id) return;
        this.selectedCodexJobId = job.id;
        if (job.workflow_stage && this.codexWorkflowSteps.some((step: any) => step.id === job.workflow_stage)) {
            this.codexWorkflowStage = job.workflow_stage;
        }
        void this.refreshCodexJob(job.id, true);
    }

    public onCodexFileChange(event: any) {
        let files: File[] = Array.from(event.target.files || []);
        event.target.value = '';
        if (!files.length) return;
        this.codexFiles = [...this.codexFiles, ...files].slice(0, 4);
        void this.service.render();
    }

    public removeCodexFile(index: number) {
        this.codexFiles.splice(index, 1);
        void this.service.render();
    }

    public async attachCurrentPageCaptureForCodex() {
        if (!this.notice_no || this.codexPageCaptureLoading) return;
        const pageNo = Math.max((this.currentPageIdx || 0) + 1, 1);
        this.codexPageCaptureLoading = true;
        await this.service.render();
        try {
            const res = await wiz.call('capture_proposal_page', {
                notice_no: this.notice_no,
                page: String(pageNo),
            });
            if (res.code === 200) {
                this.codexPageCapturePath = res.data?.path || '';
                this.codexPageCapturePage = res.data?.page || pageNo;
                const note = `현재 보고 있는 제안서 ${this.codexPageCapturePage}페이지 캡처를 함께 첨부했습니다.`;
                this.codexExtraContext = [this.codexExtraContext || '', note].filter((x: string) => !!x.trim()).join('\n');
            } else {
                await this.service.modal.show({
                    title: '페이지 캡처 실패',
                    message: res.data?.message || '현재 페이지를 캡처하지 못했습니다.',
                    cancel: false,
                    action: '확인',
                    actionBtn: 'error',
                    status: 'error',
                });
            }
        } catch (e: any) {
            await this.service.modal.show({
                title: '페이지 캡처 실패',
                message: e?.message || '현재 페이지를 캡처하지 못했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'error',
                status: 'error',
            });
        }
        this.codexPageCaptureLoading = false;
        await this.service.render();
    }

    public clearCodexPageCapture() {
        this.codexPageCapturePath = '';
        this.codexPageCapturePage = 0;
        void this.service.render();
    }

    public async requestCodexForSection(section: any) {
        if (!section) return;
        this.resultTab = 'codex';
        this.activeSectionNo = section.section_no;
        this.codexWorkflowStage = 'proposal_design';
        this.codexInput = `${section.section_no}. ${section.title} 섹션을 현재 제안서 프리뷰 기준으로 수정해줘.\n\n요청: `;
        this.codexContextOptions.include_proposal_context = true;
        this.codexContextOptions.include_html_rules = true;
        await this.loadCodexStatus(false);
        await this.loadCodexJobs(false);
        await this.service.render();
    }

    public codexStatusLabel(status: string): string {
        switch (status) {
            case 'done': return '완료';
            case 'running': return '진행';
            case 'queued': return '대기';
            case 'cancelled': return '중단';
            case 'error': return '오류';
            default: return status || '알 수 없음';
        }
    }

    public codexLogIcon(kind: string): string {
        switch (kind) {
            case 'done': return 'fa-check';
            case 'message': return 'fa-message';
            case 'error': return 'fa-triangle-exclamation';
            default: return 'fa-circle';
        }
    }

    public async startCodexRequest() {
        let message = (this.codexInput || '').trim() || this.codexWorkflowDefaultMessage();
        if (!message || this.codexLoading) return;

        this.codexLoading = true;
        await this.service.render();

        try {
            let formData = new FormData();
            formData.append('notice_no', this.notice_no);
            formData.append('message', message);
            formData.append('workflow_stage', this.codexWorkflowStage || 'ad_hoc');
            formData.append('codex_model', this.codexModel || '');
            formData.append('include_proposal_context', this.codexContextOptions.include_proposal_context ? '1' : '0');
            formData.append('include_html_rules', this.codexContextOptions.include_html_rules ? '1' : '0');
            formData.append('extra_context', this.codexExtraContext || '');
            if (this.codexPageCapturePath) {
                formData.append('page_capture_path', this.codexPageCapturePath);
                formData.append('page_capture_page', String(this.codexPageCapturePage || ''));
            }
            for (let file of this.codexFiles) formData.append('file', file);

            let response = await fetch(wiz.url('codex_start'), { method: 'POST', body: formData });
            let result = await response.json();
            if (result.code === 200 && result.data?.job) {
                this.codexInput = '';
                this.codexExtraContext = '';
                this.codexFiles = [];
                this.codexPageCapturePath = '';
                this.codexPageCapturePage = 0;
                this.selectedCodexJobId = result.data.job.id;
                await this.loadCodexJobs(false);
                await this.loadCodexUsageSummary(false);
                this.startCodexPolling(result.data.job.id);
            } else {
                await this.service.modal.show({
                    title: 'Codex 요청 실패',
                    message: result.data?.message || 'Codex 작업을 시작하지 못했습니다.',
                    cancel: false,
                    action: '확인',
                    actionBtn: 'error',
                    status: 'error',
                });
            }
        } catch (e: any) {
            await this.service.modal.show({
                title: 'Codex 요청 실패',
                message: e?.message || 'Codex 작업을 시작하지 못했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'error',
                status: 'error',
            });
        }

        this.codexLoading = false;
        await this.service.render();
    }

    private startCodexPolling(jobId: string) {
        if (!jobId) return;
        this.codexPollingJobId = jobId;
        if (this.codexPollTimer) clearInterval(this.codexPollTimer);
        this.codexPollTimer = setInterval(() => {
            void this.refreshCodexJob(jobId, false);
        }, 3500);
    }

    private stopCodexPolling() {
        if (this.codexPollTimer) {
            clearInterval(this.codexPollTimer);
            this.codexPollTimer = null;
        }
        this.codexPollingJobId = '';
    }

    public async refreshCodexJob(jobId: string = '', render: boolean = true) {
        let targetId = jobId || this.selectedCodexJob?.id || '';
        if (!targetId) return;
        try {
            let res = await wiz.call('codex_job_status', { notice_no: this.notice_no, job_id: targetId });
            if (res.code === 200 && res.data?.job) {
                let job = res.data.job;
                let index = this.codexJobs.findIndex((item: any) => item.id === job.id);
                if (index >= 0) this.codexJobs[index] = job;
                else this.codexJobs.unshift(job);
                if (job.status !== 'running' && job.status !== 'queued' && this.codexPollingJobId === job.id) {
                    this.stopCodexPolling();
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    await this.loadCodexUsageSummary(false);
                }
            }
        } catch (e) {
            console.error('codex job refresh error', e);
        }
        if (render) await this.service.render();
    }

    public async cancelCodexJob(job: any) {
        if (!job?.id || (job.status !== 'running' && job.status !== 'queued')) return;
        let ok = await this.service.modal.show({
            title: 'Codex 작업 중단',
            message: '진행 중인 Codex 작업을 중단할까요?',
            action: '중단',
            actionBtn: 'error',
            status: 'error',
        });
        if (!ok) return;
        let res = await wiz.call('codex_cancel_job', { notice_no: this.notice_no, job_id: job.id });
        if (res.code === 200 && res.data?.job) {
            let index = this.codexJobs.findIndex((item: any) => item.id === job.id);
            if (index >= 0) this.codexJobs[index] = res.data.job;
            this.stopCodexPolling();
        }
        await this.service.render();
    }

    // ── Chat ──

    public initializeChatMessages() {
        this.chatMessages = [];
        this.chatContext = {};
    }

    private getChatPhases(message: string = '') {
        const msg = (message || '').trim();
        const lower = msg.toLowerCase();
        const isTocLayoutRequest = (msg.includes('목차') || lower.includes('toc')) && /(패딩|padding|간격|spacing|여백|줄바꿈|overflow|잘리|하단|아래)/i.test(msg);
        const isSectionEditRequest = !!this.chatSection || /^\d+(?:\.\d+)*\./.test(msg);

        if (isTocLayoutRequest) {
            return [
                { msg: '목차 수정 대상을 확인하고 있습니다...', delay: 0 },
                { msg: '목차 항목 간격과 배치를 점검하고 있습니다...', delay: 2500 },
                { msg: '목차 HTML에 실제 레이아웃 수정을 적용하고 있습니다...', delay: 6000 },
                { msg: '변경 결과를 정리하고 있습니다...', delay: 12000 },
            ];
        }

        if (isSectionEditRequest) {
            return [
                { msg: '수정할 섹션을 확인하고 있습니다...', delay: 0 },
                { msg: '선택한 섹션 문맥을 검토하고 있습니다...', delay: 3000 },
                { msg: '섹션 내용을 실제로 수정하고 있습니다...', delay: 7000 },
                { msg: '변경 결과를 정리하고 있습니다...', delay: 15000 },
            ];
        }

        return [
            { msg: '질문을 분석하고 있습니다...', delay: 0 },
            { msg: '제안서 맥락을 검토하고 있습니다...', delay: 3000 },
            { msg: 'AI가 답변을 작성하고 있습니다...', delay: 7000 },
            { msg: '답변을 정리하고 있습니다...', delay: 15000 },
        ];
    }

    private startChatPhases(message: string = '') {
        const phases = this.getChatPhases(message);
        this.chatPhase = phases[0].msg;
        this.service.render();
        for (let i = 1; i < phases.length; i++) {
            let timer = setTimeout(async () => {
                if (this.chatLoading) {
                    this.chatPhase = phases[i].msg;
                    await this.service.render();
                }
            }, phases[i].delay);
            this.chatPhaseTimer = timer;
        }
    }

    private stopChatPhases() {
        if (this.chatPhaseTimer) {
            clearTimeout(this.chatPhaseTimer);
            this.chatPhaseTimer = null;
        }
        this.chatPhase = '';
    }

    public async sendChat(messageOverride: string = '', textarea?: HTMLTextAreaElement) {
        let rawMessage = messageOverride || this.chatInput || '';
        let msg = rawMessage.trim();
        if (!msg || this.chatLoading) return;

        this.chatMessages.push({
            role: 'user',
            content: msg,
            created: new Date().toLocaleTimeString(),
        });
        this.chatInput = '';
        this.chatSendAfterComposition = false;
        if (textarea) {
            textarea.value = '';
        }
        this.chatLoading = true;
        this.startChatPhases(msg);
        await this.service.render();

        try {
            const usePreview = this.chatApprovalMode && !!this.chatSection;
            let res = await wiz.call(usePreview ? 'proposal_chat_preview' : 'proposal_chat', {
                notice_no: this.notice_no,
                message: msg,
                model: this.currentModel,
                guide_ids: this.selectedGuideIdList.join(','),
                section_id: this.chatSection?.id || '',
                apply_mode: usePreview ? '0' : '1',
                actual_page_count: String(this.actualPageCount || 0),
                chat_context: JSON.stringify(this.chatContext || {}),
            });
            if (res.code === 200) {
                this.chatContext = res.data?.chat_context || this.chatContext || {};
                let pendingSections = res.data.pending_sections || [];
                if (pendingSections.length > 0) {
                    for (let pending of pendingSections) {
                        this.pendingChanges.unshift({
                            id: `${pending.id}-${Date.now()}`,
                            section_id: pending.id,
                            section_no: pending.section_no,
                            title: pending.title,
                            before_content: pending.before_content || '',
                            content: pending.content || '',
                            summary: res.data.reply || '',
                            created: new Date().toLocaleTimeString(),
                        });
                    }
                    this.chatMessages.push({
                        role: 'assistant',
                        content: (res.data.reply || '수정안을 만들었습니다.') + '\n\n> 오른쪽 검토 탭의 변경 승인 큐에서 적용하거나 취소할 수 있습니다.',
                        created: new Date().toLocaleTimeString(),
                    });
                    this.resultTab = 'overview';
                    this.stopChatPhases();
                    this.chatLoading = false;
                    await this.service.render();
                    return;
                }

                // 실제 수정이 수행된 경우 섹션 데이터 갱신
                let updatedSections = res.data.updated_sections || [];
                let updatedDocumentParts = res.data.updated_document_parts || [];
                let refreshDocumentParts = res.data.refresh_document_parts || [];
                let modificationFailed = !!res.data.modification_failed;
                let clarificationNeeded = !!res.data.clarification_needed;
                if (updatedSections.length > 0) {
                    for (let updated of updatedSections) {
                        this.applySectionUpdate(updated.id, updated.content, 'done');
                    }
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    this.loadReviewDashboard(false);

                    let sectionLabels = updatedSections.map((s: any) => `${s.section_no}. ${s.title}`).join(', ');
                    let replyContent = res.data.reply || '';
                    if (replyContent) {
                        replyContent += `\n\n> 미리보기 갱신 완료`;
                    } else {
                        replyContent = `**${sectionLabels}** 실제 변경을 반영했습니다.`;
                    }

                    this.chatMessages.push({
                        role: 'assistant',
                        content: replyContent,
                        created: new Date().toLocaleTimeString(),
                        edited: true,
                    });
                } else if (updatedDocumentParts.length > 0) {
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    this.loadReviewDashboard(false);

                    let partLabelMap: any = {
                        toc: '목차',
                        cover: '표지',
                    };
                    let partLabels = updatedDocumentParts.map((part: string) => partLabelMap[part] || part).join(', ');
                    let replyContent = res.data.reply || '';
                    if (replyContent) {
                        replyContent += `\n\n> 미리보기 갱신 완료`;
                    } else {
                        replyContent = `**${partLabels}** 실제 변경을 반영했습니다.`;
                    }

                    this.chatMessages.push({
                        role: 'assistant',
                        content: replyContent,
                        created: new Date().toLocaleTimeString(),
                        edited: true,
                    });
                } else if (refreshDocumentParts.length > 0) {
                    this.refreshHtmlPreview(false);
                    this.refreshPdfPreview(false);
                    this.chatMessages.push({
                        role: 'assistant',
                        content: res.data.reply || '미리보기를 다시 불러왔습니다.',
                        created: new Date().toLocaleTimeString(),
                    });
                } else if (clarificationNeeded) {
                    this.chatMessages.push({
                        role: 'assistant',
                        content: res.data.reply || '수정 대상을 먼저 확인해야 합니다.',
                        created: new Date().toLocaleTimeString(),
                    });
                } else if (modificationFailed) {
                    this.chatMessages.push({
                        role: 'assistant',
                        content: res.data.reply || '실제 수정 적용에 실패했습니다.',
                        created: new Date().toLocaleTimeString(),
                        error: true,
                    });
                } else {
                    this.chatMessages.push({
                        role: 'assistant',
                        content: res.data.reply,
                        created: new Date().toLocaleTimeString(),
                    });
                }
            } else {
                this.chatMessages.push({
                    role: 'assistant',
                    content: `오류: ${res.data?.message || '응답 실패'}`,
                    error: true,
                    created: new Date().toLocaleTimeString(),
                });
            }
        } catch (e: any) {
            this.chatMessages.push({
                role: 'assistant',
                content: `오류: ${e.message || '알 수 없는 오류'}`,
                error: true,
                created: new Date().toLocaleTimeString(),
            });
        }

        this.stopChatPhases();
        this.chatLoading = false;
        await this.service.render();
    }

    public async runQuickChat(prompt: string) {
        this.chatInput = prompt;
        await this.sendChat();
    }

    public async loadReviewDashboard(render: boolean = true) {
        if (!this.notice_no) return;
        this.reviewLoading = true;
        if (render) await this.service.render();
        try {
            let res = await wiz.call('review_dashboard', { notice_no: this.notice_no });
            if (res.code === 200) {
                this.reviewDashboard = res.data;
            }
        } catch (e) {
            console.error('review dashboard error', e);
        }
        this.reviewLoading = false;
        if (render) await this.service.render();
    }

    public get reviewIssueCounts(): any {
        const issues = this.reviewDashboard?.issues || [];
        return {
            high: issues.filter((item: any) => item.level === 'high').length,
            medium: issues.filter((item: any) => item.level === 'medium').length,
            low: issues.filter((item: any) => item.level === 'low').length,
        };
    }

    public get reviewScoreLabel(): string {
        const score = Number(this.reviewDashboard?.score || 0);
        if (score >= 90) return '제출 점검 양호';
        if (score >= 75) return '보강 후 제출 권장';
        if (score >= 50) return '주요 항목 보강 필요';
        return '제출 전 재검토 필요';
    }

    public get reviewScoreSummary(): string {
        if (!this.reviewDashboard) return '';
        const missing = (this.reviewDashboard.total_requirements || 0) - (this.reviewDashboard.covered_requirements || 0);
        const issueCount = (this.reviewDashboard.issues || []).length;
        if (missing <= 0 && issueCount === 0) return '요구사항과 섹션 품질 경고가 안정적입니다.';
        const parts = [];
        if (missing > 0) parts.push(`요구사항 ${missing}개 보강`);
        if (issueCount > 0) parts.push(`품질 경고 ${issueCount}개`);
        return parts.join(' · ');
    }

    public get reviewScoreReasons(): string[] {
        if (!this.reviewDashboard) return ['점검 데이터를 불러오면 점수 근거가 표시됩니다.'];
        const reasons: string[] = [];
        const emptySections = (this.reviewDashboard.toc_items || []).filter((item: any) => !item.done).length;
        const totalReq = this.reviewDashboard.total_requirements || 0;
        const coveredReq = this.reviewDashboard.covered_requirements || 0;
        const missingReq = Math.max(totalReq - coveredReq, 0);
        if (emptySections > 0) reasons.push(`미작성 섹션 ${emptySections}개가 점수를 낮춥니다.`);
        if (totalReq > 0) reasons.push(`RFP 요구사항 ${coveredReq}/${totalReq}개가 본문에 대응됩니다.`);
        if (missingReq > 0) reasons.push(`누락/보강 요구사항 ${missingReq}개는 우선 반영 대상입니다.`);
        if (!this.reviewDashboard.has_summary) reasons.push('RFP 요약 산출물이 없어 검토 신뢰도가 낮습니다.');
        if (!this.reviewDashboard.has_toc) reasons.push('분석 목차가 없어 목차 근거가 약합니다.');
        if (reasons.length === 0) reasons.push('섹션 작성과 요구사항 대응 상태가 안정적입니다.');
        return reasons.slice(0, 4);
    }

    public get filteredRequirementRows(): any[] {
        const rows = this.reviewDashboard?.requirement_rows || [];
        if (this.reviewRequirementFilter === 'all') return rows.slice(0, 80);
        return rows.filter((row: any) => row.coverage === this.reviewRequirementFilter).slice(0, 80);
    }

    public coverageLabel(value: string): string {
        const map: any = { covered: '대응', weak: '보강', missing: '누락' };
        return map[value] || value || '-';
    }

    public async setReviewRequirementFilter(filter: 'all' | 'missing' | 'weak' | 'covered') {
        this.reviewRequirementFilter = filter;
        await this.service.render();
    }

    public async approvePendingChange(change: any) {
        if (!change?.section_id || !change?.content) return;
        try {
            let res = await wiz.call('save_section', {
                section_id: change.section_id,
                content: change.content,
            });
            if (res.code === 200) {
                this.applySectionUpdate(change.section_id, change.content, 'done');
                this.pendingChanges = this.pendingChanges.filter((item: any) => item.id !== change.id);
                this.refreshHtmlPreview(false);
                this.refreshPdfPreview(false);
                await this.loadReviewDashboard(false);
            }
        } catch (e) {
            console.error(e);
        }
        await this.service.render();
    }

    public async rejectPendingChange(change: any) {
        this.pendingChanges = this.pendingChanges.filter((item: any) => item.id !== change.id);
        await this.service.render();
    }

    public async requestRequirementFix(row: any, event?: Event) {
        if (event) event.stopPropagation();
        const target = this.findSectionByNo(row?.section_no);
        const sectionHint = target ? `${target.section_no}. ${target.title}` : (row?.mapped_section || '가장 적절한 섹션');
        this.resultTab = 'codex';
        this.codexInput = `${row?.req_id || '해당 요구사항'} "${row?.requirement || ''}" 내용을 ${sectionHint}에 평가 대응이 드러나도록 보강해줘.`;
        this.codexContextOptions.include_proposal_context = true;
        this.codexContextOptions.include_html_rules = true;
        await this.loadCodexStatus(false);
        await this.loadCodexJobs(false);
        await this.service.render();
    }

    private findSectionByNo(sectionNo: any): any {
        const wanted = String(sectionNo || '').trim();
        if (!wanted) return null;
        return this.sections.find((section: any) => String(section.section_no || '').trim() === wanted) || null;
    }

    public goAnalysisDetail() {
        if (!this.notice_no) return;
        this.service.href(`/analysis/${this.notice_no}`);
    }

    public getDiffPreview(text: string): string {
        return this.renderMarkdown(this.truncatePlainText(text || '', 500));
    }

    public truncatePlainText(text: string, limit: number = 500): string {
        const plain = String(text || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (plain.length <= limit) return plain;
        return plain.slice(0, limit).trim() + '...';
    }

    public onChatCompositionStart() {
        this.chatComposing = true;
    }

    public onChatCompositionEnd(event: CompositionEvent) {
        this.chatComposing = false;
        let textarea = event.target as HTMLTextAreaElement | null;
        if (!textarea) return;
        this.chatInput = textarea.value;
        if (!this.chatSendAfterComposition) return;
        this.chatSendAfterComposition = false;
        void this.sendChat(textarea.value, textarea);
    }

    public onChatKeydown(event: KeyboardEvent, textarea: HTMLTextAreaElement) {
        if (event.key !== 'Enter' || event.shiftKey) return;

        let composingEvent = event as KeyboardEvent & { keyCode?: number };
        event.preventDefault();

        if (composingEvent.isComposing || composingEvent.keyCode === 229 || this.chatComposing) {
            this.chatSendAfterComposition = true;
            return;
        }

        void this.sendChat(textarea?.value || this.chatInput, textarea);
    }

    // ── Utilities ──

    public renderMarkdown(text: string): string {
        if (!text) return '';
        let normalized = text.replace(/```mermaid\s*([\s\S]*?)```/gi, (_match, code) => {
            let source = (code || '').trim();
            if (!source) return '';
            return `\n<div class="mermaid">${this.escapeHtml(source)}</div>\n`;
        });
        return this.markdownConverter.makeHtml(normalized);
    }

    private escapeHtml(text: string): string {
        return (text || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    private scheduleMermaidRender() {
        if (this.mermaidRenderScheduled) return;
        if (!this.hasPendingMermaidBlocks()) return;
        this.mermaidRenderScheduled = true;
        setTimeout(() => {
            this.mermaidRenderScheduled = false;
            void this.renderMermaidBlocks();
        }, 0);
    }

    private hasPendingMermaidBlocks(): boolean {
        let nodes = Array.from(this.elementRef.nativeElement.querySelectorAll('.proposal-rendered .mermaid')) as HTMLElement[];
        return nodes.some((node: HTMLElement) => node.dataset['mermaidProcessed'] !== 'true' && node.dataset['mermaidProcessed'] !== 'error' && !!(node.textContent || '').trim());
    }

    private async renderMermaidBlocks() {
        if (this.mermaidRenderInProgress) return;
        this.mermaidRenderInProgress = true;

        try {
            let nodes = Array.from(this.elementRef.nativeElement.querySelectorAll('.proposal-rendered .mermaid')) as HTMLElement[];
            for (let node of nodes) {
                if (node.dataset['mermaidProcessed'] === 'true' || node.dataset['mermaidProcessed'] === 'error') continue;

                let source = (node.textContent || '').trim();
                if (!source) continue;

                try {
                    let renderId = `proposal-mermaid-${++this.mermaidSequence}`;
                    let rendered = await mermaid.render(renderId, source);
                    node.innerHTML = rendered.svg;
                    node.dataset['mermaidProcessed'] = 'true';
                    node.classList.add('is-rendered');
                } catch (e) {
                    console.error('mermaid render error', e);
                    node.dataset['mermaidProcessed'] = 'error';
                    node.classList.add('is-error');
                }
            }
        } finally {
            this.mermaidRenderInProgress = false;
        }
    }

    public formatDuration(ms: number): string {
        let sec = Math.floor(ms / 1000);
        if (sec < 60) return `${sec}초`;
        let min = Math.floor(sec / 60);
        sec = sec % 60;
        if (min < 60) return `${min}분 ${sec}초`;
        let hr = Math.floor(min / 60);
        min = min % 60;
        return `${hr}시간 ${min}분`;
    }
}

export default PageProposalDetailComponent;